// @ts-check
/* GENERATED FILE - Edit the source JSON file and run I18n code generation to update */
const L = "en-GB";
const P = new Intl.PluralRules(L);
const O = new Intl.PluralRules(L, { type: "ordinal" });
/**@type{import("./types").Translations}*/
export default {
  apps: {
    admin: {
      common: {
        accept: "Accept",
        apply: "Apply",
        acceptPayment: "Accept",
        addSingle: "Add single employee",
        aed: "AED",
        aiAssistant: "AI Assistant",
        approve: "Approve",
        areYouSure: "Are you sure?",
        back: "Back",
        benefits: "Benefits",
        bulkUpload: "Upload employees details",
        bulkUpdate: "Bulk update",
        cancel: "Cancel",
        changesSavedSuccessfully: "Changes saved successfully",
        clear: "Clear",
        clearAll: "Clear all",
        companies: "Companies",
        company: "Company",
        confirm: "Confirm",
        continue: "Continue",
        copiedToClipboard: "Copied to clipboard",
        create: "Create",
        currencies: { AED: "AED", EUR: "EUR", GBP: "GBP", USD: "USD" },
        data: {
          notFound: (name) => `${name} not found`,
          noResultsFor: (query) => `No results found for \"${query}\"`,
          noRecords: "No records available",
          searchPlaceholder: (name) => `Search ${name}...`,
        },
        dashboard: "Dashboard",
        date: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
        monthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateMonthShort: (d) => `${d.toLocaleString(L, { month: "short" })}`,
        dateInvalid: "Invalid date format",
        dateMax: "Date cannot exceed the maximum allowed date",
        dateRangePicker: "Pick a date range",
        ordinalDayOfMonth: (day) =>
          `${/**@type{Record<string,unknown>}*/ ({ ["one"]: `${day}st of the month`, ["two"]: `${day}nd of the month`, ["few"]: `${day}rd of the month` })[O.select(day)] ?? `${day}th of the month`}`,
        original: "Original",
        defaultRequired: "Required",
        customAttributeRequired: (attributeName) =>
          `Please provide a ${attributeName}`,
        delete: "Delete",
        discard: "Discard",
        dismiss: "Dismiss",
        download: "Download",
        dragAndDrop: "or drag and drop",
        edit: "Edit",
        actions: "Actions",
        email: "Email",
        employee: "Employee",
        employees: "Employees",
        errorGeneric: "An error occurred. Try reloading the page",
        editing: "Editing",
        save: "Save",
        import: "Import",
        export: "Export",
        exportFailed: "Export failed. Please try again.",
        exportExcel: "Excel (XLS)",
        csv: "CSV",
        exportCsv: "Export CSV",
        file: "File",
        fileInvalidType: "Invalid file type",
        fileTooLarge: "File too large",
        fileTooSmall: "File too small",
        filters: "Filters",
        fullName: ({ first, last }) => `${first} ${last}`,
        greet: (name) => `${{ ["null"]: `Hello!` }[name] ?? `Hello, ${name}!`}`,
        helpEmail: "help@aurem.ae",
        hubName: (companyName) => `${companyName} Hub`,
        insert: "Insert",
        insertLink: "Insert link",
        invite: "Invite",
        ipp: "International Pension Plan",
        iUnderstand: "I understand",
        label: "Label",
        linkUrl: "URL",
        loading: "Loading...",
        markAsResolved: "Mark as resolved",
        name: "Name",
        versionHistory: "Show version history",
        needHelp: "Need help?",
        next: "Next",
        no: "No",
        noDocuments: "No documents available",
        noResult: "No results found",
        notNow: "Not now",
        optional: "Optional",
        payments: "Payments",
        percentOfSalary: (p) => `${p}% of salary`,
        recentSearch: "Recent searches",
        reject: "Reject",
        rejectPayment: "Reject",
        remove: "Remove",
        resendCode: "Resend code",
        resendInvitations: "Re-invite",
        review: "Review",
        reviewPayments: "Review payments",
        revert: "Revert",
        roles: "Roles",
        userRoles: "User Roles",
        saveAndClose: "Save & close",
        saveChanges: "Save changes",
        search: "Search",
        seeDetails: "See details",
        select: "Select",
        selected: (count) => `${count.toLocaleString(L, {})} selected`,
        sendInvite: "Invite",
        signOut: "Sign out",
        status: "Status",
        employeeStatus: {
          active: "Active",
          inactive: "Inactive",
          invited: "Invited",
          notInvited: "Not invited",
        },
        submit: "Submit",
        supportEmail: "support@aurem.ae",
        tagline: "Aurem Wealth Savings",
        tooManyFiles: (amount) => `Exceeded file limit (${amount})`,
        type: "Type",
        upload: "Click to upload",
        users: "Users",
        viewAll: "View all",
        voluntary: "Aurem End of Service Benefits Funds",
        Xdays: (count) => `${{ [1]: `1 day` }[count] ?? `${count} days`}`,
        XformatEmployeeCount: (count) =>
          `${{ [1]: `1 employee` }[count] ?? `${count} employees`}`,
        yes: "Yes",
        relativeTime: {
          justNow: "just now",
          now: "now",
          minutesAgo: (minutes) =>
            `${{ [1]: `1 minute ago` }[minutes] ?? `${minutes} minutes ago`}`,
          hoursAgo: (hours) =>
            `${{ [1]: `1 hour ago` }[hours] ?? `${hours} hours ago`}`,
          daysAgo: (days) =>
            `${{ [1]: `1 day ago` }[days] ?? `${days} days ago`}`,
          inMinutes: (minutes) =>
            `${{ [1]: `in 1 minute` }[minutes] ?? `in ${minutes} minutes`}`,
          inHours: (hours) =>
            `${{ [1]: `in 1 hour` }[hours] ?? `in ${hours} hours`}`,
          inDays: (days) => `${{ [1]: `in 1 day` }[days] ?? `in ${days} days`}`,
        },
        view: "view",
        nextStep: "Next step",
        goBack: "Go back",
        stepsCompleted: "steps completed",
        finish: "Finish",
        or: "Or",
        contactSupport: "Contact support",
        responses: (count) =>
          `${{ [0]: `No responses`, [1]: `1 response` }[count] ?? `${count} responses`}`,
        permissionAlert:
          "You need additional permissions to view this content. Contact your administrator to request access.",
        employeeNotFound: "Employee not found",
        submitted: "Submitted",
        pending: "Pending",
        formSubmitted: "Form submitted",
        reset: "Reset",
        applyFilters: "Apply filters",
        saveAndContinue: "Save and continue",
        noResultsFor: (search) => `No results found for ${search}`,
        notFound: "No results found",
        inCompany: (company) => `in ${company}`,
        commaSeparatedValues: "Comma-separated values (.csv)",
        exportWithAi: "Export with AI",
        exportSelectRowsTooltip: "Select one or more rows to export",
        microsoftExcel: "Microsoft Excel (.xlsx)",
        bulkAdjustmentsImportStarted: "Bulk adjustments import started",
        bulkAdjustmentsImportCompleted: "Bulk adjustments import completed",
        bulkAdjustmentsImportFailed: "Bulk adjustments import failed",
        bulkAdjustmentsImportTimeout:
          "Bulk adjustments import is taking longer than expected. Please check back later.",
        bulkAdjustmentsImportBelowZero: ({ employee, category }) =>
          `Import would result in a negative balance for ${employee} in category ${category}.`,
        unverified: "Unverified",
        viewTask: "View task",
        viewWorkflowRun: "View workflow run",
        relatedRecords: {
          title: "Related records",
          marketOrders: "Market orders",
          payments: "Payments",
        },
      },
      globalSearch: {
        idle: {
          title: "Start your search",
          text: "Enter a keyword above to find employees or companies.",
        },
        noResults: {
          title: "No results found",
          text: "Try adjusting your search terms to find what you’re looking for.",
        },
      },
      language: { en: "English", ar: "Arabic" },
      cookie: {
        description:
          "We use cookies to enhance your browsing experience. By continuing to use our site, you agree to our use of cookies.",
      },
      countryCombobox: {
        add: "Add tax reporting information",
        cta: "Go to settings",
        dropdownLabel: "Country of tax residence",
        dropdownLabelOptional: "Country of tax residence (optional)",
        empty: "No results found",
        error:
          "Both country of tax and tax number must be filled or both must be empty",
        inputLabel: "Tax reference number",
        inputLabelOptional: "Tax reference number (optional)",
        select: "Select country",
        noSelection: "No selection",
        title: "Tax reporting",
      },
      healing: {
        date: {
          corrected:
            "The date was automatically updated to the format DD/MM/YYYY. If this is incorrect, please edit and upload the file again.",
        },
        decimal: {
          corrected:
            "The number has been updated to the format of 10000.00 if this is incorrect please edit the file and upload again.",
        },
        employmentStatus: {
          corrected:
            "The employment status has been updated to the required format.",
        },
        gender: {
          corrected: "The gender has been updated to the required format.",
        },
      },
      modal: {
        continue: "Continue",
        description:
          "You are able to navigate away from this page. Any unsaved data will be lost",
        stay: "Stay",
      },
      pagination: { resultsPerPage: "Results per page", to: "to", of: "of" },
      navBar: {
        companies: "Companies",
        controls: "Controls",
        funds: "Insights",
        holdings: "Holdings",
        marketOrders: "Market orders",
        menu: "Menu",
        more: "More",
        tasks: "Tasks",
        payments: "Payments",
        personalSettings: "Personal settings",
        support: "Support",
        requests: "Requests",
        users: "Users",
        internal: "Internal",
        products: "Products",
        forms: "Forms",
        inactiveCurrency:
          "Currency switch is not available at the moment due to technical issues.",
        chatDropdown: { addNewChat: "New chat", history: "History" },
        subNavBar: {
          accessAndRestrictions: "Access and restrictions",
          automations: "Automations",
          fees: "Fees",
          paymentCategories: "Payment categories",
          payments: "Payments",
          setup: "Setup",
          lookAndFeel: "Look and feel",
          contentManagement: "Content management",
          customFields: "Custom fields",
          developer: "Developer",
          internal: "Internal",
          compliance: "Compliance",
          activities: "Activity log",
          branding: "Branding",
          tasks: {
            page: {
              title: "Tasks",
              kyb: "KYB ( Know your Business )",
              kyc: "KYC ( Know your Customer )",
              payments: "Payments",
              ["company-payments"]: "Company payments",
              ["refund-payments"]: "Refund payments",
              ["distribution-payments"]: "Distribution payments",
              ["fee-payments"]: "Fee payments",
              ["market-orders"]: "Market orders",
              ["product-assignment"]: "Subscriptions",
              corrections: "Corrections",
              roles: "Roles",
              description: "Description",
              paymentTasks: "Payment tasks",
              saveChanges: "Save changes",
            },
            description: {
              en: "English",
              ar: "Arabic",
              variablesTooltip:
                "Use this to insert variables into the description",
              variables: "Variables",
            },
            escalation: {
              title: "Escalation",
              escalationInactive: "Escalation inactive",
              escalationAfterDays: (days) => `Escalation after ${days} days`,
              notifyEscalationRecipients:
                "Notify escalation recipient(s) after:",
              numberOfDays: (day) =>
                `${{ [1]: `1 day` }[day] ?? `${day} days`}`,
              enableEscalation: "Enable escalation",
              reminderDays: "Reminder days",
              reminderDaysDescription:
                "Counted from the day the task is created. Days before the escalation send a gentle reminder; days after it send a firm follow-up.",
              dayOfEscalation: "Day of escalation",
              dayNumber: (day) => `Day ${day}`,
              escalatesOn: "Escalates on",
              noReminders: "No reminders selected",
            },
            descriptionVariables: {
              assignee_name: "assignee_name",
              reviewer_name: "reviewer_name",
              escalation_recipient_name: "escalation_recipient_name",
              issue_date: "issue_date",
              due_date: "due_date",
              current_date: "current_date",
              current_year: "current_year",
              unknown: "unknown",
              amount: "amount",
              fund_name: "fund_name",
              benefit_name: "benefit_name",
              employee_name: "employee_name",
            },
            config: {
              openRoles: "Assignee",
              openRolesDescription:
                "Who is assigned a task when the task is open",
              inReviewRoles: "Reviewer",
              inReviewRolesDescription:
                "Who reviews and acts on a task when the task is in review",
              escalation: "Escalation recipient",
              escalationDescription: "Who is notified when a task is escalated",
              readonlyRoles: "Read-only roles",
              readonlyRolesDescription: "Who can only view a task",
              noRoles: "No roles",
            },
            variablesDrawer: {
              title: "Variables",
              description:
                "Click a variable to insert it at the cursor position.",
              searchPlaceholder: "Search variables...",
              names: "Names",
              dates: "Dates",
              emptySearch: "No variables match your search.",
            },
          },
          companySettings: "Company settings",
          emails: "Emails",
          featuresAndProducts: "Products",
          textEditor: "Text editor",
          documents: "Documents",
          passwords: "Passwords",
          workflows: "Workflows",
          data: "Data",
          supportTools: "Support Tools",
          roles: "Roles",
          activity: "Activity",
        },
        dropdownMenu: { addCompany: "Register new company" },
        configTools: {
          sidebar: {
            accessAndRestrictions: "Access & restrictions",
            automations: "Automations",
            configureBrand: "Configure your brand",
            customizeFormFields: "Customize form fields",
            uploadDocuments: "Upload your documents",
            chooseProducts: "Choose your products",
            digitalExperience: "Digital experience",
          },
        },
        insights: "Insights",
        chats: "Chats",
        activity: "Activity",
      },
      notifications: {
        title: "Notifications",
        readAll: "Mark all as read",
        deleteAll: "Delete all",
        empty: "No notifications",
        markAsRead: "Mark as read",
      },
      internalResources: {
        attachmentRunRecord: {
          title: "Attachment runs",
          columns: {
            runId: "Run ID",
            nodeId: "Node ID",
            itemIndex: "Item index",
            entityType: "Entity type",
            entityId: "Entity ID",
            entityDetails: "Entity details",
            fileId: "Attachment ID",
            fileFilename: "File name",
            fileSize: "File size",
            file: "File",
            createdAt: "Created at",
          },
          openFile: "Open file in a new tab",
          filters: { runId: "Run ID", runIdPlaceholder: "Filter by run ID" },
        },
        auditTrail: {
          title: "Audit trail",
          columns: {
            event: "Event",
            resourceType: "Resource",
            resourceId: "Resource ID",
            object: "Snapshot",
            diff: "Diff",
            userId: "User",
            createdAt: "Timestamp",
          },
        },
        chatThread: {
          title: "Chat threads",
          columns: {
            title: "Title",
            description: "Description",
            starred: "Starred",
            messages: "Messages",
            userId: "User",
            createdAt: "Created",
            lastMessageAt: "Last message",
          },
        },
        emailLog: {
          title: "Email logs",
          columns: {
            to: "Recipient",
            subject: "Subject",
            template: "Template",
            from: "From",
            bcc: "BCC",
            body: "Body",
            createdAt: "Sent at",
          },
        },
        employeeInvitation: {
          title: "Employee invitations",
          columns: {
            email: "Email",
            employeeId: "Employee",
            companyId: "Company",
            inviterUserId: "Invited by",
            createdAt: "Created",
          },
        },
        llmAuditLog: {
          title: "LLM audit logs",
          columns: {
            modelName: "Model",
            success: "Status",
            runId: "Run ID",
            nodeId: "Node",
            turnCount: "Turns",
            totalDurationMs: "Duration",
            conversationHistory: "Messages",
            finalOutput: "Output",
            errorMessage: "Error",
            userId: "User",
            createdAt: "Timestamp",
          },
        },
        dataImportJob: {
          title: "Data imports",
          columns: {
            status: "Status",
            handlerKey: "Handler",
            uploadId: "Upload ID",
            progress: "Progress",
            lastError: "Last error",
            finishedAt: "Finished at",
            createdAt: "Started at",
          },
        },
        outboundLog: {
          title: "Outbound logs",
          columns: {
            connector: "Connector",
            status: "Status",
            endpoint: "Endpoint",
            destination: "Destination",
            entityType: "Entity Type",
            entityId: "Entity ID",
            retryCount: "Retries",
            error: "Error",
            data: "Data",
            response: "Response",
            createdAt: "Created at",
          },
        },
        supportToolLog: {
          title: "Support tool logs",
          columns: {
            action: "Action",
            category: "Category",
            user: "User",
            entityType: "Entity Type",
            entityId: "Entity ID",
            inputParams: "Input Params",
            success: "Success",
            errorMessage: "Error",
            createdAt: "Created at",
          },
        },
        workflowRun: {
          title: "Workflow runs",
          columns: {
            id: "Run ID",
            workflowName: "Workflow",
            version: "Version",
            scope: "Scope",
            scopedTo: "Scoped to",
            status: "Status",
            workflowVersionId: "Workflow version",
            lastNode: "Last node",
            createdAt: "Created at",
          },
          filters: { status: "Status", allStatuses: "All statuses" },
          statuses: {
            created: "Created",
            running: "Running",
            pending: "Pending",
            completed: "Completed",
            failed: "Failed",
            exited: "Exited",
          },
          sources: { config: "Ran from workflow config" },
          events: {
            started: "Started",
            pending: "Pending",
            completed: "Completed",
            completedWithErrors: "Completed with errors",
            failed: "Failed",
            skipped: "Skipped",
            exited: "Exited",
          },
          detail: {
            title: "Run details",
            titleWithWorkflow: (workflow) => `Run details - ${workflow}`,
            run: "Run input",
            events: "Events",
            resetNode: "Reset from here",
            resetNodeSubmit: "Reset workflow",
            resetNodeConfirmTitle: "Reset the workflow from this node?",
            resetNodeConfirmDescription: (nodeId) =>
              `This supersedes the events for ${nodeId} and everything after it, then re-runs the workflow from that node. Every downstream node runs again.`,
            resetNodePaymentWarning: (count) =>
              `${{ [1]: `This node already created 1 payment. Re-running it may create a duplicate, and the existing payment is not reversed.` }[count] ?? `This node already created ${count} payments. Re-running it may create duplicates, and the existing payments are not reversed.`}`,
            resetNodeMarketOrderWarning: (count) =>
              `${{ [1]: `This node already created 1 market order. Re-running it may create a duplicate, and the existing order is not reversed.` }[count] ?? `This node already created ${count} market orders. Re-running it may create duplicates, and the existing orders are not reversed.`}`,
            resetNodeConfirmPrompt: (nodeId) => `Type ${nodeId} to confirm`,
            resetNodeSuccess: "Workflow reset from node",
            resetNodeError: "Failed to reset the workflow from this node",
            input: "Node input",
            output: "Node output",
            meta: "Node metadata",
            error: "Error",
            code: "Code",
            refreshEvents: "Refresh events",
            noEvents: "No node events recorded yet.",
            orderNewest: "Newest to oldest",
            orderOldest: "Oldest to newest",
            viewFull: "View full",
            generatedPayments: "Generated payments",
            generatedMarketOrders: "Generated market orders",
            blockedBy: "Blocked by",
            expandAll: "Expand all",
            collapseAll: "Collapse all",
            continueTimer: "Continue now",
            continueTimerConfirmTitle: "Continue this timer now?",
            continueTimerConfirmDescription: (nodeId) =>
              `This skips the remaining wait for ${nodeId} and continues the workflow immediately to the next node.`,
            continueTimerSuccess: "Timer continued",
            continueTimerError: "Failed to continue timer",
            continueRun: "Continue",
            continueRunConfirmTitle: "Continue this run?",
            continueRunConfirmDescription:
              "This re-signals Temporal with the stored run input and executes the workflow from the beginning.",
            continueRunSuccess: "Workflow run continued",
            continueRunError: "Failed to continue workflow run",
            exitRun: "Exit",
            exitRunConfirmTitle: "Exit this run?",
            exitRunConfirmDescription:
              "This marks the run as exited without executing any of its nodes. It cannot be continued afterwards.",
            exitRunSuccess: "Workflow run exited",
            exitRunError: "Failed to exit workflow run",
            viewAttachmentRuns: "View attachment runs",
          },
        },
      },
      pages: {
        benefits: {
          assignEmployees: {
            missingDetails:
              "Some employees have missing details. Ensure that all details are filled to proceed with assigning them to this benefit",
            missingDetailsFor: ({ key, value }) =>
              `${key} is missing for ${{ [1]: `1 employee` }[value] ?? `${value} employees`}`,
          },
          id: {
            employeeFilters: {
              last3Months: "Last 3 months",
              last6Months: "Last 6 months",
              lastMonth: "Last month",
              thisYear: "This year",
            },
          },
        },
        companies: {
          companyId: {
            details: {
              security: {
                page: {
                  addDomain: "Add domain",
                  assertionConsumerServiceUrl: {
                    hint: "Enter this in your IDP’s SAML configuration.",
                    label: "Assertion Consumer Service (ACS) URL",
                  },
                  domain: {
                    edit: "Edit domain",
                    hint: "Enter the the domain you want to verify",
                    label: "Domain",
                    placeholder: "Enter domain",
                    regenerateTxtRecord: "Regenerate TXT record",
                    required: "Domain name is required",
                    verificationFailed:
                      "The domain verification has failed, please try again later",
                    verificationSucceeded: "The domain verification succeeded",
                    verified: "Domain verified",
                    verify: "Verify domain",
                  },
                  domainVerificationHeading: "Domain verification",
                  downloadCertificate: "Download certificate",
                  enable: {
                    description:
                      "Allow invited employees using email addresses with a verified domain to log in via SAML SSO",
                    heading: "Enable SAML SSO",
                  },
                  fileMetadataType: "Metadata XML file upload",
                  fileMetadataTypeSubtitle: "Upload your IdP metadata file",
                  identityProviderUrl: {
                    hint: "Enter the Metadata URL provided by your IDP",
                    label: "Identity Provider Metadata URL",
                    placeholder: "https://",
                    required: "The identity provider URL is a required field",
                    updateSucceeded:
                      "The identity provider URL has been updated.",
                  },
                  instructionsPart1: "Add the following TXT record to DNS for",
                  instructionsPart2: "domain",
                  metadata: {
                    hint: "Use this URL for quicker configuration of your Identity Provider (IdP)",
                    label: "Service Provider (SP) Metadata URL",
                  },
                  metadataFile: {
                    required: "IdP metadata file is a required field",
                    requirements: "XML file (max. 2MB)",
                  },
                  ssoConfigurationDescription:
                    "Configure SAML SSO for your workspace with your Identity Provider (IdP)",
                  ssoConfigurationHeading: "SAML SSO Configuration",
                  ssoHeading: "SAML Single sign-on",
                  urlMetadataType: "URL to metadata XML",
                  urlMetadataTypeSubtitle:
                    "Enter your IdP SAML metadata public URL",
                },
              },
              trading: {
                page: {
                  bankLocation: {
                    label: "Bank country",
                    required: "Bank location is required",
                  },
                  bankName: {
                    label: "Bank name",
                    required: "Bank name is required",
                  },
                  iban: { label: "IBAN", required: "IBAN is required" },
                  success: "Bank details updated",
                  title: "Bank details",
                },
              },
              billingDetails: {
                page: {
                  bankDetails: {
                    title: "Bank details",
                    success: "Bank details updated",
                  },
                  billingInfo: {
                    title: "Billing information",
                    success: "Billing information updated",
                  },
                  bankLocation: {
                    label: "Bank country",
                    required: "Bank country is required",
                  },
                  bankName: {
                    label: "Bank name",
                    required: "Bank name is required",
                  },
                  iban: { label: "IBAN", required: "IBAN is required" },
                  swift: { label: "SWIFT / BIC" },
                  accountName: { label: "Account name" },
                  branchName: { label: "Branch name" },
                  branchAddress: { label: "Branch address" },
                  trn: { label: "TRN (Tax Registration Number)" },
                  billingAddress: { label: "Billing address" },
                },
              },
              verification: {
                page: {
                  completedView: {
                    heading: "Verification completed",
                    subHeading: "Your company has been successfully verified",
                  },
                  approvedDocuments: {
                    title: "Know your Business (KYB)",
                    downloadDocument: "Download document",
                    unknownFile: "Unknown file",
                    tabs: {
                      companyDocuments: "Company documents",
                      signatoryDocuments: "Signatory documents",
                    },
                  },
                  unnamedSignatory: "Unnamed signatory",
                  signatoryNameLabel: "Signatory name",
                  documentFallback: (number) => `Document ${number}`,
                  controls: {
                    compliance: {
                      companyStatus: {
                        backToDashboard: "Back to the dashboard",
                      },
                    },
                  },
                  stepCard: {
                    title: "Start your verification process",
                    stepsCompleted: ({ completed, total }) =>
                      `${completed}/${total} steps completed`,
                    whatYouNeed: "What you'll need",
                    companyDocumentsPrefix: "Company registration documents",
                    signatoryList: "List of all company signatories",
                    signatoryDocumentsPrefix:
                      "Signatory identification documents",
                    startVerification: "Start verification",
                  },
                  stepper: {
                    steps: {
                      start: "Start your verification",
                      companyDocuments: "Upload company documents",
                      signatoryDocuments: "Upload signatory documents",
                    },
                    addSignatory: "Add signatory",
                    documentUploaded: "Document uploaded",
                    documentRemoved: "Document removed",
                    emptySignatories: {
                      title: "No signatories added",
                      description:
                        "Add signatories who can sign on behalf of the company",
                    },
                    validation: {
                      signatoryNameRequired: "Signatory name is required",
                      documentRequired: "Required document must be uploaded",
                    },
                  },
                  uploadAdditionalDocuments: {
                    title: "Upload additional documents",
                  },
                  resubmitCompanyDocuments: {
                    title: "Resubmit company documents",
                  },
                  resubmitSignatoryDocuments: {
                    title: "Resubmit signatory documents",
                  },
                  downloadDocument: "Download document",
                },
              },
              overview: {
                page: {
                  edit: { companyUpdated: "Company data updated" },
                  title: "Company settings",
                  registeredOn: "Registered on",
                  employees: "employees",
                  activeBenefit: "active benefit(s)",
                  companyInformation: {
                    title: "Company information",
                    companyName: {
                      label: "Company name",
                      required: "Please provide a company name",
                    },
                    registeredUnder: {
                      label: "Registered under",
                      required: "Please provide a licensing authority",
                    },
                    tradeLicenseNumber: {
                      label: "Trade license number",
                      required: "Please provide a trade license number",
                    },
                    address: {
                      label: "Address",
                      required: "Please provide a address",
                    },
                  },
                  registeredAddress: {
                    title: "Registered address",
                    address: "Address",
                    emirate: "Emirate",
                    placeholder: "Select emirate",
                    required: "Please provide a company address",
                    options: [
                      { label: "Abu Dhabi", value: "AbuDhabi" },
                      { label: "Ajman", value: "Ajman" },
                      { label: "Dubai", value: "Dubai" },
                      { label: "Fujairah", value: "Fujairah" },
                      { label: "Ras Al Khaimah", value: "RasAlKhaimah" },
                      { label: "Sharjah", value: "Sharjah" },
                      { label: "Umm Al Quwain", value: "UmmAlQuwain" },
                    ],
                  },
                  taxResidence: {
                    title: "Tax residence",
                    country: "Country of tax residence",
                    taxReferenceNumber: "Tax reference number",
                  },
                  new: {
                    companyInfo: "Company Information",
                    registeredAddress: { label: "Registered Address" },
                    additionalDetails: "Additional details",
                    taxResidence: "Tax residence",
                  },
                  details: {
                    tabTitle: {
                      overview: "Overview",
                      security: "Security",
                      verification: "Verification",
                      trading: "Bank details",
                      billingDetails: "Billing details",
                      documents: "Documents",
                      taxInformation: "Tax information",
                      fees: "Fees",
                    },
                  },
                  company: {
                    form: {
                      info: {
                        registeredUnder: {
                          required: "Please select a licensing authority",
                        },
                        name: { required: "Please provide a company name" },
                        tradeLicenseNumber: {
                          required: "Please enter a trade license number",
                        },
                        website: { required: "Please enter a website" },
                        onShore: {
                          inputRequired: "Please enter a valid number",
                        },
                      },
                      address: {
                        address: { required: "Please provide an address" },
                        emirate: { required: "Please select an emirate" },
                      },
                    },
                  },
                },
              },
              fees: {
                overview: {
                  heading: "Overview",
                  totalPaid: "Total fees paid to date",
                  lastPaidOn: (date) => `Last paid on ${date}`,
                  lastUpdated: "Last updated just now",
                  upcomingPayment: "Upcoming payment",
                  dueIn: ({ days, date }) =>
                    `Due in ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `${days} day` })[P.select(days)] ?? `${days} days`} (${date})`,
                },
                yourFees: {
                  heading: "Your fees",
                  feeName: "Participation Fee",
                  feeDescription:
                    "Fee description goes here. Calculated as a percentage of assets for all associated entities",
                  active: "Active",
                  paidYearly: "Paid yearly",
                },
                history: { heading: "Fee history" },
                filters: {
                  pending: "Pending",
                  completed: "Completed",
                  export: "Export",
                  exportReceipts: "Export receipts as .zip",
                  exportInvoices: "Export invoices as .zip",
                },
                table: {
                  columns: {
                    status: "Status",
                    fee: "Fee",
                    totalAmount: "Total amount",
                    dateDue: "Date due",
                    dateCompleted: "Date completed",
                  },
                  status: {
                    pending: "Pending",
                    processed: "Processed",
                    failed: "Failed",
                  },
                  actions: {
                    menu: "Actions",
                    downloadReceipt: "Download receipt",
                    downloadInvoice: "Download invoice",
                    receiptTooltip:
                      "A receipt will be generated once a payment has been made",
                  },
                  empty: {
                    title: "No fees found",
                    text: "Fee records will appear here when payments are processed.",
                  },
                },
              },
            },
            dashboard: {
              overview: {
                page: {
                  actionItems: {
                    actionsThatNeedAttentionAppearHere:
                      "Actions that need attention appear here",
                    tradingAccount: {
                      add: "Fill in your banking details",
                      cta: "Add details",
                    },
                    viewAllPayments: (count) =>
                      `View ${{ [1]: `1 more payment` }[count] ?? `${count} more payments`}`,
                    viewMore: (count) =>
                      `view ${{ [1]: `1 more` }[count] ?? `${count} more`}`,
                    approveAll: "Approve all",
                    employeesWithNewSubscriptions:
                      "Employees with new subscriptions",
                    headingV2: "Action items",
                    inviteAllEmployees: "Invite all employees",
                    inviteAllEmployeesDescription:
                      "This means they will be able to download the app, register, and use the benefits that you have set up for them",
                    inviteByBenefit: "Invite by benefit",
                    inviteByBenefits: {
                      heading: "Invite employees by benefits",
                      type: "Type",
                      uninivtedEmployees: "Uninvited employees",
                    },
                    payNow: "Pay now",
                    pensionPayment: {
                      due: ({ pensionName, daysCount, date }) =>
                        `${pensionName} payment due in ${daysCount} (${date})`,
                      overdue: "Payment is overdue",
                      rejected: (pensionName) =>
                        `Payment rejected for ${pensionName}`,
                      tooltipDue: (date) =>
                        `It's essential that you pay before ${date}. Your company may incur penalties and fines if you don't pay in time.`,
                      tooltipOverdue: (date) =>
                        `Your payment was due on ${date}. Your company may incur penalties and fines if you do not pay now.`,
                    },
                    reviewNow: "Review now",
                    subscriptionDue: ({ daysCount, date }) =>
                      `Subscription payment due in ${daysCount.toLocaleString(L, {})} days (${date})`,
                    uninvitedEmployees: "Employees not invited yet",
                    viewRequests: "View requests",
                    youAreAllCaughtUp: "All caught up! No pending actions yet.",
                    verificationSectionTitle: "Verification",
                    verificationAlert: {
                      title: "Verification required.",
                      description:
                        "Complete your documentation to access all platform features.",
                      buttonText: "Upload documents",
                    },
                    bankDetailsSectionTitle: "Bank Details",
                    taxDetailsSectionTitle: "Tax Details",
                    fatca: {
                      title: "FATCA Tax Information Required",
                      cta: "Complete FATCA Form",
                    },
                    paymentsSectionTitle: "Payments",
                    employeesSectionTitle: "Employees",
                    paymentsOverdue: (count) =>
                      `${{ [1]: `1 payment overdue` }[count] ?? `${count} payments overdue`}`,
                    paymentsUpcoming: (count) =>
                      `${{ [1]: `1 payment pending` }[count] ?? `${count} payments pending`}`,
                    paymentsRejected: (count) =>
                      `${{ [1]: `1 rejected payment` }[count] ?? `${count} rejected payments`}`,
                    paymentPenaltyWarning:
                      "You may incur penalties and fines if you do not pay now.",
                    paymentOverdueByDays: ({ amount, days }) =>
                      `${amount} overdue by ${{ [1]: `1 day` }[days] ?? `${days} days`}`,
                    paymentDueInDays: ({ amount, days }) =>
                      `${amount} due in ${{ [1]: `1 day` }[days] ?? `${days} days`}`,
                    paymentRejectedForBenefit: ({ amount, benefitName }) =>
                      `${amount} rejected for ${benefitName}`,
                    newSubscriptionRequests: (count) =>
                      `${{ [1]: `1 new subscription request` }[count] ?? `${count} new subscription requests`}`,
                    employeesToInvite: (count) =>
                      `${{ [1]: `1 employee to invite` }[count] ?? `${count} employees to invite`}`,
                    employeesNotRegistered: (count) =>
                      `${{ [1]: `1 employee has been added but is not yet registered` }[count] ?? `${count} employees have been added but are not yet registered`}`,
                  },
                  insights: {
                    basicSubscriptions: "Basic subscriptions",
                    heading: "Insights",
                    invitedEmployees: "Invited employees",
                    noDataDescription:
                      "Keep using the platform to see insights about your organisation",
                    onboardingEngagement: "Onboarding engagement",
                    registeredEmployees: "Registered",
                    total: "Total amount (last month)",
                    totalSubscriptions: "Total subscriptions",
                    voluntarySubscription: "Voluntary subscriptions",
                  },
                  verificationStatusCard: {
                    body: {
                      Approved: {
                        cta: "Dismiss",
                        description:
                          "Your company has successfully been verified. You can now access end of service benefits",
                        title: "Verified",
                      },
                      DocumentsInReview: {
                        cta: "View submitted documents",
                        description:
                          "Your documents are being reviewed. We will notify you when the review is complete",
                        title: "In review",
                      },
                      DocumentsRequired: {
                        cta: "Start verification",
                        description:
                          "Start your verification to be able to access end of service benefits",
                        title: "Required",
                      },
                      DocumentsRetry: {
                        cta: "Respond with information",
                        description:
                          "Based on the information provided, we need additional information to verify your business",
                        title: "Revisions requested",
                      },
                      Rejected: { cta: "", description: "", title: "" },
                      SignatoryRequired: {
                        cta: "",
                        description: "",
                        title: "",
                      },
                      WaitingForSignature: {
                        cta: "",
                        description: "",
                        title: "",
                      },
                    },
                    heading: "Verification status",
                  },
                  list: {
                    inviteEmployee: {
                      error: {
                        both: "Company must be both verified and subscribed to perform this action.",
                        clickHereTo: "Click here to",
                        verify: "Verify details",
                        subscribe: "subscribe",
                        unverified:
                          "Company must be verified to perform this action.",
                        unsubscribed:
                          "Company must be subscribed to perform this action.",
                        bankingDetailsRequired:
                          "Company banking details are required for this action.",
                      },
                    },
                  },
                  setupChecklist: {
                    title: "Get started",
                    progressText: ({ completed, total }) =>
                      `${completed}/${total} tasks completed`,
                    verifyBusiness: "Verify your business",
                    verifyBusinessDescription:
                      "Business verification is required before you can process payments or manage financial transactions.",
                    verifyBusinessInProgress:
                      "Business verification is in progress",
                    verifyBusinessInProgressDescription:
                      "Your documents are being reviewed",
                    verifyBusinessRejected: "Business verification rejected",
                    verifyBusinessRejectedDescription:
                      "Documents could not be verified. Contact your administrator for more information.",
                    verifyBusinessRejectedResubmit:
                      "Business verification rejected - resubmission required",
                    verifyBusinessRejectedResubmitDescription:
                      "Documents could not be verified. Please resubmit valid business documentation.",
                    verifyBusinessTooltip:
                      "Additional permissions are needed for this task. Contact your administrator for access.",
                    uploadEmployees: "Upload your employees",
                    setupBenefits: "Set up company benefits",
                    fillTaxReporting: "Fill in company tax reporting details",
                    fillBillingDetails: "Fill in company billing details",
                    inviteAdmins: "Invite admins",
                    doLater: "I'll do this later",
                  },
                  helpCenter: {
                    feelingLost: "Feeling lost?",
                    description:
                      "Explore in-depth articles and frequently asked questions in our help center.",
                  },
                  welcomeDialog: {
                    title: (name) =>
                      `${{ ["null"]: `Welcome!` }[name] ?? `Welcome, ${name}!`}`,
                    description: (platformName) =>
                      `Welcome to ${platformName}. Ready to explore?`,
                    tourButton: "Show me around",
                    imageAlt: "Welcome to the dashboard",
                  },
                  tour: {
                    steps: {
                      first: {
                        title: "Get set up on your new platform",
                        description:
                          "Complete these tasks to unlock the full set of features and launch your benefits.",
                      },
                      personalSettings: {
                        title: "Personal settings",
                        description:
                          "Access your personal settings to update your personal and security details.",
                      },
                      languagePreferences: {
                        title: "Language preferences",
                        description: "Choose your default language.",
                      },
                      search: {
                        title: "Find the information you need",
                        description:
                          "Search the platform for company and employee information easily.",
                      },
                      employees: {
                        title: "Manage your employees",
                        description:
                          "Browse, add or update employee information, status, and benefit assignments all in one place.",
                      },
                      benefits: {
                        title: "Manage your company products",
                        description:
                          "Set up, view, and manage your company's products in real-time.",
                      },
                      payments: {
                        title: "Manage your company payments",
                        description:
                          "View, track and make all of your payments here - with detailed information and insights.",
                      },
                      requests: {
                        title: "Manage requests",
                        description:
                          "Review, approve, and track your employees' requests.",
                      },
                      activity: {
                        title: "View recent activity",
                        description:
                          "View all recent actions and updates within your company account to keep track of important changes.",
                      },
                      settings: {
                        title: "Manage company information",
                        description:
                          "Access and manage your company's key information, including registration details, address, and tax residence, all in one place.",
                      },
                      actionItems: {
                        title: "Complete your action items",
                        description:
                          "Tasks that require your attention and/or action will show here over time.",
                      },
                    },
                    navigation: {
                      back: "Back",
                      next: "Next",
                      finishTour: "Finish tour",
                      stepCounter: ({ currentStep, steps }) =>
                        `${currentStep} of ${steps}`,
                      gotIt: "Got it",
                    },
                  },
                  manageEmployees: "Manage employees",
                  manageBenefits: "Manage benefits",
                  managePayments: "Manage payments",
                  pillars: {
                    employees: {
                      label: "Employees",
                      enrolled: (count) =>
                        `${{ [1]: `1 enrolled` }[count] ?? `${count} enrolled`}`,
                    },
                    contributions: {
                      label: "Upcoming contributions",
                      notScheduled: "No payroll schedule set",
                    },
                    payments: {
                      label: "Overdue payments",
                      daysLate: (count) =>
                        `${{ [1]: `1 day late` }[count] ?? `${count} days late`}`,
                      noneOverdue: "All payments up to date",
                    },
                    holdings: {
                      label: "Holdings",
                      noHoldings: "No holdings yet",
                      noPerformance: "No performance data yet",
                    },
                    vsLastMonth: (d) => `${d} vs last month`,
                    lastUpdatedAt: (time) => `Last update at ${time}`,
                  },
                  latestTasks: {
                    title: "Latest tasks",
                    openCount: (count) =>
                      `${{ [0]: `0 open`, [1]: `1 open` }[count] ?? `${count} open`}`,
                    seeMore: "See more",
                    empty: {
                      title: "Nothing needs your attention",
                      description:
                        "New tasks will show up here as they come in.",
                    },
                  },
                  contributionVolume: {
                    title: "Total subscriptions",
                    ranges: {
                      threeMonths: "3M",
                      sixMonths: "6M",
                      oneYear: "1Y",
                      yearToDate: "YTD",
                    },
                    subtitle: {
                      threeMonths: "Settled over the last 3 months",
                      sixMonths: "Settled over the last 6 months",
                      oneYear: "Settled over the last 12 months",
                      yearToDate: "Settled since the start of the year",
                    },
                    series: {
                      basic: "Basic",
                      additional: "Additional",
                      voluntary: "Voluntary",
                      lumpSum: "Lump sum",
                      other: "Other",
                    },
                    combined: "Combined",
                    lastUpdatedAt: (time) => `Last update at ${time}`,
                    share: (d) =>
                      `${d.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} of total`,
                    empty: {
                      title: "No contributions yet",
                      description:
                        "Contributions appear here once the first payment settles.",
                    },
                  },
                  paymentTracker: {
                    title: "Payment & investment tracker",
                    steps: {
                      created: "Payment created",
                      approval: "In progress of approval",
                      marketOrderExecution: "Market order execution",
                      completed: "Completed",
                    },
                    hints: {
                      created: "Awaiting payment from your company.",
                      approval:
                        "Awaiting sign-off before the money is invested.",
                      marketOrderExecution:
                        "Buying units for your employees. This usually takes 1-2 business days.",
                      completed:
                        "Units have landed in your employees' holdings.",
                    },
                    receipt: "Receipt",
                    empty: {
                      lastSettled: "No payment in progress yet.",
                      noPayments: "No contribution payment has been made yet.",
                    },
                    summary: ({ amount, d }) =>
                      `${amount} · ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                  },
                  feeInvoicing: {
                    title: "Fee & invoicing",
                    allInvoices: "All invoices",
                    tile: {
                      paidOn: (d) =>
                        `Paid · ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      paid: "Paid",
                      dueOn: (d) =>
                        `Due ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      overdueOn: (d) =>
                        `Overdue since ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      outstanding: "Outstanding",
                    },
                    outstanding: {
                      heading: ({ reference, amount, d }) =>
                        `${reference} · ${amount} due ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      overdueHeading: ({ reference, amount, d }) =>
                        `${reference} · ${amount} overdue since ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      invoices: (n) =>
                        `${{ [1]: `1 invoice` }[n] ?? `${n} invoices`}`,
                      payNow: "Pay now",
                    },
                    allPaid: "All invoices paid",
                    allPaidNext: (d) =>
                      `All invoices paid · Next invoice on ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                  },
                  holdingsSummary: {
                    title: "Holdings summary",
                    subtitle:
                      "What your employees hold, by fund and share class",
                    breakdownTitle: "BREAKDOWN BY FUND & SHARE CLASS",
                    splitTitle: "EMPLOYER-LED VS EMPLOYEE-LED",
                    percent: (p) =>
                      `${p.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
                    trend: ({ p, a }) => `${p} · ${a} vs last month`,
                    meta: {
                      employees: (n) =>
                        `${{ [1]: `1 employee` }[n] ?? `${n} employees`}`,
                      funds: (n) => `${{ [1]: `1 fund` }[n] ?? `${n} funds`}`,
                      shareClasses: (n) =>
                        `${{ [1]: `1 share class` }[n] ?? `${n} share classes`}`,
                    },
                    columns: {
                      fund: "Fund / share class",
                      risk: "Risk",
                      units: "Units held",
                      nav: "NAV / unit",
                      marketValue: "Market value",
                      return: "Return (YTD)",
                      employees: "Employees",
                    },
                    units: (u) => `${u} units`,
                    employees: (n) =>
                      `${{ [1]: `1 employee` }[n] ?? `${n} employees`}`,
                    shareClassUnknown: "Share class unavailable",
                    totalRow: "Total portfolio",
                    buckets: {
                      employerLed: "Employer-led (EOSB)",
                      employeeLed: "Employee-led (voluntary)",
                    },
                    bucketShare: (p) =>
                      `${p.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} of total`,
                    bucketContributions: (a) => `Contributions YTD: ${a}`,
                    bucketReturn: (p) => `${p} return`,
                    empty: {
                      title: "Nothing invested yet",
                      description:
                        "Fund holdings appear here once your first contribution has been invested.",
                    },
                    viewPortfolio: "View portfolio",
                    lastUpdatedAt: (time) => `Last update at ${time}`,
                  },
                  employeeOverview: {
                    title: "Employee overview",
                    addEmployee: "Add employee",
                    invite: {
                      action: (count) =>
                        `${{ [1]: `Invite all (1)` }[count] ?? `Invite all (${count})`}`,
                      confirmTitle: "Invite employees",
                      confirmDescription: (count) =>
                        `${{ [1]: `1 employee will receive an invitation to the portal. Anyone already invited gets a reminder.` }[count] ?? `${count} employees will receive an invitation to the portal. Anyone already invited gets a reminder.`}`,
                      started: "Invitations are on their way",
                    },
                    chips: {
                      total: {
                        label: "Total employees",
                        hint: (count) =>
                          `${{ [0]: `No new joiners this month`, [1]: `1 joined this month` }[count] ?? `${count} joined this month`}`,
                      },
                      enrolled: {
                        label: "Enrolled",
                        hint: "Contributing to a benefit",
                      },
                      pendingInvite: {
                        label: "Pending invite",
                        hint: "Invitation not accepted yet",
                      },
                      notInvited: {
                        label: "Not yet invited",
                        hint: "Portal access pending",
                      },
                    },
                    enrollment: {
                      title: "Enrollment by product",
                      portal: {
                        label: "Portal registration",
                        detail: ({ count, total }) =>
                          `${count} registered of ${total} employees`,
                      },
                      eosb: {
                        label: "EOSB",
                        detail: ({ count, total }) =>
                          `${count} enrolled of ${total} employees`,
                      },
                      voluntary: {
                        label: "Voluntary savings",
                        detail: ({ count, total }) =>
                          `${count} contributing of ${total} enrolled`,
                      },
                    },
                    tenure: {
                      title: "Tenure distribution",
                      underOneYear: "< 1 yr",
                      oneToThreeYears: "1-3 yrs",
                      threeToSevenYears: "3-7 yrs",
                      sevenToTenYears: "7-10 yrs",
                      tenYearsOrMore: "10+ yrs",
                      bandCount: ({ count, percent }) =>
                        `${count} (${percent}%)`,
                      average: (d) => `Average tenure: ${d} years`,
                    },
                    lastUpdatedAt: (time) => `Last update at ${time}`,
                  },
                },
              },
              activity: {
                page: {
                  eventLogs: {
                    heading: "Latest activity",
                    viewAll: "View all activity",
                    emptyState:
                      "No activity yet! Activity logs will appear here as you keep using the platform.",
                    errorState:
                      "We couldn't fetch your activity logs at the moment. Refresh the page or check back shortly.",
                  },
                },
              },
            },
            employees: {
              new: {
                page: {
                  create: "Add an employee",
                  error: "Failed to create employee",
                  success: "Successfully created the employee",
                  creating: "Creating...",
                  createEmployee: "Add employee",
                  willAddToBenefits: {
                    back: "Go back",
                    confirm: "Confirm and assign",
                    description: (Name) =>
                      `Based off their employment details, ${Name} will automatically be assigned to the following existing benefit:`,
                    title: (count) =>
                      `${{ [1]: `Assign employee to the benefit` }[count] ?? `Assign employee to the benefits`}`,
                  },
                  form: {
                    details: {
                      heading: "Employment details",
                      subheading: "For things to run smoothly",
                    },
                    personal: {
                      subheading: "Let's start with the basics",
                      heading: "Personal info",
                    },
                    contact: {
                      subheading: "A way to get in touch with them",
                      heading: "Contact",
                    },
                    additionalDetails: { heading: "Additional details" },
                  },
                  avs: "Aurem End of Service Benefits Funds",
                },
              },
              employeeId: {
                benefits: {
                  page: {
                    name: "Benefit name",
                    status: "Status",
                    totalContribution: "Total contribution",
                    type: "Type",
                    title: "Benefits",
                    benefitStatus: { active: "Active", inactive: "Inactive" },
                  },
                },
                products: {
                  page: {
                    name: "Product name",
                    status: "Status",
                    totalContributed: "Total contributed",
                    currentValue: "Current value",
                    monthlyContribution: "Monthly basic contribution",
                    type: "Type",
                    title: "Products",
                    productStatus: { active: "Active", inactive: "Inactive" },
                  },
                  details: {
                    properties: {
                      type: "Type",
                      totalContributed: "Total contributed",
                      currentValue: "Current value",
                      enrolled: "Enrolled",
                      ended: "Ended",
                      monthlyContribution: "Monthly basic contribution",
                    },
                    grid: {
                      date: "Date",
                      contributionMonth: "Contribution month",
                      category: "Category",
                      amount: "Amount",
                      status: "Status",
                      adjusted: "Adjusted",
                    },
                    footer: {
                      totalContributedSettled: "Total contributed (settled)",
                    },
                    noItems: {
                      title: "No contributions yet",
                      text: "Contributions will appear here once payments are made into this benefit.",
                    },
                  },
                },
                beneficiaries: {
                  page: {
                    noNominees: {
                      heading: (employeeName) =>
                        `${employeeName} has chosen to follow Shariah Law.`,
                      message: "No beneficiaries have been nominated.",
                    },
                    nominees: {
                      heading: ({ employeeName, beneficiaryCount }) =>
                        `${employeeName} has chosen to nominate ${{ [1]: `1 beneficiary` }[beneficiaryCount] ?? `${beneficiaryCount.toLocaleString(L, {})} beneficiaries`}.`,
                    },
                    details: {
                      relation: "Relationship to employee",
                      dateOfBirth: "Date of birth",
                      mobileNumber: "Phone number",
                      email: "Personal email (optional)",
                      passportNumber: "Passport no. (optional)",
                      percentAllotted: "Percentage of funds allocated",
                      relationship: {
                        spouse: "Spouse",
                        child: "Child",
                        parent: "Parent",
                        sibling: "Sibling",
                        other: "Other",
                      },
                    },
                    form: {
                      firstName: {
                        label: "First name",
                        placeholder: "First name",
                      },
                      lastName: {
                        label: "Last name",
                        placeholder: "Last name",
                      },
                      relationship: {
                        label: "Relationship to employee",
                        placeholder: "Select relationship",
                      },
                      dateOfBirth: { label: "Date of birth" },
                      phone: {
                        label: "Phone number",
                        placeholder: "Enter phone number",
                      },
                      percentAllocated: {
                        label: "Percentage allocated",
                        placeholder: "Enter percentage allocated",
                      },
                    },
                  },
                },
                personalDetails: {
                  page: {
                    headline: "Employees / Employee Details",
                    navigation: {
                      personalDetails: "Personal details",
                      employmentDetails: "Employment details",
                      benefits: "Benefits",
                      beneficiaries: "Beneficiaries",
                    },
                    benefitsChange: {
                      addedAndRemoved: {
                        added: "Added to new benefits",
                        description: "This employee benefits will update",
                        removed: "Removed from benefits",
                        title:
                          "Added to new benefits, removed from old benefits",
                      },
                      addedOnly: {
                        description:
                          "This employee will be added to the following benefits",
                        title: "Added to new benefits",
                      },
                      noChange: {
                        description:
                          "This employee remains assigned to the existing benefits",
                        title: "No change on benefits",
                      },
                      removedOnly: {
                        description:
                          "This employee will be removed from the following benefits",
                        title: "Removal from benefits",
                      },
                    },
                    changesMayAffectBenefits: {
                      description:
                        "Changing employment details may affect the benefits that the employee is part of as they may fit a different benefit criteria.",
                      title: "Changes may affect the benefits of the employee",
                    },
                    error: "Failed to edit employee",
                    success: "Successfully edited the employee",
                    form: {
                      additionalDetails: { heading: "Additional details" },
                      address: {
                        label: "Address",
                        placeholder: "Enter address",
                      },
                      basicSalary: {
                        error: "Basic salary must be a number",
                        hint: "The base salary on which end of service benefits are calculated",
                        label: "Monthly basic salary",
                        placeholder: "Monthly basic salary",
                        required: "Basic salary is required",
                      },
                      branch: {
                        hint: "",
                        label: "City/branch office (optional)",
                        placeholder: "City/branch office",
                      },
                      contact: { heading: "Contact" },
                      dateOfBirth: {
                        label: "Date of birth",
                        lessThan15Years:
                          "Employee must be at least 15 years old",
                      },
                      department: {
                        hint: "",
                        label: "Department (optional)",
                        placeholder: "Department",
                      },
                      details: { heading: "Employment details" },
                      email: {
                        hint: "This is the email address on which employees will receive the inviation to access the app",
                        label: "Work email",
                        placeholder: "Work email",
                      },
                      nationalId: {
                        label: "Emirates ID",
                        placeholder: "xxx-xxxx-xxxxxxx-x",
                        required: "Emirates ID is required",
                      },
                      employeeIdNumber: {
                        hint: "",
                        label: "Employee ID number (optional)",
                        placeholder: "Employee ID number",
                      },
                      employerID: { label: "Employer ID" },
                      employmentStatus: {
                        label: "Employment status",
                        placeholder: "Select the employment status",
                      },
                      endDate: {
                        hint: "We use this to initiate an off boarding process",
                        label: "End of employment",
                      },
                      firstName: {
                        hint: "Must match their government ID",
                        label: "First name",
                        placeholder: "First name",
                        required: "First name is required",
                      },
                      fullSalary: {
                        error: "Salary must be a number",
                        hint: "The total remuneration at the end of the month including allowances",
                        label: "Monthly salary",
                        placeholder: "Monthly salary in AED",
                        required: "Monthly salary is required",
                      },
                      gender: {
                        label: "Gender",
                        placeholder: "Select the gender",
                      },
                      iban: {
                        hint: "This is the employee's salary account where end of service payments are transferred",
                        label: "IBAN",
                        placeholder: "AE07 0331 2345 6789 0123 456",
                      },
                      jobTitle: {
                        hint: "This makes it easier for you to sort and filter employees later",
                        label: "Job title",
                        placeholder: "Job title",
                      },
                      labourId: {
                        error: "Ministry of Labour ID must be number",
                        hint: "This is the 14 digit personal number on the employees Ministry of Labour ID",
                        label: "Ministry of Labour ID",
                        placeholder: "xxxxxxxxxxxxxx",
                      },
                      lastName: {
                        hint: "Includes all middle and last names",
                        label: "Last name",
                        placeholder: "Last name",
                        required: "Last name is required",
                      },
                      level: {
                        hint: "",
                        label: "Level (optional)",
                        placeholder: "Level",
                      },
                      nationality: {
                        label: "Nationality",
                        placeholder: "Select the nationality",
                      },
                      passport: {
                        label: "Passport number",
                        placeholder: "Enter passport number",
                      },
                      personal: {
                        heading: "Personal details",
                        workEmail: "Work email",
                      },
                      employment: { heading: "Employment details" },
                      phone: {
                        error:
                          "Phone number must include country code and digits only",
                        hint: "Phone number should include country code",
                        label: "Phone number",
                        placeholder: "Enter phone number",
                      },
                      startDate: {
                        hint: "To calculate their end of service benefits entitlement",
                        label: "Start of employment",
                        required: "Start of employment is required",
                      },
                      workPermitExpiryDate: {
                        label: "Work permit expiry date (optional)",
                      },
                      workPermitNumber: {
                        hint: "",
                        label: "Work permit number (optional)",
                        placeholder: "xxxxxxxx",
                      },
                    },
                    employeeStatus: {
                      contract: "Contract",
                      temporary: "Temporary",
                      permenant: "Permanent",
                    },
                    list: {
                      grid: {
                        employeeStatus: {
                          active: "Active",
                          inactive: "Inactive",
                          invited: "Invited",
                          notInvited: "Not invited",
                        },
                        skilledType: "Skilled",
                        unskilledType: "Unskilled",
                        name: "Name",
                        title: "Title",
                        department: "Department",
                        level: "Level",
                        benefits: "Benefits",
                        status: "Status",
                        skill: "Skill",
                        type: "Type",
                        salaryRange: "Salary range",
                        report: "employees report",
                      },
                      headline: "Employees",
                      importInProgress:
                        "We're importing the employees that you have uploaded. Check again in a few minutes to see them here",
                      updateEmployees: "Update employees",
                      updateInProgress:
                        "We're updating the employees. Check again in a few minutes to see the udpates",
                      mohreSync: "Sync employees with MOHRE",
                      addEmployees: "Add employees",
                      noRecords: {
                        noRecordsTitle: "No employees added yet.",
                        noRecordsContent:
                          "Invite employees and start configuring their bespoke benefits.",
                      },
                    },
                    gender: { male: "Male", female: "Female" },
                  },
                },
                page: {
                  exportAllEmployeesDialog: {
                    title: "Update your employee details",
                    step1: {
                      number: "1",
                      title: "Export all employees",
                      action: "Export",
                    },
                    step2: {
                      number: "2",
                      title: "Fill in missing details",
                      description:
                        "In the exported file, update and/or fill in the details that are missing.",
                    },
                    step3: {
                      number: "3",
                      title: "Save and import",
                      description: "Save your file and re-import it here.",
                    },
                  },
                  importCsvFile: "Import file",
                  employeeStatus: {
                    contract: "Contract",
                    temporary: "Temporary",
                    permenant: "Permanent",
                  },
                  form: {
                    fullSalary: {
                      required: "Monthly salary is required",
                      error: "Salary must be a number",
                      label: "Monthly salary",
                      hint: "The total remuneration at the end of the month including allowances",
                      placeholder: "Monthly salary in AED",
                    },
                    labourId: {
                      error: "Ministry of Labour ID must be number",
                      label: "Ministry of Labour ID",
                      hint: "This is the 14 digit personal number on the employees Ministry of Labour ID",
                      placeholder: "xxxxxxxxxxxxxx",
                    },
                    employment: { heading: "Employment details" },
                    workEmail: {
                      label: "Work email",
                      placeholder: "Work email",
                    },
                    employmentStatus: {
                      label: "Employment status",
                      placeholder: "Select the employment status",
                    },
                    workPermitExpiryDate: {
                      label: "Work permit expiry date (optional)",
                    },
                    employeeIdNumber: {
                      label: "Employee ID number (optional)",
                      hint: "",
                      placeholder: "Employee ID number",
                    },
                    jobTitle: {
                      label: "Job title",
                      hint: "This makes it easier for you to sort and filter employees later",
                      placeholder: "Job title",
                    },
                    department: {
                      label: "Department",
                      hint: "",
                      placeholder: "Department",
                    },
                    level: { label: "Level", hint: "", placeholder: "Level" },
                    branch: {
                      label: "City/branch office (optional)",
                      hint: "",
                      placeholder: "City/branch office",
                    },
                    iban: {
                      label: "IBAN",
                      hint: "This is the employee's salary account where end of service payments are transferred",
                      placeholder: "AE07 0331 2345 6789 0123 456",
                    },
                    contact: { heading: "Contact details" },
                    personal: { heading: "Personal details" },
                    addressLine1: {
                      label: "Address",
                      placeholder: "Enter address",
                    },
                    addressLine2: {
                      label: "Address line 2",
                      placeholder: "Enter address line 2",
                    },
                    city: {
                      label: "City/Town",
                      placeholder: "Enter city/town",
                    },
                    state: {
                      label: "State/Province/Region",
                      placeholder: "Enter state/province/region",
                    },
                    postalCode: {
                      label: "Postal code",
                      placeholder: "Enter postal code",
                    },
                    country: {
                      label: "Country",
                      placeholder: "Select the country",
                    },
                    phone: {
                      error:
                        "Phone number must include country code and digits only",
                      label: "Phone number",
                      hint: "Phone number should include country code",
                      placeholder: "Enter phone number",
                    },
                    email: {
                      label: "Work email",
                      hint: "This is the email address on which employees will receive the inviation to access the app",
                      placeholder: "Work email",
                    },
                    address: { label: "Address", placeholder: "Enter address" },
                    startDate: {
                      required: "Start of employment is required",
                      label: "Start of employment",
                      hint: "To calculate their end of service benefits entitlement",
                    },
                    basicSalary: {
                      required: "Basic salary is required",
                      error: "Basic salary must be a number",
                      label: "Monthly basic salary",
                      hint: "The base salary on which end of service benefits are calculated",
                      placeholder: "Monthly basic salary",
                    },
                    endDate: {
                      label: "End of employment",
                      hint: "We use this to initiate an off boarding process",
                    },
                    workPermitNumber: {
                      label: "Work permit number",
                      hint: "",
                      placeholder: "xxxxxxxx",
                    },
                    employerID: { label: "Employer ID" },
                    nationalId: {
                      placeholder: "xxx-xxxx-xxxxxxx-x",
                      label: "Emirates ID",
                    },
                    firstName: {
                      required: "First name is required",
                      label: "First name",
                      hint: "Must match their government ID",
                      placeholder: "First name",
                    },
                    lastName: {
                      required: "Last name is required",
                      label: "Last name",
                      hint: "Includes all middle and last names",
                      placeholder: "Last name",
                    },
                    gender: {
                      label: "Gender",
                      placeholder: "Select the gender",
                    },
                    dateOfBirth: {
                      label: "Date of birth",
                      lessThan15Years: "Employee must be at least 15 years old",
                    },
                    nationality: {
                      label: "Nationality",
                      placeholder: "Select the nationality",
                      required: "Nationality is required",
                    },
                    passport: {
                      label: "Passport number",
                      placeholder: "Enter passport number",
                    },
                    relationship: {
                      label: "Relationship to employee",
                      placeholder: "Select relationship",
                      description:
                        "Select the relationship of the nominee to the employee",
                    },
                    percentAllocated: {
                      label: "Percentage allocated",
                      placeholder: "Enter percentage allocated",
                      description:
                        "Enter the percentage allocated to the nominee",
                    },
                  },
                  changesMayAffectBenefits: {
                    title: "Changes may affect the benefits of the employee",
                    description:
                      "Changing employment details may affect the benefits that the employee is part of as they may fit a different benefit criteria.",
                  },
                  confirmEndDateChange: {
                    title: "Confirm end date change",
                    description:
                      "Changing this employee's end date will affect their benefit calculations and eligibility. Employees with less than one year of service will not receive end of service benefits.",
                    confirmButtonText: "Confirm change",
                  },
                  benefitsChange: {
                    addedAndRemoved: {
                      title: "Added to new benefits, removed from old benefits",
                      description: "This employee benefits will update",
                      added: "Added to new benefits",
                      removed: "Removed from benefits",
                    },
                    addedOnly: {
                      title: "Added to new benefits",
                      description:
                        "This employee will be added to the following benefits",
                    },
                    removedOnly: {
                      title: "Removal from benefits",
                      description:
                        "This employee will be removed from the following benefits",
                    },
                    noChange: {
                      title: "No change on benefits",
                      description:
                        "This employee remains assigned to the existing benefits",
                    },
                  },
                  navigation: {
                    personalDetails: "Personal details",
                    employmentDetails: "Employment details",
                    benefits: "Benefits",
                    products: "Products",
                    beneficiaries: "Beneficiaries",
                  },
                  headline: "Employees / Employee Details",
                  list: {
                    exportAllEmployees: "Edit employees details",
                    grid: {
                      employeeStatus: {
                        active: "Active",
                        inactive: "Inactive",
                        invited: "Invited",
                        notInvited: "Not invited",
                      },
                      skilledType: "Skilled",
                      unskilledType: "Unskilled",
                    },
                  },
                  gender: { male: "Male", female: "Female" },
                  benefitStatus: { active: "Active", inactive: "Inactive" },
                  error: "Failed to edit employee",
                  success: "Successfully edited the employee",
                },
              },
              page: {
                mohreImport: {
                  heading: "Your employees are currently being imported.",
                  description:
                    "This could take a few minutes depending on the number of employees in the company. Please check back shortly.",
                  syncingAlert:
                    "Your employees are syncing. This could take a few minutes depending on the number of employees in the company.",
                },
                list: {
                  editEmployees: "Edit employees details",
                  manageEmployees: "Manage employees",
                  updateEmployeeDetails: "Update employee details",
                  dataEditorBannerText:
                    "Rows with errors will be skipped and won't be created.",
                  sendInvitation: "Send invitations",
                  inviteEmployee: {
                    invitedEmployee: "Employee invited",
                    invitedEmployees:
                      "Only employees with work email were invited",
                  },
                  department: "Department",
                  level: "Level",
                  minSalary: "Minimum salary",
                  maxSalary: "Maximum salary",
                  status: "Status",
                  product: "Product",
                  noProduct: "No product",
                  active: "Active",
                  notStarted: "Not started",
                  former: "Former",
                  invited: "Invited",
                  notInvited: "Not invited",
                  exportAllEmployeesDialog: {
                    title: "Update your employee details",
                    step1: {
                      number: "1",
                      title: "Export all employees",
                      action: "Export",
                    },
                    step2: {
                      number: "2",
                      title: "Fill in missing details",
                      description:
                        "In the exported file, update and/or fill in the details that are missing.",
                    },
                    step3: {
                      number: "3",
                      title: "Save and import",
                      description: "Save your file and re-import it here.",
                    },
                  },
                  importInProgress:
                    "We're importing the employees that you have uploaded. Check again in a few minutes to see them here",
                  employeesUploaded: "All employees have been uploaded",
                  invitationSent: "Invitation sent",
                  invitationsSent: "Invitations sent",
                  skilledType: "Skilled",
                  unskilledType: "Unskilled",
                  table: {
                    status: "Status",
                    skill: "Skill",
                    name: "Name",
                    title: "Title",
                    department: "Department",
                    level: "Level",
                    dateJoined: "Date joined",
                    tenure: "Tenure",
                    benefits: "Benefits",
                    products: "Products",
                    noneAssigned: "None assigned",
                    type: "Type",
                    invite: "Invite",
                    syncEmployeesWithMohre: "Sync employees with MOHRE",
                    mohreSyncStarted:
                      "MOHRE sync started. This may take some time.",
                    emptyState: {
                      noItems: {
                        title: "No employees available",
                        text: "Add employees to make them appear here.",
                      },
                      filtersApplied: {
                        title: "No employees match your filters",
                        text: "Adjust or clear filters to see available employees.",
                      },
                    },
                  },
                },
                bulkBenefitsChange: {
                  addedAndRemoved: {
                    title: "Added to new benefits, removed from old benefits",
                    description: "This employee(s) benefits will update",
                    added: ({ employeesCount, benefitsCount }) =>
                      `${{ [1]: `1 employee` }[employeesCount] ?? `${employeesCount.toLocaleString(L, {})} employees`} added to ${benefitsCount.toLocaleString(L, {})} benefits`,
                    removed: ({ employeesCount, benefitsCount }) =>
                      `${{ [1]: `1 employee` }[employeesCount] ?? `${employeesCount.toLocaleString(L, {})} employees`} removed from ${benefitsCount.toLocaleString(L, {})} benefits`,
                  },
                  addedOnly: {
                    title: "Added to new benefits",
                    description: "Employee(s) will be added to benefits",
                    added: ({ employeesCount, benefitsCount }) =>
                      `${{ [1]: `1 employee` }[employeesCount] ?? `${employeesCount.toLocaleString(L, {})} employees`} added to ${benefitsCount.toLocaleString(L, {})} benefits`,
                  },
                  removedOnly: {
                    title: "Removal from benefits",
                    description: "Employee(s) will be removed from  benefits",
                    removed: ({ employeesCount, benefitsCount }) =>
                      `${{ [1]: `1 employee` }[employeesCount] ?? `${employeesCount.toLocaleString(L, {})} employees`} removed from ${benefitsCount.toLocaleString(L, {})} benefits`,
                  },
                  noChange: {
                    title: "No change on benefits",
                    description:
                      "The employee(s) remains assigned to the existing benefits",
                    current: ({ employeesCount, benefitsCount }) =>
                      `${{ [1]: `1 employee` }[employeesCount] ?? `${employeesCount.toLocaleString(L, {})} employees`} stays with ${benefitsCount.toLocaleString(L, {})} benefits`,
                  },
                },
                tour: {
                  manageEmployees: {
                    title: "Manage your employees",
                    description:
                      "Need to update employee details? Export your employee list as CSV, make your changes, then import it back to sync all updates at once.",
                  },
                },
              },
              export: {
                headers: {
                  id: "ID",
                  nationalId: "Emirates ID",
                  firstName: "First name",
                  lastName: "Last name",
                  gender: "Gender",
                  dateOfBirth: "Date of birth",
                  phoneNumber: "Phone number",
                  address: "Address",
                  nationality: "Nationality",
                  employmentStatus: "Employment status",
                  department: "Department",
                  level: "Level",
                  branch: "Branch",
                  jobTitle: "Job title",
                  passportNumber: "Passport number",
                  iban: "IBAN",
                  workEmail: "Work email",
                  startDate: "Start date",
                  endDate: "End date",
                  contribution: "Contribution",
                  baseSalary: "Base salary",
                  fullSalary: "Full salary",
                },
              },
            },
            activity: {
              header: "Activity log",
              columns: {
                date: "Date",
                type: "Type",
                description: "Description",
              },
              types: {
                company: "Company",
                employees: "Employees",
                verifications: "Verifications",
              },
              actions: {
                viewEmployee: "View employee",
                viewEmployees: "View employees",
                viewVerificationDocuments: "View verification documents",
                viewCompanyInformation: "View company information",
                viewCompanyAdmins: "View company admins",
                viewUsers: "View users",
              },
              emptyState: {
                title: "No activity logs",
                text: "Activity logs will appear here as actions are taken.",
              },
            },
            payments: {
              page: {
                companyPayments: {
                  list: { heading: "Payments" },
                  noRecords: {
                    noRecordsTitle: "No payments to show for now.",
                    noRecordsContent: "Your future payments will show here.",
                  },
                },
                grid: {
                  id: "ID",
                  type: "Type",
                  benefitName: "Benefit name",
                  amount: "Amount",
                  issueDate: "Issue date",
                  dueDate: "Due date",
                  status: "Status",
                  report: "payment report",
                  downloadReport: "Download report",
                  inProgress: "In progress",
                  pastActivity: "Past activity",
                  referenceNumber: "Payment reference",
                  sender: "Sender",
                  recipient: "Recipient",
                },
                status: {
                  overdue: "Overdue",
                  paid: "Paid",
                  paymentMade: "Payment processing",
                  rejected: "Rejected",
                  pending: "Pending",
                  approved: "Approved",
                },
                zipExport: {
                  downloadZip: "Download as Zip",
                  invoices: "Invoices",
                  receipts: "Receipts",
                  invoicesAsZip: "Invoices as .zip",
                  receiptsAsZip: "Receipts as .zip",
                  selectedCount: (count) => `${count} selected`,
                  started: "Preparing zip file...",
                  complete: "Zip file ready",
                  failed: "Failed to create zip file",
                },
              },
            },
            requests: {
              page: {
                companyEmployeeSubscriptionRequests: {
                  list: {
                    approveSubscriptions: "Approve subscriptions",
                    approveOnlySelectedDescription:
                      "Are you sure you want to approve all selected subscriptions? You can’t undo this action afterwards.",
                    approveAllDescription:
                      "Are you sure you want to approve all subscriptions? You can’t undo this action afterwards.",
                    approvedSingle: "The request has been approved",
                    approvedMultiple: "The requests have been approved",
                    status: { pending: "Pending", approved: "Approved" },
                    type: {
                      voluntary: "Voluntary",
                      oneTimePayment: "One time payment",
                    },
                    heading: "Requests",
                    grid: {
                      id: "ID",
                      employee: "Employee",
                      company: "Company",
                      amount: "Amount",
                      dateAdded: "Date added",
                      status: "Status",
                      report: "company-requests-report",
                      pending: "In progress",
                      completed: "Completed",
                      type: "Type",
                    },
                    generate: "Export CSV",
                    approveSelected: "Approve selected",
                  },
                },
                list: {
                  grid: {
                    noRecords: {
                      noRecordsTitle: "Nothing to review for now.",
                      noRecordsContent:
                        "Verification documents that have been submitted or re-submitted will show here.",
                    },
                  },
                },
              },
            },
            products: {
              page: {
                title: "Products",
                noResults: {
                  title: "No results found",
                  description: "No products match your search for ",
                  noProducts:
                    "There are no product instances set up under this category yet.",
                },
                netContributions: "Net contributions",
                activeParticipants: "Active participants",
                employees: "employees",
                emptyTitle: "No products created yet.",
                emptySubtitle:
                  "Create and configure a new product and assign to your employees.",
                createProduct: "Create a new product",
              },
              create: {
                page: {
                  title: "New product",
                  existingSchemes: "Existing schemes",
                  netContributions: "Net contributions",
                },
              },
              productInstanceId: {
                page: {
                  title: "Product setup",
                  backToProducts: "Back to products",
                  sidebar: { title: "Set up your product" },
                  errors: {
                    productInstanceNotFound: "Product instance not found",
                  },
                  steps: {
                    details: {
                      title: "Product details",
                      editProductDetails: "Edit product details",
                      productNameDescription:
                        "Only you and your team will be able to see the name of this product.",
                      productNameTitle: "Product name",
                      productNamePlaceholder: "Untitled product",
                      productNameRequired:
                        "Name is required and must contain at least 1 character",
                      productType: "Product type",
                      activateProduct: "Activate product",
                      activateProductDescription:
                        "Once active, this benefit will allow the processing of payments and run workflows for assigned employees.",
                      nextStep: "Next step",
                      productStatus: "Product status",
                    },
                    configurations: {
                      title: "Product settings",
                      noAttributes:
                        "No custom attributes configured for this product type.",
                      validation: {
                        scheduleRequired: "Schedule configuration is required",
                        fundRequired: "Fund selection is required",
                        invalidEmail: "Invalid email format",
                        fieldRequired: (field) => `${field} is required`,
                        mustBePositive: (field) => `${field} must be positive`,
                        minValue: ({ field, min }) =>
                          `${field} must be at least ${min}`,
                        maxValue: ({ field, max }) =>
                          `${field} must not exceed ${max}`,
                      },
                    },
                    employees: {
                      title: "Assigned employees",
                      description: "Add employees to this scheme",
                      doItLater: "I'll do it later",
                      uaePensionInformation: {
                        title: "Important Information",
                        message:
                          "The EOSB Basic Contribution is separate from the mandatory UAE Pension Scheme. Assigning a UAE National to an EOSB benefit does not replace or affect the employer's obligations under the UAE Pension Scheme.",
                        acknowledge: "OK",
                      },
                      grid: {
                        firstName: "First name",
                        lastName: "Last name",
                        name: "Name",
                        email: "Email",
                        title: "Title",
                        department: "Department",
                        level: "Level",
                        pending: "Pending",
                        passportNumber: "Passport number",
                        dateOfBirth: "Date of birth",
                        gender: "Gender",
                        nationality: "Nationality",
                        arabicName: "Arabic name",
                        unifiedNumber: "Unified number",
                        basicSalary: "Basic salary",
                        fullSalary: "Full salary",
                        dateJoined: "Date joined",
                        tenure: "Tenure",
                        tenureMonthsOnly: (months) =>
                          `${months} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `month` })[P.select(months)] ?? `months`}`,
                        tenureYearsOnly: (years) =>
                          `${years} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `year` })[P.select(years)] ?? `years`}`,
                        tenureYearsAndMonths: ({ years, months }) =>
                          `${years} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `year` })[P.select(years)] ?? `years`} ${months} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `month` })[P.select(months)] ?? `months`}`,
                        missing: "Missing",
                        tabUnassigned: "Unassigned",
                        tabErrors: "Errors",
                        tabAssigned: "Assigned",
                        actionAssign: "Assign",
                        actionUnassign: "Unassign",
                        actionBulkAssign: "Assign",
                        emptyUnassigned:
                          "No active employees have been found that can be assigned to this product. If you wish to assign employees to this product, please make sure to upload them first.",
                        emptyAssigned:
                          "No employees are currently assigned to this product.",
                        emptyError: "No employees with missing information.",
                        missingDetailsWarning:
                          "Some employees have missing details. Ensure that all details are filled to proceed with assigning them to this product.",
                        toastAssignmentInProgress:
                          "Assignment in progress. Check again in a few minutes.",
                        toastCannotAssign: (count) =>
                          `Cannot assign ${count} employee(s) - missing required fields`,
                        toastMovedToErrors: (count) =>
                          `${count} employee(s) moved to Errors tab - missing required fields`,
                        toastErrorAssigning: "Error assigning employees",
                        toastErrorUnassigning: "Error unassigning employees",
                        toastNoProductInstance: "Error: No product instance",
                        filterNoBenefits:
                          "Show only employees without product assignments",
                        filterButton: "Filter",
                      },
                    },
                    confirm: { title: "Confirm all details" },
                  },
                },
              },
            },
            verification: {
              page: {
                verification: {
                  processing: {
                    heading: "Processing verification",
                    description:
                      "Thank you for providing information about your business for verification. Your details are being reviewed and we will notify you once the registration process is complete",
                  },
                  description:
                    "Note: Additional documents may be required to verify your company.",
                  form: {
                    industry: {
                      label: "Industry",
                      placeholder: "Select your industry",
                      industries: {
                        accounting: "Accounting",
                        airlinesAviation: "Airlines/Aviation",
                        alternativeDisputeResolution:
                          "Alternative Dispute Resolution",
                        alternativeMedicine: "Alternative Medicine",
                        animation: "Animation",
                        apparelAndFashion: "Apparel & Fashion",
                        architectureAndPlanning: "Architecture & Planning",
                        artsAndCrafts: "Arts & Crafts",
                        automotive: "Automotive",
                        aviationAndAerospace: "Aviation & Aerospace",
                        banking: "Banking",
                        biotechnology: "Biotechnology",
                        broadcastMedia: "Broadcast Media",
                        buildingMaterials: "Building Materials",
                        businessSuppliesAndEquipment:
                          "Business Supplies & Equipment",
                        capitalMarkets: "Capital Markets",
                        chemicals: "Chemicals",
                        civicAndSocialOrganization:
                          "Civic & Social Organization",
                        civilEngineering: "Civil Engineering",
                        commercialRealEstate: "Commercial Real Estate",
                        computerAndNetworkSecurity:
                          "Computer & Network Security",
                        computerGames: "Computer Games",
                        computerHardware: "Computer Hardware",
                        computerNetworking: "Computer Networking",
                        computerSoftware: "Computer Software",
                        construction: "Construction",
                        consulting: "Consulting",
                        consumerElectronics: "Consumer Electronics",
                        consumerGoods: "Consumer Goods",
                        consumerServices: "Consumer Services",
                        cosmetics: "Cosmetics",
                        dairy: "Dairy",
                        defenseAndSpace: "Defense & Space",
                        design: "Design",
                        educationManagement: "Education Management",
                        eLearning: "E-learning",
                        electricalAndElectronicManufacturing:
                          "Electrical & Electronic Manufacturing",
                        entertainment: "Entertainment",
                        environmentalServices: "Environmental Services",
                        eventsServices: "Events Services",
                        executiveOffice: "Executive Office",
                        facilitiesServices: "Facilities Services",
                        farming: "Farming",
                        financialServices: "Financial Services",
                        fineArt: "Fine Art",
                        fishery: "Fishery",
                        foodAndBeverages: "Food & Beverages",
                        foodProduction: "Food Production",
                        fundraising: "Fundraising",
                        furniture: "Furniture",
                        gamblingAndCasinos: "Gambling & Casinos",
                        glassCeramicsAndConcrete: "Glass, Ceramics & Concrete",
                        governmentAdministration: "Government Administration",
                        governmentRelations: "Government Relations",
                        graphicDesign: "Graphic Design",
                        healthWellnessAndFitness: "Health, Wellness & Fitness",
                        higherEducation: "Higher Education",
                        hospitalAndHealthCare: "Hospital & Health Care",
                        hospitality: "Hospitality",
                        humanResources: "Human Resources",
                        importAndExport: "Import & Export",
                        individualAndFamilyServices:
                          "Individual & Family Services",
                        industrialAutomation: "Industrial Automation",
                        informationServices: "Information Services",
                        informationTechnologyAndServices:
                          "Information Technology & Services",
                        insurance: "Insurance",
                        internationalAffairs: "International Affairs",
                        internationalTradeAndDevelopment:
                          "International Trade & Development",
                        internet: "Internet",
                        investmentBankingVenture: "Investment Banking/Venture",
                        investmentManagement: "Investment Management",
                        judiciary: "Judiciary",
                        lawEnforcement: "Law Enforcement",
                        lawPractice: "Law Practice",
                        legalServices: "Legal Services",
                        legislativeOffice: "Legislative Office",
                        leisureAndTravel: "Leisure & Travel",
                        libraries: "Libraries",
                        logisticsAndSupplyChain: "Logistics & Supply Chain",
                        luxuryGoodsAndJewelry: "Luxury Goods & Jewelry",
                        machinery: "Machinery",
                        managementConsulting: "Management Consulting",
                        maritime: "Maritime",
                        marketingAndAdvertising: "Marketing & Advertising",
                        marketResearch: "Market Research",
                        mechanicalOrIndustrialEngineering:
                          "Mechanical or Industrial Engineering",
                        mediaProduction: "Media Production",
                        medicalDevice: "Medical Device",
                        medicalPractice: "Medical Practice",
                        mentalHealthCare: "Mental Health Care",
                        military: "Military",
                        miningAndMetals: "Mining & Metals",
                        motionPicturesAndFilm: "Motion Pictures & Film",
                        museumsAndInstitutions: "Museums & Institutions",
                        music: "Music",
                        nanotechnology: "Nanotechnology",
                        newspapers: "Newspapers",
                        nonprofitOrganizationManagement:
                          "Nonprofit Organization Management",
                        oilAndEnergy: "Oil & Energy",
                        onlinePublishing: "Online Publishing",
                        outsourcingOffshoring: "Outsourcing/Offshoring",
                        packageFreightDelivery: "Package/Freight Delivery",
                        packagingAndContainers: "Packaging & Containers",
                        paperAndForestProducts: "Paper & Forest Products",
                        performingArts: "Performing Arts",
                        pharmaceuticals: "Pharmaceuticals",
                        philanthropy: "Philanthropy",
                        photography: "Photography",
                        plastics: "Plastics",
                        politicalOrganization: "Political Organization",
                        primarySecondary: "Primary/Secondary",
                        printing: "Printing",
                        professionalTraining: "Professional Training",
                        programDevelopment: "Program Development",
                        publicPolicy: "Public Policy",
                        publicRelations: "Public Relations",
                        publicSafety: "Public Safety",
                        publishing: "Publishing",
                        railroadManufacture: "Railroad Manufacture",
                        ranching: "Ranching",
                        realEstate: "Real Estate",
                        recreational: "Recreational",
                        facilitiesAndServices: "Facilities & Services",
                        religiousInstitutions: "Religious Institutions",
                        renewablesAndEnvironment: "Renewables & Environment",
                        research: "Research",
                        restaurants: "Restaurants",
                        retail: "Retail",
                        securityAndInvestigations: "Security & Investigations",
                        semiconductors: "Semiconductors",
                        shipbuilding: "Shipbuilding",
                        sportingGoods: "Sporting Goods",
                        sports: "Sports",
                        staffingAndRecruiting: "Staffing & Recruiting",
                        supermarkets: "Supermarkets",
                        telecommunications: "Telecommunications",
                        textiles: "Textiles",
                        thinkTanks: "Think Tanks",
                        tobacco: "Tobacco",
                        translationAndLocalization:
                          "Translation & Localization",
                        transportationTruckingRailroad:
                          "Transportation/Trucking/Railroad",
                        utilities: "Utilities",
                        ventureCapital: "Venture Capital",
                        veterinary: "Veterinary",
                        warehousing: "Warehousing",
                        wholesale: "Wholesale",
                        wineAndSpirits: "Wine & Spirits",
                        wireless: "Wireless",
                        writingAndEditing: "Writing & Editing",
                      },
                      required: "Please select an industry",
                    },
                    articlesOfAssociation: {
                      label: "Articles of Association",
                      hint: "This must include signatures of the Ultimate Beneficiary Owners (UBOs) and their details.",
                    },
                  },
                  requiresResubmission: "Requires resubmission",
                  fileType: "PDF, JPG or DOCS (max. 5 MB)",
                  formHeading: {
                    documentsRequired: "Upload documents",
                    documentsInReview: "Uploaded documents",
                    documentsRetry: "Additional documents required",
                  },
                },
                detailsApprovalModal: {
                  companyAndOwnership: {
                    defaultOptions: [
                      "Valid Trade License",
                      "Articles of Association",
                      "Memorandum of Association",
                      "Structure chart (Signed and dated)",
                      "Register of Directors",
                      "Register of Members",
                      "Last Audited Financial",
                      "Business Registration",
                      "Proof of operating address in UAE",
                    ],
                  },
                },
                documentsUpload: {
                  upload: {
                    successMessage: "Document uploaded",
                    removeMessage: "Document removed",
                  },
                },
                verificationStatusCard: { heading: "Verification status" },
              },
            },
            benefitPayments: {
              benefitPaymentId: {
                page: {
                  companyPayments: {
                    id: {
                      grid: {
                        name: "Employee name",
                        benefit: "Benefit",
                        fromCompany: "From company",
                        fromEmployee: "From employee",
                        finalSalary: "Final salary",
                        total: "Total due",
                      },
                      receipt: "Receipt",
                      downloadReceipts: "Download receipts",
                      title: "Payment details",
                      paymentRejectedOn: "Your payment was rejected on",
                      manage: "Manage",
                      adjustment: "Adjustment",
                      paymentInvoice: "Payment invoice",
                      paymentReceipt: "Payment receipt",
                      addAdjustment: "Add adjustment",
                      singleAdjustment: "Add single adjustment",
                      bulkAdjustment: "Bulk import adjustments",
                      reasonForAdjustment: "Reason for adjustment",
                      changedBy: "Changed by",
                      on: "on",
                      deleteTitle: "Delete this adjustment",
                      deleteWarning:
                        "Are you sure you want to delete this adjustment? This action cannot be undone.",
                      deleteSuccess: "Adjustment deleted successfully",
                      adjustmentsModal: {
                        title: "Edit amount",
                        currentAmount: "Current amount",
                        employee: "Employee",
                        employeePlaceholder: "Search employee",
                        paymentCategory: "Payment category",
                        paymentCategoryPlaceholder: "Choose payment category",
                        adjustmentType: "Adjustment type",
                        positive: "Positive",
                        negative: "Negative",
                        newAmount: "Enter new amount",
                        newAmountDescription: "The amount cannot go below 0.",
                        reason: "Add a reason for this change",
                        reasonPlaceholder: "Choose a reason",
                        otherReason: "Please specify the reason",
                        addAdjustment: "Add adjustment",
                        editAdjustment: "Edit amount",
                        cancel: "Cancel",
                        success: "Adjustment added successfully",
                        error: "Failed to add adjustment",
                        requiredFields: {
                          employee: "Employee is required",
                          paymentCategory: "Payment category is required",
                          adjustmentType: "Adjustment type is required",
                          newAmount: "New amount is required",
                          reason: "Reason is required",
                          otherReason: "Other reason is required",
                          negativeAmountBelowZero:
                            "Adjustment would reduce the amount below 0",
                        },
                        adjustmentReasons: {
                          overpayment: "Overpayment",
                          underpayment: "Underpayment",
                          creditFee: "Credit fee",
                          debitFee: "Debit fee",
                          otherReason: "Other reason",
                        },
                      },
                    },
                  },
                  grid: {
                    rejectPayment: "Reject payment",
                    confirmPayment: "Confirm payment",
                    approver: "Approver",
                    amount: "Amount",
                    companyName: "Company name",
                    benefitName: "Benefit name",
                    referenceNumbers: "Reference numbers",
                    createdOn: "Created on",
                    rejectPaymentModal: {
                      paymentNotFound: "The payment was not found",
                      paymentNotFullAmount:
                        "The payment was less than the required amount",
                    },
                  },
                  status: { overdue: "Overdue" },
                },
              },
            },
          },
          page: {
            list: {
              addCompany: "Register new company",
              companies: "Companies",
              grid: {
                createdOn: "Created on",
                noRecords: {
                  noRecordsTitle: "No companies registered yet",
                  noRecordsContent:
                    "This is where you’ll be able to track, manage and add new companies,",
                },
                name: "Company name",
              },
              dataEditor: {
                title: "Companies",
                openButton: "Data Editor",
                updateSuccess: "Company details updated successfully",
                updatePartialFailure: ({ failed, total }) =>
                  `${failed} of ${total} companies failed to update`,
                mohreLocked:
                  "This company is regulated by MOHRE and its details cannot be edited here.",
                columns: {
                  name: "Company name",
                  registeredNumber: "Trade license number",
                  registeredAddress: "Registered address",
                  registeredUnder: "Registered under",
                  verificationStatus: "Verification status",
                  employeesCount: "Number of employees",
                  createdAt: "Created on",
                  updatedAt: "Updated on",
                },
                updateInProgress:
                  "We're updating the companies you've edited. This might take a moment.",
                updateResult: ({ updated, total }) =>
                  `${updated} of ${total} companies updated successfully`,
              },
            },
            skipStep: "I'll do this later",
          },
          new: {
            page: {
              company: {
                syncWithMohre: "Sync with MOHRE",
                fillDetailsManually: "Fill details manually",
                registerCompany: "Register company",
                registerACompany: "Register a company",
                howIsCompanyRegistered: "How is the company registered?",
                pickATypeToContinue: "Pick a type to continue.",
                mohreCompany:
                  "Ministry of Human Resources & Emiratisation company",
                mohreCompanyDescription:
                  "Registered under the UAE Ministry of Human Resources & Emiratisation.",
                syncAvailable: "Sync available",
                nonMohreCompany: "Free Zone & Offshore company",
                nonMohreCompanyDescription:
                  "Free zone, offshore, or any entity outside MOHRE.",
                whatsTheDifference: "What's the difference?",
                form: {
                  info: {
                    name: {
                      label: "Company name",
                      required: "Please provide a company name",
                    },
                    website: {
                      label: "Company website",
                      required: "Please provide a company website",
                    },
                    address: {
                      label: "Address",
                      required: "Please provide a company address",
                    },
                    registeredNumber: {
                      label: "Trade license number",
                      required: "Please provide a company trade license number",
                    },
                    industry: {
                      label: "Industry",
                      required: "Please provide a company industry",
                      placeholder: "Select industry",
                      list: {
                        technology: "Technology",
                        healthcare: "Healthcare",
                        finance: "Finance",
                        education: "Education",
                      },
                    },
                    onShore: {
                      companyNotFound:
                        "We can’t seem to find your details. Check if you’ve entered your ID correctly and make sure you’re enrolled on the savings scheme with MOHRE",
                    },
                  },
                  acknowledgment: {
                    label: (citizenships) =>
                      `The employer understands, acknowledges and agrees that (i) the Fund is not eligible for employees with certain citizenships (${citizenships}), (ii) it may not register any of its employees with blocked citizenships, and (iii) it must immediately inform the Fund Manager and the Fund Administrator should it come to its knowledge that an employee is, or has acquired, a blocked citizenship.`,
                    required: "You must acknowledge the terms to proceed",
                  },
                },
                mohreOtpDescription:
                  "If you are authorised to register companies via MOHRE, you will be sent a five digit code via SMS.",
                mohreOtpDuration: "This code will be valid for 5 minutes.",
                mohreRetrievingCompanies:
                  "We're retrieving the companies assigned to you.",
                mohreWillRedirect:
                  "We'll redirect you to the next step shortly.",
                searchForCompanies: "Search for companies",
                empty: { title: "No companies match your search" },
                updateCompany: "Update company",
                companyUpdated: "Company updated",
                mohreCodeResentSuccessfully:
                  "The code has been resent successfully",
                mohreVerifying: "We're verifying your details.",
                mohreWillSendOtp:
                  "We'll send you a verification code in just a moment.",
                mohreRetrievingCompany:
                  "We're retrieving your company details.",
                mohreForm: {
                  info: {
                    eidaOrUid: {
                      required: "Please provide your company's UID or EIDA",
                    },
                    eida: {
                      label: "Emirates ID Authority (EIDA)",
                      description:
                        "An EIDA is 15 digits long (e.g. 784-1997-1234567-1).",
                      required: "The EIDA must be 15 digits long",
                    },
                    uid: {
                      label: "Unified Identification Number (UID)",
                      description:
                        "A UID is 6-15 digits long (e.g. 123456879265)",
                      required: "The UID must be 6-15 digits long",
                    },
                    warning: {
                      title: "Important: OTP verification required",
                      text: "We'll send a one-time code to the Company Owner's registered contact. Make sure they're available to receive and enter it before you continue.",
                    },
                  },
                },
                differenceModal: {
                  title:
                    "Ministry of Human Resources & Emiratisation vs Free Zone & Offshore",
                  mohreTitle:
                    "Ministry of Human Resources & Emiratisation company",
                  nonMohreTitle: "Free Zone & Offshore company",
                  mohreDescription:
                    "Mainland UAE employers with a Ministry of Human Resources & Emiratisation establishment file. Identified by EIDA or UID.",
                  nonMohreDescription:
                    "Free zone, offshore, branches. Identified by trade licence and ICP establishment card.",
                  gotIt: "Got it",
                },
              },
              new: { companyAdded: "Company added" },
            },
          },
        },
        controls: {
          page: {
            context: "Context",
            emailControls: "Email controls",
            engineControls: "Engine controls",
            logoEmail: "Logo - Email",
            logoInverse: "Logo - Inverse",
            logoRegular: "Logo - Regular",
            logoSymbol: "Logo - Symbol",
            sendEmail: "Send Email",
            template: "Template",
            logo: { fileRequirements: "PNG, JPG or GIF (max. 2MB)" },
            emails: {
              edit: {
                success: "Your changes have been saved.",
                revertSuccess: "All changes have been reverted.",
                revertTemplate: "Revert template",
                revertTemplateDescription:
                  "Are you sure you want to revert to the chosen version? All your current customizations will be lost.",
                testEmailSuccess: "Test email sent successfully",
                error: "Your changes could not be saved.",
                revertError: "The template could not be reverted.",
                testEmailError: "The test email could not be sent.",
              },
            },
          },
          automations: {
            page: {
              heading: "Automations",
              employeeInvitations: {
                automated: "Automated",
                automatedDescription:
                  "Invite employees automatically when you set up a benefit or product.",
                heading: "Invite employees",
                description:
                  "Choose how the employees you onboard will be invited to the benefits that they are assigned to.",
                manual: "Manual",
                manualDescription: "Invite employees manually.",
              },
              kycProvider: {
                heading: "KYC (Know Your Customer) preferences",
                description:
                  "Choose how the employees you onboard will submit their documents after they register.",
                manual: "Manual",
                manualDescription:
                  "Employees can submit documents directly to your team for review.",
                automated: "Automated",
                automatedDescription:
                  "Employees can complete verification through a secure third-party service.",
                externalProvider: {
                  heading: "Which integration do you want to enable?",
                  options: {
                    Sumsub: "Sumsub",
                    Onfido: "Onfido",
                    BostonDynamics: "Boston Dynamics",
                  },
                },
              },
            },
          },
          fees: {
            heading: "Fees",
            page: {
              cta: "Create fee",
              status: {
                live: "Live",
                inactive: "Inactive",
                draft: "Unpublished",
              },
              lastUpdated: "Last updated",
              menu: {
                edit: "Edit",
                viewWorkflows: "View workflows",
                duplicate: "Duplicate",
                settings: "Settings",
                delete: "Delete",
              },
              empty: {
                createWorkflow: "Create fee",
                title: "No fee types created yet.",
                description: "Create your first fee type to get started",
              },
              noRecords: {
                title: "No fee types found",
                description: "No fee types match your search for",
              },
              duplicateSuccess: "Fee type duplicated",
              duplicateWorkflowSuccess: "Fee workflow duplicated",
              deleteSuccess: "Fee type deleted",
              activeWorkflows: (count) =>
                `${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `active workflow` })[P.select(count)] ?? `active workflows`}`,
              appliedToCompanies: (count) =>
                `Applied to ${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `company` })[P.select(count)] ?? `companies`}`,
              appliedToAllCompanies: "Applied to all companies",
              appliedToProducts: (count) =>
                `Applied to ${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `product` })[P.select(count)] ?? `products`}`,
              appliedToAllProducts: "Applied to all products",
              deleteDialog: {
                title: "Delete fee type",
                description: (name) =>
                  `Are you sure you want to delete \"${name}\"? This action cannot be undone.`,
                success: "Fee type deleted",
              },
            },
            feeId: {
              settings: {
                title: "Fee settings",
                nameIsRequired: "Workflow name is required",
                details: "Details",
                name: "Fee name",
                description: "Description",
                isActive: "Activate workflow",
                isActiveDescription:
                  "Once active, you can apply this fee to companies and products immediately.",
                applyFees: "Apply fees",
                applyFeesSubtitle:
                  "Apply fees either by company or apply by product type",
                companies: "Companies",
                products: "Products",
                applyToAll: "Apply to all companies",
                applyToAllDescription:
                  "Selecting this will automatically apply this fee to all existing and new companies created.",
                chooseCompanies: "Choose companies to apply this fee to",
                companiesSelected: ({ selected, total }) =>
                  `${selected} out of ${total} companies selected`,
                search: "Search",
                edit: "Edit",
                chooseCompaniesTitle: "Choose companies to apply this fee to",
                chooseCompaniesSource: "Choose companies",
                selectedCompaniesTarget: "Selected companies",
                applyFeeToCompanies: (count) =>
                  `Apply fee to (${count}) companies`,
                cancel: "Cancel",
                xCompanies: (count) => `${count} companies`,
                noCompaniesSelected: "No companies selected yet",
                productsLabel: "Products",
                applyToAllCategory: "Apply to all products in this category",
                applyToAllCategoryDescription:
                  "Selecting this will automatically apply this fee to all existing and new products created.",
                chooseProducts: "Choose product instances to apply this fee to",
                noProductsSelected: "No products selected yet",
                chooseProductsTitle:
                  "Choose product instances to apply this fee to",
                chooseProductsSource: "Choose products",
                selectedProductsTarget: "Selected products",
                applyFeeToProducts: (count) =>
                  `Apply fee to (${count}) products`,
                companiesCountLabel: "companies",
                productsCountLabel: "products",
                editWorkflow: "Edit workflow",
                dangerZone: "Danger zone",
                unpublishTitle: "Unpublish this workflow",
                unpublishDescription:
                  "Unpublishing will hide this workflow from all users. You can republish it later without losing any data.",
                unpublishButton: "Unpublish",
                publishTitle: "Publish workflow",
                publishDescription:
                  "Publishing this workflow will make it active and available for execution.",
                publishButton: "Publish",
                deleteTitle: "Delete this workflow",
                deleteDescription:
                  "Deleting this workflow will permanently remove all associated data. Companies or products using this workflow will be affected.",
                deleteButton: "Delete permanently",
                confirmUnpublish: (name) =>
                  `Are you sure you want to unpublish \"${name}\"?`,
                confirmPublish: (name) =>
                  `Are you sure you want to publish \"${name}\"?`,
                confirmDelete: (name) =>
                  `Are you sure you want to delete \"${name}\"? This action cannot be undone.`,
              },
              workflowSettings: {
                title: "Workflow settings",
                nameIsRequired: "Workflow name is required",
                details: "Details",
                isActive: "Activate workflow",
                isActiveDescription: "Enable this workflow to make it active",
                name: "Workflow name",
                description: "Description",
                dangerZone: "Danger zone",
                deleteTitle: "Delete this workflow",
                deleteDescription:
                  "Deleting this workflow will permanently remove all associated data.",
                deleteButton: "Delete permanently",
                confirmDelete: (name) =>
                  `Are you sure you want to delete \"${name}\"? This action cannot be undone.`,
                deleteSuccess: "Workflow deleted",
              },
              workflows: {
                heading: "Workflows",
                cta: "Create workflow",
                empty: {
                  title: "No workflows created yet.",
                  description:
                    "Create your first workflow for this fee to get started",
                  createWorkflow: "Create workflow",
                },
                noRecords: {
                  title: "No workflows found",
                  description: "No workflows match your search for",
                },
              },
            },
          },
          translations: {
            heading: "Translations",
            identifier: "Identifier",
            identifierDescription:
              "Unique keys used in code to reference translation strings",
            string: "String",
            employerPortal: "Employer portal",
            employeeApp: "Employee app",
            versionHistory: "Version history",
            emptyState: {
              title: "No results found",
              text: "Adjust your search to find the translation",
            },
          },
          branding: {
            platform: { name: "", signInName: "", signUpName: "" },
            page: {
              heading: "Configure your brand",
              yourDetails: "Your details",
              platformName: "Platform name",
              privacyNotice: "Privacy notice",
              privacyNoticeUrl: "Privacy notice URL",
              feelingLost: "Feeling lost",
              feelingLostUrl: "Feeling lost URL",
              domain: {
                label: "Set your domain",
                hint: "This is how the URL of the platform will be displayed as. E.g. acmecorp.com",
                optional: "Optional",
              },
              signIn: {
                title: (name) => `Log in to ${name}`,
                email: { label: "Email" },
                password: { label: "Password" },
                signIn: "Sign in",
                donthaveAccount: "Don't have an account yet?",
                signUpLink: "Sign up",
              },
              uploadLogo: "Upload your logo",
              logoInverse: "Negative",
              logoRegular: "Positive",
              logoEmail: "Email",
              logoSymbol: "Symbol",
              chooseTheme: "Choose your theme",
              liveChat: "Live chat",
              liveChatWidgetToken: "Live Chat widget token",
              liveChatSecretKey: "Live Chat secret key",
              liveChatSecretKeyHint:
                "Used to verify user identity in the Live Chat widget",
              applyChanges: "Save all changes",
            },
          },
          mohreSupport: {
            page: {
              heading: "MOHRE Support Tools",
              description:
                "Manage and push data to MOHRE (Ministry of Human Resources and Emiratisation)",
              pushing: "Pushing...",
              companyOperations: {
                heading: "Company Operations",
                companyId: "Company ID",
                companyIdPlaceholder: "Enter Company ID",
                pushEmployer: "Push Employer to MOHRE",
                pushOwner: "Push Owner to MOHRE",
                pushAllEmployees: "Push All Employees to MOHRE",
                pushSubscriptions: "Push Company Subscriptions to MOHRE",
              },
              employeeOperations: {
                heading: "Individual Employee Operations",
                employeeId: "Employee ID",
                employeeIdPlaceholder: "Enter Employee ID",
                pushEmployee: "Push Individual Employee to MOHRE",
                pushSubscription: "Push Individual Subscription to MOHRE",
              },
              paymentOperations: {
                heading: "Individual Payment Operations",
                paymentId: "Payment ID",
                paymentIdPlaceholder: "Enter Payment ID",
                pushPayment: "Push Individual Payment to MOHRE",
              },
              withdrawalOperations: {
                heading: "Withdrawal Operations",
                paymentId: "Payment ID",
                paymentIdPlaceholder: "Enter Withdrawal Payment ID",
                pushWithdrawal: "Push Withdrawal to MOHRE",
              },
            },
          },
          paymentSupport: {
            page: {
              heading: "Payment Support Tools",
              description: "Support tools for managing payment operations",
              removePaymentLines: {
                heading: "Remove Payment Lines",
                paymentId: "Payment ID",
                paymentIdPlaceholder: "Enter Payment ID",
                paymentLineIds: "Payment Line IDs",
                paymentLineIdsPlaceholder: "Select payment lines to remove",
                keepOnlySelected:
                  "Keep only the selected lines and remove all others",
                submit: "Remove Lines",
                confirmTitle: "Confirm Payment Line Removal",
                confirmSubmit: "Remove Lines",
              },
              regeneratePaymentInvoice: {
                heading: "Regenerate Payment Invoice",
                paymentId: "Payment ID",
                paymentIdPlaceholder: "Enter Payment ID",
                description:
                  "Re-renders the invoice document from the payment's current line items and replaces the stored file.",
                submit: "Regenerate Invoice",
                confirmTitle: "Confirm Invoice Regeneration",
                confirmSubmit: "Regenerate",
              },
            },
          },
          supportTools: {
            tabs: {
              mohre: "MOHRE",
              payment: "Payment",
              workflow: "Workflow",
              marketOrder: "Market Order",
              employeeStatement: "Employee Statement",
            },
          },
          employeeStatementSupport: {
            page: {
              success: "Statements fixed — no one was notified",
              successNotified: "Statements fixed and employees notified",
              successNewRunId: (runId) => `New run: ${runId}`,
              error: "Failed to start the new run",
              errorMissingProductInstanceId:
                "This run has no productInstanceId — reload the run and try again.",
              confirmTitle: "Confirm statement fix",
              confirmSubmit: "Fix Statements",
              confirmFixAllSilent: (count) =>
                `This regenerates the statement for all ${count} employee(s) this run covered, including ones that already succeeded — use this when a bug affected everyone, not just the ones that failed. No email will be sent. The original statements are kept for history but employees will only see the corrected one.`,
              confirmFixSilent: (count) =>
                `This regenerates the statement for the ${count} employee(s) listed below. No email will be sent.`,
              confirmFixNotify: (count) =>
                `This regenerates the statement for the ${count} employee(s) listed below and sends them a notification email. Only do this for employees who were never successfully notified — anyone notified already will be notified again.`,
              newerRunWarning:
                "This run may be out of date — a newer run already covers some of these employees.",
              newerRunSingle: (date) => `View run from ${date}`,
              loadRun: {
                heading: "Load Statement Run",
                description:
                  "Enter the workflow run ID for the employee statement batch to inspect statement generation status.",
                runId: "Workflow Run ID",
                runIdPlaceholder: "Enter run UUID",
                submit: "Load",
              },
              statement: {
                heading: "Statement Generation",
                statusAllGenerated: (count) =>
                  `All ${count} statements generated successfully`,
                statusSomeMissing: (count) =>
                  `${count} employee(s) still missing a statement`,
                succeededCount: (count) => `${count} generated`,
                failedCount: (count) => `${count} failed`,
                fixStatements: (count) =>
                  `Fix statement for ${count} employee(s)`,
                editHint:
                  "Employee IDs, one per line or comma-separated — starts pre-filled with anyone missing a statement; edit the list to target a different set",
                selectAll: (count) => `Select all ${count} employees`,
                resetToFailed: "Reset to failed only",
                idsPlaceholder: "Employee IDs, comma or newline separated",
                notifyEmployees: "Also notify these employees",
                notifyEmployeesHint:
                  "Off by default. Only turn this on for employees who were never successfully notified — anyone already notified will get another email.",
                copied: "Copied to clipboard",
              },
            },
          },
          workflowSupport: {
            page: {
              heading: "Workflow Support Tools",
              description: "Support tools for managing workflow operations",
              triggerPayrollDeduction: {
                heading: "Trigger payroll deduction workflow",
                productId: "Product ID",
                productIdPlaceholder: "Enter Product ID",
                month: "Select Month",
                monthPlaceholder: "Select a month",
                fund: "Fund",
                fundBoth: "Both funds",
                fundConventional: "Conventional only",
                fundIslamic: "Islamic only",
                includeLeavers:
                  "Include people whose employment or scheme assignment ended after the selected month",
                submit: "Trigger workflow",
              },
              runWorkflow: {
                heading: "Run Workflow",
                productInstanceId: "Product Instance ID",
                productInstanceIdPlaceholder: "Enter Product Instance ID",
                employee: "Employee",
                employeePlaceholder: "Select employee",
                employeeRequired: "Select an employee",
                cashAmount: "Cash Amount",
                cashAmountPlaceholder: "Enter cash amount",
                cashAmountRequired: "Cash amount is required",
                customAttributeName: "Custom Attribute Name",
                customAttributeNamePlaceholder: "Enter custom attribute name",
                customAttributeNameRequired:
                  "Custom attribute name is required",
                targetFundName: "Target Fund Name",
                targetFundNamePlaceholder: "Enter target fund name",
                targetFundNameRequired: "Target fund name is required",
                sourceFundName: "Source Fund Name",
                sourceFundNamePlaceholder: "Enter source fund name (optional)",
                noAdditionalFields:
                  "No additional fields required for this hook",
                runFeeWorkflowDescription:
                  "Are you sure you want to run this workflow? This will trigger the workflow for all applicable fees.",
                data: "Data (JSON)",
                dataPlaceholder: "Enter JSON object",
                dataInvalid: "Enter a valid JSON object",
                workflowId: "Workflow ID",
                workflowIdPlaceholder: "Enter Workflow ID",
                workflowKey: "Workflow",
                workflowKeyPlaceholder: "Select a workflow",
                run: "Run",
                running: "Running...",
              },
              rerunTerminations: {
                heading: "Rerun terminations",
                description:
                  "Run the daily termination job for all employees whose end date is today or earlier.",
                submit: "Rerun",
                confirmTitle: "Rerun terminations",
                confirmDescription:
                  "This reprocesses every employee whose end date is today or earlier, across the whole tenant. It runs in the background and may take a while.",
                confirmSubmit: "Rerun",
              },
              rerunTermination: {
                heading: "Rerun termination for one employee",
                description:
                  "Re-runs the termination workflow for a single employee, ignoring the marker that stops the daily job repeating. Only holdings that are still unvested are affected — already vested holdings keep their vesting date. Use when contributions landed after the employee's termination had already run.",
                id: "Employee ID or product assignment ID",
                idPlaceholder:
                  "Paste an employee ID or a product assignment ID",
                submit: "Rerun for employee",
                confirmTitle: "Rerun termination for one employee",
                confirmDescription:
                  "This starts the termination workflow again for this employee. It vests any unvested holdings and can create a market order. Vested holdings are left alone.",
                confirmSubmit: "Rerun",
                success: "Termination workflow started",
                error: "Failed to rerun the termination",
              },
              rerunFundSwitch: {
                heading: "Rerun fund switch",
                description:
                  "Re-fire the fund switch for a single employee. Use when the original switch produced no market order. The employee's selected fund is not changed.",
                productAssignmentId: "Product assignment ID",
                productAssignmentIdPlaceholder: "Enter product assignment ID",
                customAttributeName: "Fund attribute",
                customAttributeNamePlaceholder:
                  "Enter fund attribute name, e.g. employeeBasicFund",
                sourceFundName: "Source fund",
                sourceFundNamePlaceholder: "Fund the holdings are currently in",
                targetFundName: "Target fund",
                targetFundNamePlaceholder: "Fund to switch into",
                submit: "Rerun",
                confirmTitle: "Rerun fund switch",
                confirmDescription:
                  "This starts the fund switch workflows for this employee and can create a new switch market order. Check for an existing pending switch order first to avoid switching the units twice.",
                confirmSubmit: "Rerun",
                success: "Fund switch rerun started",
                error: "Failed to rerun fund switch",
              },
              rerunStatement: {
                heading: "Rerun employee statement",
                description:
                  "Regenerate the statement and notification for specific employees. Check Attachment runs / Email log first to avoid duplicates.",
                productInstanceId: "Product instance ID",
                productInstanceIdPlaceholder: "Enter product instance ID",
                employeeIds: "Employee IDs",
                employeeIdsPlaceholder:
                  "One employee ID per line, or comma-separated",
                submit: "Rerun",
                confirmTitle: "Rerun employee statement",
                confirmDescription:
                  "This sends a new statement email to each employee listed. Continue?",
                confirmSubmit: "Rerun",
                success: "Employee statement rerun started",
                error: "Failed to rerun employee statement",
              },
              success: { workflowRan: "Workflow run successfully" },
              errors: {
                workflowNotFound: "Workflow version not found",
                noVersionFound: (workflowId) =>
                  `No current version found for workflow definition \"${workflowId}\"`,
                failedToRun: "Failed to run workflow",
              },
            },
          },
          customAttributes: {
            categoryId: {
              page: {
                title: "Configure form fields",
                types: { default: "Default", additional: "Additional" },
                saveFieldsError: "Failed to save the fields",
                saveFieldsSuccess: "Fields saved successfully",
              },
            },
            page: {
              group: {
                employer: { title: "Employer onboarding" },
                employee: { title: "Employee onboarding" },
                nominee: { title: "Nominee details" },
              },
              category: {
                companyInformation: { name: "Company information" },
                companyCreate: { name: "Company registration" },
                companyProduct: { name: "Company product" },
                companyTax: { name: "Company tax information" },
                employeePersonalInfo: { name: "Employee personal information" },
                employeeProduct: { name: "Employee product" },
                employeeContact: { name: "Employee contact information" },
                employeeEmploymentDetails: {
                  name: "Employee employment details",
                },
                employeeBankDetails: { name: "Employee bank details" },
                nomineeDetails: { name: "Nominee personal information" },
                employeeAdditionalDetails: {
                  name: "Employee additional details",
                },
                other: { name: "Other" },
                taxInformation: { name: "Tax information" },
              },
              title: "Configure form fields",
            },
          },
          forms: {
            page: {
              list: {
                title: "Forms",
                addForm: "Add form",
                taxInformation: "Tax information",
                emptyFormsTitle: "No forms created yet.",
                emptyFormsText: "Create your first form to get started.",
                createForm: "Create a form",
                category: {
                  taxInformation: {
                    name: "Tax information",
                    description: "Forms related to tax information",
                  },
                  companyInformation: {
                    name: "Company information",
                    description: "Forms related to company information",
                  },
                  companyCreate: {
                    name: "Company registration",
                    description: "Forms related to company registration",
                  },
                  companyTax: {
                    name: "Company tax information",
                    description: "Forms related to company tax information",
                  },
                  employeePersonalInfo: {
                    name: "Employee personal information",
                    description:
                      "Forms related to employee personal information",
                  },
                  employeeContact: {
                    name: "Employee contact information",
                    description:
                      "Forms related to employee contact information",
                  },
                  employeeEmploymentDetails: {
                    name: "Employee employment details",
                    description: "Forms related to employee employment details",
                  },
                  employeeBankDetails: {
                    name: "Employee bank details",
                    description: "Forms related to employee bank details",
                  },
                  employeeAdditionalDetails: {
                    name: "Employee additional details",
                    description: "Forms related to employee additional details",
                  },
                  nomineeDetails: {
                    name: "Nominee details",
                    description: "Forms related to nominee details",
                  },
                  companyProduct: {
                    name: "Company product",
                    description: "Forms related to company product",
                  },
                  employeeProduct: {
                    name: "Employee product",
                    description: "Forms related to employee product",
                  },
                  other: {
                    name: "Other",
                    description: "Forms related to other information",
                  },
                },
              },
              editor: {
                addField: "Add field",
                backToEditing: "Back to editing",
                category: "Category",
                defaultLabel: "Default label",
                defaultPlaceholder: "Default placeholder",
                formDescription: "Form description",
                formName: "Form name",
                formSettings: "Form settings",
                newForm: "New form",
                publish: "Publish",
                unpublish: "Unpublish",
                unpublishDialog: {
                  title: "Are you sure you want to unpublish this form?",
                  description:
                    "This form will no longer be visible or accessible to users. You can republish it at any time.",
                  submit: "Unpublish form",
                },
                formStatusUpdatedToast: "Form status updated.",
                saveDraft: "Save draft",
                savedToast: "Form saved. Publish now to make changes live.",
                actions: {
                  add: "Add",
                  edit: "Edit",
                  duplicate: "Duplicate",
                  delete: "Delete",
                  moveUp: "Move up",
                  moveDown: "Move down",
                  toggleVisibility: "Toggle visibility",
                  goBack: "Go back",
                  preview: "Preview",
                  settings: "Settings",
                  menu: "Menu",
                },
              },
            },
          },
          products: {
            page: {
              heading: "Choose your products",
              category: {
                retirement: "Retirement",
                benefit: "Benefit",
                wealth: "Wealth",
                advice: "Advice",
                insurance: "Insurance",
              },
              product: {
                avs: {
                  name: "End of service benefits",
                  description: "Defined benefit saving plan",
                },
                ipp: {
                  name: "International pensions plan",
                  description: "Multi-jurisdictional workplace saving",
                },
                workingSaving: {
                  name: "Workplace saving",
                  description: "Defined contribution saving plan",
                },
                sipps: {
                  name: "SIPPS",
                  description: "Self-invested personal pension",
                },
                iras: {
                  name: "IRAs",
                  description: "Individual retirement account",
                },
                selfDirectedInvestment: {
                  name: "Individual investment account",
                  description: "Self-directed investment",
                },
                discretionaryPortfolio: {
                  name: "Discretionary portfolio management",
                  description: "Professional portfolio management",
                },
                execution: {
                  name: "Execution only",
                  description: "Self-directed portfolio management",
                },
                advisorPlatform: {
                  name: "Advisor platform",
                  description: "Advisor managed account",
                },
                roboAdvisory: {
                  name: "Robo-advisory",
                  description: "Automated financial planning",
                },
                managedAccounts: {
                  name: "Managed accounts",
                  description: "Discretionary investment management",
                },
                groupLife: {
                  name: "Group life",
                  description: "Life insurance for employees",
                },
                criticalIllness: {
                  name: "Critical illness",
                  description: "Insurance for serious illness",
                },
                incomeProtection: {
                  name: "Income protection",
                  description: "Income insurance for illness or injury",
                },
              },
              comingSoon: "Coming soon",
              productInDevelopment:
                "These products are currently in development.",
              noProductEnabled: "No products enabled yet.",
              updateProducts: "Update products",
              XProduct: (count) =>
                `${{ [1]: `Update 1 product` }[count] ?? `Update ${count} products`}`,
              addProducts: "Add products",
              search: "Search for available products",
              title: "Products",
              cta: "Create new product",
              status: { live: "Live", inactive: "Inactive" },
              workflows: "Workflows",
              attributes: "Attributes",
              settings: "Settings",
              lastUpdated: "Last updated",
              empty: {
                createProduct: "Create new product",
                title: "No products created yet.",
                description: "Create your first product to get started",
              },
              noRecords: {
                title: "No products found",
                description: "No products match your search for ",
              },
            },
            productId: {
              details: {
                page: {
                  createTitle: "Create new product",
                  editTitle: "Edit product",
                  settings: "Settings and details",
                  name: "Product name",
                  description: "Product description",
                  isActive: "Make live on platform",
                  isActiveDescription:
                    "When enabled, this product becomes available on your platform. You'll be able to add employees, process contributions, and manage the benefit.",
                  saveError: "Failed to save product",
                },
              },
              productCustomAttributes: {
                page: {
                  name: "Product custom attributes",
                  category: {
                    employer: { title: "Company product" },
                    employee: { title: "Employee product" },
                  },
                  group: {
                    productAttributes: { name: "Product attributes" },
                    productAssignmentAttributes: {
                      name: "Product assignment attributes",
                    },
                  },
                },
              },
              workflows: {
                page: {
                  title: "Workflows",
                  addWorkflow: "Add workflow",
                  edited: "Edited",
                  versions: "versions",
                  status: {
                    Active: "Live",
                    Draft: "Unpublished",
                    Inactive: "Inactive",
                  },
                  empty: {
                    createProduct: "Create new workflow",
                    title: "No workflows created yet.",
                    description: "Create your first workflow to get started",
                  },
                  noRecords: {
                    title: "No workflows found",
                    description: "No workflows match your search for ",
                  },
                },
              },
            },
          },
          payments: {
            page: {
              title: "Payments",
              saveError: "Failed to save payment categories",
              tabs: {
                paymentCategories: "Payment categories",
                invoiceParties: "Invoice parties",
              },
              paymentCategory: {
                cta: "Add payment category",
                modal: {
                  title: {
                    add: "Add new payment category",
                    edit: "Edit payment category",
                  },
                  titleEn: {
                    label: "English",
                    placeholder: "e.g., Basic subscriptions",
                  },
                  titleAr: {
                    label: "Arabic",
                    placeholder: "e.g., اشتراكات أساسية",
                  },
                  adjustable: {
                    label: "Show as adjustment option",
                    description:
                      "Enable this to make the category available when adjusting holding payment records.",
                  },
                  delete: {
                    title: "Delete payment category",
                    description:
                      "Are you sure you want to delete the category?",
                    cta: "Delete category",
                  },
                },
              },
              invoiceParty: {
                cta: "Add invoice party",
                errors: {
                  saveFailed: "Failed to save invoice party",
                  deleteFailed: "Failed to delete invoice party",
                },
                modal: {
                  title: {
                    add: "Add invoice party",
                    edit: "Edit invoice party",
                  },
                  type: {
                    label: "Recipient type",
                    individual: "Individual",
                    company: "Company",
                  },
                  name: { label: "Full name" },
                  invoiceTitle: { label: "Invoice title" },
                  address: { label: "Address" },
                  trn: { label: "TRN" },
                  disclaimerEn: {
                    label: "Disclaimer (English)",
                    description: "Displayed to recipients in English.",
                  },
                  disclaimerAr: {
                    label: "Disclaimer (Arabic)",
                    description: "Displayed to recipients in Arabic.",
                  },
                  delete: {
                    title: "Delete invoice party",
                    description:
                      "Are you sure you want to delete this invoice party? This action cannot be undone.",
                    cta: "Delete",
                  },
                },
              },
            },
          },
          emails: {
            page: {
              emails: {
                edit: { subject: "Subject", from: "From", to: "To" },
                list: {
                  sidebar: {
                    categories: {
                      employees: "Employees",
                      business: "Business",
                    },
                    subCategories: {
                      actionRequired: "Action required",
                      onboarding: "Onboarding",
                      verification: "Verification",
                      reports: "Reports",
                      security: "Security",
                    },
                    searchPlaceholder: "Search for templates",
                    noResults: "No results found",
                    tabs: {
                      chooseTemplate: "Choose template",
                      configure: "Configure",
                      sendTest: "Send test",
                    },
                  },
                  heading: "Emails",
                },
              },
            },
            emailType: {
              page: {
                details: "Details",
                emails: {
                  edit: {
                    recipientAndSenderDetails: "Recipient and sender details",
                    sender: "Sender",
                    recipients: "Recipients",
                    recipientsTooltip:
                      "Recipients of this email are dependent on the users' roles. To change recipients, amend role permissions or assign users to a different role.",
                    recipientsTooltipEditRoles: "Edit roles",
                    uploadOrChangeYourLogo: "Upload or change your logo",
                    testRecipientDetails: "Test recipient details",
                    testRecipientDetailsDescription:
                      "Separate emails using a comma, space, or by pressing enter.",
                    testRecipientsAdded: (count) => `${count} recipients added`,
                    trigger: "Trigger",
                    showVersionHistory: "Show version history",
                    sendTestEmail: "Send test email",
                    resetToDefault: "Revert all changes",
                  },
                  list: { heading: "Emails" },
                },
                invite: {
                  errors: {
                    invalidEmail: "One of the emails is invalid",
                    atLeastOneEmail: "Please add at least one email",
                  },
                },
              },
            },
          },
          documents: {
            page: {
              title: "Documents",
              generalDocument: "General document",
              addDocument: "Add a document",
              noDocuments: "No documents yet",
              fileType: "PDF only, max 10MB",
              choose: "Choose",
              configure: "Configure",
              dialog: {
                delete: "Delete document",
                warning:
                  " Are you sure you want to delete this document? This will delete documents uploaded in all languages. You can’t undo this action afterwards.",
              },
              disclaimerNotice: "Disclaimer notice",
              documentType: "What type of document are you uploading?",
              documentUsage: "How should this document be used?",
              addLanguage: "Add languages",
              search: "Search for documents or categories",
              toast: {
                upload: "Documents uploaded successfully",
                update: "Documents updated successfully",
                delete: "Documents deleted successfully",
              },
              fund: "Fund",
              failedToFetch:
                "Failed to fetch original file. Please reselect manually.",
              missingFile: "Missing file",
              titleRequired: "Document title required",
              cta: "Save all changes",
              untitled: "Untitled",
            },
          },
          passwordPolicy: {
            page: {
              heading: "Password policy",
              description: "Set password rules for all users",
              policy: {
                capitalLetter: {
                  title: "Capital letter",
                  description: "Require at least one uppercase letter (A-Z)",
                },
                lowercaseLetter: {
                  title: "Lowercase letter",
                  description: "Require at least one lowercase letter (a-z)",
                },
                number: {
                  title: "Number",
                  description:
                    "Require at least one digit in the password (0-9)",
                },
                specialCharacter: {
                  title: "Special character",
                  description: "Require at least one symbol (!@#$%^&* etc.)",
                },
                minimumLength: {
                  title: "Minimum length",
                  description: "Set minimum number of characters required",
                  label: "Set length",
                },
                forcePasswordChange: {
                  title: "Force password change",
                  description:
                    "Require users to update their password every [X] days",
                  label: "Set number of days",
                },
                avoidCommonPasswords: {
                  title: "Avoid common passwords",
                  description:
                    "Block commonly used or easily guessed passwords",
                },
                disallowPreviousPasswords: {
                  title: "Prevent password reuse",
                  description:
                    "Prevent users from cycling through the same passwords",
                },
              },
              toast: {
                success: "Password policy updated successfully",
                enterValidNumericValue: "Please enter a valid numeric value",
              },
              tab: {
                passwords: "Passwords",
                nationalities: "Nationalities",
                passwordRequirements: "Password requirements",
                securityPolicies: "Security policies",
                citizenships: "Citizenships",
                passwordRequirementsTab: {
                  heading: "Password requirements",
                  description: "Set rules for creating strong passwords",
                },
                securityPoliciesTab: {
                  heading: "Security policies",
                  description: "Set security policies",
                },
              },
              securityPoliciesCard: {
                heading: "Set security policies",
                description:
                  "Configure password requirements and security policies for your platform.",
              },
              nationalitiesCard: {
                heading: "Block citizenships",
                description:
                  "Choose the citizenships that you want to restrict from accessing the platform.",
                placeholder: "Search for citizenships",
              },
            },
          },
          accessAndRestrictions: {
            page: {
              nationalitiesCard: {
                heading: "Block citizenships",
                description:
                  "Choose the citizenships that you want to restrict from accessing the platform.",
                placeholder: "Search for citizenships",
              },
              toast: {
                success: "Password policy updated successfully",
                authenticationAndSecurityUpdated:
                  "Authentication and security policies updated successfully",
                enterValidNumericValue: "Please enter a valid numeric value",
              },
              policy: {
                capitalLetter: {
                  title: "Capital letter",
                  description: "Require at least one uppercase letter (A-Z)",
                },
                lowercaseLetter: {
                  title: "Lowercase letter",
                  description: "Require at least one lowercase letter (a-z)",
                },
                number: {
                  title: "Number",
                  description:
                    "Require at least one digit in the password (0-9)",
                },
                specialCharacter: {
                  title: "Special character",
                  description: "Require at least one symbol (!@#$%^&* etc.)",
                },
                minimumLength: {
                  title: "Minimum length",
                  description: "Set minimum number of characters required",
                  label: "Set length",
                },
                forcePasswordChange: {
                  title: "Force password change",
                  description:
                    "Require users to update their password every [X] days",
                  label: "Set number of days",
                },
                avoidCommonPasswords: {
                  title: "Avoid common passwords",
                  description:
                    "Block commonly used or easily guessed passwords",
                },
                disallowPreviousPasswords: {
                  title: "Prevent password reuse",
                  description:
                    "Prevent users from cycling through the same passwords",
                },
              },
              tab: {
                authentication: "Authentication",
                passwordRequirements: "Password requirements",
                securityPolicies: "Security policies",
                passwords: "Passwords",
                nationalities: "Nationalities",
                features: "Features",
                content: "Content",
                citizenships: "Citizenships",
              },
              contentCard: {
                heading: "Employee transactions",
                description:
                  "Control what information is displayed in employee transaction history.",
                feeBalance: {
                  title: "Fee balance",
                  description: "Show fee balance in employee transactions",
                },
                toast: { success: "Content settings updated" },
              },
              featuresCard: {
                heading: "Hide or enable certain platform features",
                description:
                  "Choose the features that you want to enable or hide.",
                segmentEmployers: "For employers",
                segmentEmployees: "For employees",
                employeeAutoInvite: {
                  title: "Automatic employee invitations",
                  description:
                    "Automatically invite employees when they are added to the platform.",
                },
                beneficiaries: {
                  title: "Beneficiaries",
                  description:
                    "Allow employees to add or edit beneficiary details.",
                },
                saml: {
                  title: "Single sign-on (SSO)",
                  description:
                    "Allow administrators to configure SAML-based single sign-on.",
                },
                googleSignIn: {
                  title: "Google sign-in",
                  description:
                    "Allow users to sign in with their Google account.",
                },
                marketOrderConfirmation: {
                  title: "Market order confirmation",
                  description:
                    "Require administrators to confirm market orders before submission.",
                },
                workflowConfiguration: {
                  title: "Workflow configuration",
                  description:
                    "Enable workflows managed through platform configuration.",
                },
                dataEditor: {
                  title: "Data editor",
                  description:
                    "Allow administrators to edit supported platform data in bulk.",
                },
                tasks: {
                  title: "Tasks",
                  description:
                    "Enable task management and task-based operational flows.",
                },
                adminDashboard: {
                  title: "Admin dashboard",
                  description:
                    "Show the dashboard experience to platform administrators.",
                },
                transactionFees: {
                  title: "Transaction fees",
                  description:
                    "Show fee amounts in employee transaction history.",
                },
                statements: {
                  title: "Statements",
                  description:
                    "Allow employees to view and download their statements.",
                },
                toast: { success: "Platform features updated." },
                activity: {
                  title: "Activity",
                  description:
                    "Show the activity pages, where each stage of a company's activity is tracked.",
                },
              },
              securityPoliciesCard: {
                heading: "Set security policies",
                description:
                  "Configure password requirements and security policies for your platform.",
              },
              signInCard: {
                heading: "Configure authentication and security",
                description:
                  "Control how users access the platform and stay secure.",
                button: "Save",
                singleSignOn: "Single sign-on (SSO)",
                singleSignOnDescription:
                  "Allow users to sign in using your company’s login system",
                googleSignIn: "Google sign-in",
                googleSignInDescription:
                  "Allow users to sign in with their Google account.",
                inactivityTimeout: "Session inactivity timeout",
                inactivityTimeoutDescription:
                  "Minutes of inactivity before a user is signed out. Leave as is to keep the environment-wide default.",
              },
            },
          },
          workflow: {
            new: {
              page: {
                title: "Untitled workflow",
                toast: {
                  productIdRequired: "Product ID required",
                  workflowIdRequired: "Workflow ID required",
                  cannotCreateWorkflowWithoutProductId:
                    "Cannot create workflow without a product ID",
                  workflowSaved: "Workflow saved",
                  workflowUpdated: "Workflow updated",
                  workflowPublished: "Workflow published",
                  workflowDeactivated: "Workflow deactivated",
                  workflowStatusUpdated: "Workflow status updated",
                  workflowVersionUpdated: "Workflow version updated",
                },
                badgeLabel: {
                  draft: "Unpublished",
                  active: "Live",
                  inactive: "Inactive",
                },
                nodeTemplates: { trigger: "Trigger" },
              },
            },
            page: {
              badgeLabel: { draft: "Unpublished" },
              topNavigation: {
                exitBuilder: "Exit builder",
                publishWorkflow: "Publish workflow",
                unpublishWorkflow: "Unpublish workflow",
                publishFeeModal: {
                  title: "Publish this workflow",
                  description:
                    "You've not assigned this workflow to any companies or products yet. You can do this under your workflow settings.",
                  skipAndSaveAsDraft: "Skip and save as draft",
                  goToWorkflowSettings: "Go to workflow settings",
                },
              },
              versionHistory: {
                title: "Version history",
                current: "Current",
                pendingSummary: "Generating summary...",
                useThisVersion: "Use this version",
                renameTitle: "Rename version",
                renamePlaceholder: "Enter version name",
                deleteTitle: "Delete version",
                deleteDescription:
                  "Are you sure you want to delete this version?",
                deleteConfirm: "Delete version",
              },
              versionBanners: {
                latest: {
                  text: "This is not the latest version of this workflow.",
                  action: "Go to latest version",
                },
                live: {
                  text: "This is not the currently live version of this workflow.",
                  action: "Go to live version",
                  cta: "Make this version live",
                },
              },
              readOnlyBanner: {
                text: "This workflow is managed in code and cannot be edited here.",
              },
              shared: {
                dataSourceBadges: {
                  retrievingDataFrom: "Retrieving data from:",
                },
              },
              nameModal: {
                title: "Workflow name",
                nameLabel: "Template name",
                descriptionLabel: "Template description",
                save: "Save template",
              },
              leftSidebar: {
                vestHoldings: "Vest holdings",
                upcomingPaymentNotice: "Upcoming payment notice",
                notification: "Notification",
                attachment: "Attachment",
                triggers: "Triggers",
                hooks: "Hooks",
                query: {
                  title: "Query data",
                  displayName: "Query",
                  defaultRules: {
                    queryType: {
                      name: "Query type",
                      options: [
                        "Employee data",
                        "Company data",
                        "Product data",
                        "Custom query",
                      ],
                    },
                    cacheResults: { name: "Cache results" },
                  },
                },
                transform: "Transform",
                timer: "Timer",
                gate: "Gate",
                condition: "Condition",
                payment: "Payment",
                marketOrder: "Market order",
                barrier: "Barrier",
                workflow: "Workflow",
                aumFee: "AUM Fee",
              },
              pwbsidebar: {
                search: "Search",
                noResultFound: "No result found",
                categories: {
                  initiations: "Initiations",
                  dataAndLogic: "Data and logic",
                  actions: "Actions",
                  communications: "Communications",
                  conditions: "Conditions",
                },
              },
              entities: {
                employee: {
                  title: "Employee",
                  description: "Employee records and information",
                },
                productAssignment: {
                  title: "Employee-Product",
                  description: "Employee attributes for specific products",
                },
                company: {
                  title: "Company",
                  description: "Company and organization information",
                },
                product: {
                  title: "Product",
                  description: "Product catalog and information",
                },
                holding: {
                  title: "Holding",
                  description: "Holding information and attributes",
                },
                fundPrice: {
                  title: "Latest fund prices",
                  description: "Latest fund price per ISIN",
                },
                fundPriceHistory: {
                  title: "Historical fund price",
                  description:
                    "Full fund price history per ISIN, for resolving a price as of a past date",
                },
                aumFee: {
                  title: "AUM Fees",
                  description: "Accrued AUM fees per employee holding",
                },
                paymentLineItem: {
                  title: "Payment",
                  description:
                    "Payment line items linked to employee product assignments",
                },
                marketOrderTransaction: {
                  title: "Market order transaction",
                  description:
                    "Market order transactions linked to employee product assignments",
                },
                user: {
                  title: "User",
                  description: "Platform users and their roles",
                },
                investmentTransaction: {
                  title: "Investment transaction",
                  description:
                    "Contributions and withdrawals per employee, already matched to fund and amount",
                },
                portfolio: {
                  title: "Portfolio",
                  description:
                    "Opening and closing value, units, and cash flow per fund over a reporting window",
                },
              },
              rulesSidebarDrawer: {
                title: (category) => `Configure ${category} node`,
                backToTriggerRules: "Back to trigger rules",
                triggers: {
                  title: "How Trigger nodes work",
                  description:
                    "Trigger nodes define when the workflow begins. Use Schedule for time-based starts (e.g., 'Every 1st at 09:00') and Hook for event-based starts. Scope sets where it executes (Platform).",
                },
              },
              nodeTemplates: {
                trigger: "Trigger",
                eventHookTrigger: "Event hook trigger",
                endOfEmployment: "End of employment",
                formSubmission: "Form submission",
                dateReached: "Date reached",
                sendEmail: "Send email",
                createTask: "Create task",
                updateRecord: "Update record",
                setWaitPeriod: "Set wait period",
                timer: "Timer",
                changeSubscription: "Change subscription",
                convertDataFormat: "Convert data format",
                mapFields: "Map fields",
                filterData: "Filter data",
                processPayment: "Process payment",
                refundPayment: "Refund payment",
                verifyPayment: "Verify payment",
                validateEmail: "Validate email",
                validatePhoneNumber: "Validate phone number",
                checkRequiredFields: "Check required fields",
                query: "Query",
                companyDataQuery: "Company data query",
                productDataQuery: "Product data query",
                marketOrder: "Market order",
                barrier: "Barrier",
                aumFee: "AUM Fee",
                vestHoldings: "Vest holdings",
                upcomingPaymentNotice: "Upcoming payment notice",
                notification: "Notification",
                attachment: "Attachment",
                gate: "Gate",
                condition: "Condition",
                rules: {
                  triggerType: "Trigger type",
                  scheduleScope: "Schedule scope",
                  frequency: "Frequency",
                  runOn: "Run on",
                  eventType: "Event type",
                  employeeStatus: "Employee status",
                  noticePeriod: "Notice period",
                  formType: "Form type",
                  dateCondition: "Date condition",
                  emailTemplate: "Email template",
                  sendImmediately: "Send immediately",
                  taskPriority: "Task priority",
                  assignTo: "Assign to",
                  recordType: "Record type",
                  updateFields: "Update fields",
                  waitingTime: "Waiting time",
                  businessDaysOnly: "Business days only",
                  subscriptionType: "Subscription type",
                  autoRenewal: "Auto-renewal",
                  sourceFormat: "Source format",
                  targetFormat: "Target format",
                  preserveFormatting: "Preserve formatting",
                  sourceField: "Source field",
                  targetField: "Target field",
                  applyTransformation: "Apply transformation",
                  filterCondition: "Filter condition",
                  includeEmptyValues: "Include empty values",
                  paymentMethod: "Payment method",
                  currency: "Currency",
                  sendReceipt: "Send receipt",
                  refundType: "Refund type",
                  reasonRequired: "Reason required",
                  verificationMethod: "Verification method",
                  fraudDetection: "Fraud detection",
                  checkFormat: "Check format",
                  verifyDomain: "Verify domain",
                  checkDisposable: "Check disposable",
                  countryCode: "Country code",
                  formatValidation: "Format validation",
                  requiredFields: "Required fields",
                  allowPartialValidation: "Allow partial validation",
                  queryType: "Query type",
                  cacheResults: "Cache results",
                  orderType: "Order type",
                  customRecurringDate: "Custom recurring date",
                  timeZone: "Time zone",
                },
                values: {
                  schedule: "Schedule",
                  hook: "Hook",
                  then: "Then",
                  else: "Else",
                  platform: "Platform",
                  product: "Product",
                  daily: "Daily",
                  weekly: "Weekly",
                  monthly: "Monthly",
                  quarterly: "Quarterly",
                  yearly: "Yearly",
                  custom: "Custom",
                  payrollDay: "Payroll day",
                  monthEnd: "Month end",
                  quarterEnd: "Quarter end",
                  anniversaryDate: "Anniversary date",
                  customDate: "Custom date",
                  withdrawalRequested: "withdrawal_requested",
                  employeeTerminated: "employee_terminated",
                  employeeFundSwitched: "employee_fund_switched",
                  citizenshipBlocked: "citizenship_blocked",
                  active: "Active",
                  terminated: "Terminated",
                  onLeave: "On Leave",
                  thirtyDays: "30 days",
                  contactForm: "Contact form",
                  registrationForm: "Registration form",
                  feedbackForm: "Feedback form",
                  specificDate: "Specific date",
                  defaultTemplate: "Default template",
                  welcomeTemplate: "Welcome template",
                  reminderTemplate: "Reminder template",
                  low: "Low",
                  medium: "Medium",
                  high: "High",
                  critical: "Critical",
                  defaultAssignee: "Default assignee",
                  userRecord: "User record",
                  status: "Status",
                  sevenDays: "7 days",
                  basicSubscription: "Basic subscription",
                  premiumSubscription: "Premium subscription",
                  enterpriseSubscription: "Enterprise subscription",
                  json: "JSON",
                  xml: "XML",
                  csv: "CSV",
                  yaml: "YAML",
                  firstName: "firstName",
                  firstNameUnderscore: "first_name",
                  statusActive: "status = active",
                  ageGreaterThan18: "age > 18",
                  verifiedTrue: "verified = true",
                  creditCard: "Credit card",
                  bankTransfer: "Bank transfer",
                  paypal: "PayPal",
                  stripe: "Stripe",
                  usd: "USD",
                  eur: "EUR",
                  gbp: "GBP",
                  cad: "CAD",
                  fullRefund: "Full refund",
                  partialRefund: "Partial refund",
                  manualReview: "Manual review",
                  automatedCheck: "Automated check",
                  thirdPartyService: "Third-party service",
                  us: "US",
                  ca: "CA",
                  uk: "UK",
                  au: "AU",
                  international: "International",
                  nameEmailPhone: "name, email, phone",
                  employeeData: "Employee data",
                  companyData: "Company data",
                  productData: "Product data",
                  customQuery: "Custom query",
                  buy: "Buy",
                  sell: "Sell",
                  switch: "Switch",
                },
              },
              nodeConfig: {
                shared: {
                  dataSourceSelector: {
                    label: "Data source",
                    description:
                      "Select which upstream node will provide data for this operation.",
                    placeholder: "Select node(s)",
                  },
                  ruleAccordion: {
                    customScheduleInfo:
                      'Custom schedule configuration is available in the advanced view. The detailed schedule settings will appear above when you select "Custom" frequency.',
                    noRulesConfigured: "No rules configured for this node.",
                  },
                  validation: {
                    dataSourceRequired: "At least one data source is required",
                  },
                  code: {
                    stale:
                      "Inputs changed — the code will be regenerated on the next run",
                  },
                },
                gate: {
                  title: "How Gate nodes work",
                  description:
                    "Gate nodes evaluate an expression from your workflow's context against an expected value using a comparison operator. This allows you to implement conditional logic and prevent invalid data from progressing through your workflow.",
                  backToGateRules: "Back to gate rules",
                  noValue: "no value",
                  inputExpression: {
                    label: "Input expression",
                    description:
                      "The information to check from your workflow. Must be wrapped in curly braces, e.g. {'query:1.result.0.kycVerified'}'",
                  },
                  operator: {
                    label: "Operator",
                    description:
                      "How to compare the information to the value (equals, greater than, exists, etc.)",
                    placeholder: "Search",
                  },
                  value: {
                    label: "Value",
                    description:
                      "What the value should be for the workflow to continue. E.g. true or false",
                    configure: "Configure",
                  },
                  operators: {
                    equals: "Equals",
                    notEquals: "Not equals",
                    greaterThan: "Greater than",
                    lessThan: "Less than",
                    greaterThanOrEqual: "Greater than or equal to",
                    lessThanOrEqual: "Less than or equal to",
                    exists: "Exists",
                    includedInArray: "Included in the array",
                  },
                  valueConfig: {
                    setValueType: "Set value type",
                    description:
                      "Choose the type of value to compare against your expression.",
                    types: {
                      boolean: "True/False",
                      number: "Number",
                      string: "String",
                      array: "Array of strings",
                    },
                    booleanValues: { true: "True", false: "False" },
                    inputs: { number: "Number", string: "String" },
                    array: { title: "Array of strings", addItem: "Add item" },
                  },
                  validation: {
                    expressionFormat:
                      "Expression must be wrapped in curly braces, e.g. {query:1.result}'",
                    valueRequired: "Value is required",
                  },
                },
                condition: {
                  title: "How Condition nodes work",
                  description:
                    "Condition nodes evaluate an expression from your workflow's context against an expected value using a comparison operator. This allows you to branch your workflow based on whether the condition is true or false.",
                  backToGateRules: "Back to condition rules",
                  noValue: "no value",
                  inputExpression: {
                    label: "Input expression",
                    description:
                      "The information to check from your workflow. Must be wrapped in curly braces, e.g. {'query:1.result.0.kycVerified'}'",
                  },
                  operator: {
                    label: "Operator",
                    description:
                      "How to compare the information to the value (equals, greater than, exists, etc.)",
                    placeholder: "Search",
                  },
                  value: {
                    label: "Value",
                    description:
                      "What the value should be for the workflow to branch. E.g. true or false",
                    configure: "Configure",
                  },
                  operators: {
                    equals: "Equals",
                    notEquals: "Not equals",
                    greaterThan: "Greater than",
                    lessThan: "Less than",
                    greaterThanOrEqual: "Greater than or equal to",
                    lessThanOrEqual: "Less than or equal to",
                    exists: "Exists",
                    includedInArray: "Included in the array",
                  },
                  valueConfig: {
                    setValueType: "Set value type",
                    description:
                      "Choose the type of value to compare against your expression.",
                    types: {
                      boolean: "True/False",
                      number: "Number",
                      string: "String",
                      array: "Array of strings",
                    },
                    booleanValues: { true: "True", false: "False" },
                    inputs: { number: "Number", string: "String" },
                    array: { title: "Array of strings", addItem: "Add item" },
                  },
                },
                barrier: {
                  title: "How Barrier nodes work",
                  description:
                    "Barrier nodes pause this workflow until all runs of the selected workflow definitions finish for the same scope.",
                  workflowDefinitionIds: {
                    label: "Workflow definitions to wait for",
                    description:
                      "Select workflow definitions. The workflow waits until all running instances of these definitions are complete for the same scope.",
                    placeholder: "Select workflow definitions...",
                  },
                  workflowKeys: {
                    label: "Workflow keys this barrier waits for",
                    description:
                      "Configured in the workflow config. The workflow waits until all running instances of these workflows are complete for the same scope.",
                    empty: "This barrier is not waiting for any workflows.",
                  },
                  validation: {
                    workflowDefinitionsRequired:
                      "Workflow definitions are required",
                  },
                },
                marketOrder: {
                  title: "How market order nodes work",
                  description:
                    "Investment nodes execute market orders using AI-powered analysis. They can receive data from transform/query nodes for analysis while waiting for payment/execution dependencies to complete first.",
                  instructions: {
                    label: "Market order instructions",
                    description:
                      "Explain clearly how the input should be converted into market orders. For each order, specify the order type (buy, sell, or switch) and company ID. Provide a list of transactions, each of which must include employee’s product assignment ID, cash or units amount to trade, and ISINs. For buy orders, also define the vesting rules. You may also include additional details, such as fund and share class information.",
                    placeholder:
                      "Example: Calculate total compensation by adding base_salary + bonus + equity_value. Filter for employees with status = ‘active’ and hire_date > 2020. Apply currency conversion if needed.",
                  },
                  validation: {
                    instructionsRequired: "Instructions are required",
                  },
                },
                aumFee: {
                  title: "How AUM fee nodes work",
                  description:
                    "Fee nodes compute daily AUM fees per employee holding using AI-powered analysis. They calculate fees based on the annual rate and current fund positions, storing results as pending fees for later collection.",
                  computation: {
                    label: "Fee computation",
                    percentage: "Percentage",
                    customLogic: "Custom logic",
                    percentageHint: "Choose your annual fee rate between 0–1%",
                    customHint:
                      "Describe how fees should be calculated in plain language. Our AI will interpret and apply your logic.",
                  },
                  instructions: {
                    label: "Fee computation instructions",
                    description:
                      "Define how to compute fees using the input holdings and fund price data.",
                    placeholder:
                      "Example: For each employee holding, compute the daily fee by applying the annual rate to the total position value. Use the latest fund price to convert units to cash value.",
                  },
                  validation: {
                    percentageRequired: "Percentage is required",
                    percentageExceedsMax: "Percentage cannot exceed 1%",
                    instructionsRequired: "Instructions are required",
                  },
                },
                payment: {
                  title: "How payment nodes work",
                  description:
                    "Configure sender/recipient accounts, currency, input data paths, and payment processing instructions.",
                  currency: {
                    label: "Currency",
                    placeholder: "Select currency",
                  },
                  instructions: {
                    label: "Payment instructions",
                    description:
                      "Explain clearly how the input should be converted into payments. For every payment, specify the sender, the recipient, and the destination IBAN for the bank transfer. Then divide each payment into one or more line items. Each line item must include a source, a payment category, and the corresponding amount. You may also include additional details, such as salary information.",
                    placeholder:
                      "Example: Calculate total compensation by adding base_salary + bonus + equity_value. Filter for employees with status = 'active' and hire_date > 2020. Apply currency conversion if needed.",
                  },
                  tabs: { payment: "Payment", invoice: "Invoice" },
                  yourPayments: "Your payments",
                  configurePayment: "Configure payment",
                  addPayment: "Add payment",
                  backToPayments: "Back to payments",
                  defaultPaymentTitle: "Payment",
                  deleteConfirm: {
                    title: "Remove payment?",
                    description:
                      "This payment and all its configuration will be permanently removed.",
                  },
                  invoice: {
                    billedBy: "Billed by",
                    billedTo: "Billed to",
                    paymentName: "Payment name",
                    paymentNameDescription:
                      "This name will appear on the invoice and identifies this payment leg in your payment configuration.",
                    paymentNamePlaceholder: "e.g. Participation Fee",
                    description: "Description",
                    descriptionDescription:
                      "This will appear on the invoice to describe the payment in more detail.",
                    descriptionPlaceholder: "e.g. Monthly billing",
                    taxRate: "Tax rate",
                    taxRateDescription:
                      "The percentage of the payment amount to be applied as tax. Enter a value between 0 and 100.",
                    taxRatePlaceholder: "e.g. 5",
                  },
                  validation: {
                    currencyRequired: "Currency is required",
                    instructionsRequired: "Instructions are required",
                    paymentsRequired: "At least one payment is required",
                    taxRateInvalid: "Tax rate must be between 0% and 100%",
                  },
                  routing: {
                    modeLabel: "Payment mode",
                    modeGuided: "Guided",
                    modeCustom: "Custom",
                    senderType: "Sender type",
                    recipientType: "Recipient type",
                    iban: "IBAN",
                    swiftCode: "SWIFT code (optional)",
                    bankName: "Bank name (optional)",
                    category: "Payment category",
                    lineItemLogic: "Line item logic",
                    lineItemLogicDescription:
                      "Describe how to group and calculate amounts for this payment leg. Do not include routing details — they are handled by the structured fields above.",
                    lineItemLogicPlaceholder:
                      "Example: Group by company and sum each member's pro-rata fee as a line item.",
                    customPlaceholder:
                      "Describe how to route and calculate this payment: sender, recipient, IBAN, and line items.",
                  },
                },
                query: {
                  title: "How Query nodes work",
                  description:
                    "Query nodes pull selected columns from a chosen entity and emit a clean dataset for downstream steps. Use filters and mapping to keep only what's needed and standardize field names.",
                  dataSource: {
                    label: "Data source",
                    description:
                      "Select which upstream node will provide data for this operation.",
                    placeholder: "Choose an entity...",
                  },
                  columns: {
                    selectedCount: ({ selected, total }) =>
                      `${selected} of ${total} columns selected`,
                  },
                  noEntity: {
                    title: "No entity selected",
                    description:
                      "Choose an entity above to configure your query",
                  },
                  window: {
                    label: "Snapshot range",
                    description:
                      "Choose the start and end of this portfolio snapshot.",
                    mode: {
                      label: "Period start",
                      placeholder: "Choose a start...",
                      sinceInception: "Since inception",
                      relative: "Relative to period end",
                    },
                    value: { label: "Value", placeholder: "e.g. 6" },
                    unit: {
                      label: "Unit",
                      placeholder: "Choose a unit...",
                      days: "Days",
                      months: "Months",
                      years: "Years",
                    },
                    periodEnd: {
                      label: "Period end",
                      description:
                        "Number of completed months to look back from today. Default to 0 for the latest data.",
                      placeholder: "e.g. 0",
                    },
                  },
                },
                transform: {
                  title: "How transform nodes work",
                  description:
                    "Transform nodes receive data from connected input nodes and apply your transformation rules to produce the specified output format. The input data is automatically available from upstream connections.",
                  rules: {
                    label: "Transformation rules",
                    description:
                      "Define how the input data should be transformed. Describe the logic, calculations, or data manipulations to apply.",
                    placeholder:
                      "Example: Calculate total compensation by adding base_salary + bonus + equity_value. Filter for employees with status = 'active' and hire_date > 2020. Apply currency conversion if needed.",
                  },
                  outputFormat: {
                    label: "Output format",
                    description:
                      "Describe the structure and fields of the output JSON. Define each field and its data type.",
                    placeholder:
                      "Example: Define the output structure with field names and data types, such as employee information with compensation details and effective dates.",
                  },
                  code: {
                    label: "Generated code",
                    description:
                      "JavaScript executed at run time. It's generated automatically from the rules and output format on the first workflow run and cached here, then edit if needed.",
                    placeholder:
                      "// The code is generated automatically and cached here after the first workflow run, or you can paste your code it here.",
                    generate: "Generate code",
                  },
                  validation: {
                    rulesRequired: "Transformation rules are required",
                    outputFormatRequired: "Output format is required",
                  },
                },
                timer: {
                  title: "How Timer nodes work",
                  description:
                    "Timer nodes pause the workflow for a specified duration before continuing.",
                  duration: {
                    label: "Duration",
                    description:
                      'Use a human-friendly duration like "2 days", "15 minutes", or "500ms".',
                    placeholder: "2 days",
                  },
                  validation: {
                    durationRequired: "Duration is required",
                    durationInvalid:
                      "Duration must be a valid ms-formatted string",
                  },
                },
                vestHoldings: {
                  title: "How Vest Holdings nodes work",
                  description:
                    "Vest holdings nodes take current holdings as input and immediately vest all unvested ones. This allows you to automatically update holding vesting status at specific points in your workflow based on your vesting logic and conditions.",
                },
                upcomingPaymentNotice: {
                  title: "How upcoming payment notice nodes work",
                  description:
                    "Upcoming payment notice nodes take payment data from the selected source and trigger reminder messages ahead of due dates. Use them to notify stakeholders before payments are processed, using whatever schedule logic you model in the workflow.",
                },
                notification: {
                  title: "How notification nodes work",
                  description:
                    "Notification nodes send email notifications when the workflow reaches this step.",
                  to: {
                    label: "To",
                    description: "Email address of the recipient.",
                    placeholder: "recipient@example.com",
                  },
                  bcc: {
                    label: "BCC",
                    description: "Optional BCC recipient address.",
                    placeholder: "bcc@example.com",
                  },
                  subject: {
                    label: "Subject",
                    description: "Email subject line.",
                    placeholder: "Payroll processed",
                  },
                  message: {
                    label: "Message",
                    description: "Email message body.",
                    placeholder:
                      "Write an email message to send when this node runs.",
                  },
                  attachment: {
                    content: {
                      label: "Attachment content",
                      description:
                        "Expression resolving to the file buffer from a previous node.",
                      placeholder: "e.g. attachment:1.result.content",
                    },
                    filename: {
                      label: "Attachment filename",
                      description:
                        "Filename or expression resolving to the filename.",
                      placeholder: "report.xlsx",
                    },
                  },
                },
                attachment: {
                  title: "How Attachment nodes work",
                  description:
                    "Attachment nodes define the output of attachments based on configured rules and data from connected input nodes.",
                  instructions: {
                    label: "Instructions",
                    description:
                      "Define how to save this attachment in the database.",
                    placeholder: "Instructions for saving attachment go here",
                  },
                  documentType: {
                    label: "Document type",
                    description:
                      "Select what type of document you want to configure.",
                    options: { pdf: "PDF", excel: "Excel" },
                  },
                  template: {
                    label: "Select template",
                    placeholder: "Select template",
                  },
                  templates: { employeeStatement: "Employee Statement" },
                },
              },
              toast: {
                workflowSaved: "Workflow saved",
                workflowUpdated: "Workflow updated",
                versionRenamed: "Version renamed",
                versionDeleted: "Version deleted",
                nodeDeleted: "Node deleted",
                cannotDeleteTrigger: "Cannot delete trigger node",
              },
            },
          },
          compliance: {
            page: {
              controls: {
                compliance: {
                  companyStatus: {
                    companyInReviewTitle: "That’s all we need for now",
                    companyInReviewDescription:
                      "We’ll let you know when we’ve verified your documents. Once your company is verified, you’ll get access to everything you need to start adding employees, benefits, and processing payments.",
                    companyRejectedTitle:
                      "Your company verification was not approved",
                    companyRejectedDescription:
                      "We've reviewed and verified your company documents, however the administrator was unable to approve your submission. You won't be able to proceed with your company setup. For more information on the reason for this decision and next steps, please contact your administrator.",
                  },
                  home: {
                    cards: {
                      companyDocuments: {
                        title: "Manage company documents",
                        description:
                          "Configure which documents are required at the company level",
                      },
                      signatoryDocuments: {
                        title: "Manage signatory documents",
                        description:
                          "Manage the documents that will be requested for each signatory",
                      },
                      kycDocuments: {
                        title: "Manage employee documents",
                        description:
                          "Configure which documents are required at the employee level",
                      },
                    },
                    kybHeading: "Know your business (KYB)",
                    kycHeading: "Know your employee (KYC)",
                  },
                  kybDocuments: {
                    companyDocuments: "Company documents",
                    signatoryDocuments: "Signatory documents",
                    messages: {
                      unsavedChanges:
                        "You have unsaved changes. Are you sure you want to leave this page?",
                      saveSuccess: "Documents saved successfully",
                      editSuccess: "Document updated successfully",
                    },
                    errors: {
                      saveFailed: "Failed to save documents please try again",
                    },
                    header: {
                      companyTitle: "Manage company documents",
                      companyDescription:
                        "Configure which documents are required at the company level",
                      signatoryTitle: "Manage signatory documents",
                      signatoryDescription:
                        "Manage the documents that will be requested for each signatory.",
                      title: "KYC Document Types",
                      description:
                        "Configure which documents are required for employee KYC verification.",
                    },
                    actions: {
                      optional: "Optional",
                      add: "Add document",
                      edit: "Edit document",
                      remove: "Remove document",
                      save: "Save changes",
                      deleteDocument: "Delete document",
                      deleteDocumentWarning:
                        "Are you sure you want to delete this document? This will delete documents uploaded in all languages. You can't undo this action afterwards.",
                      cancel: "Cancel",
                      documentName: "Document name",
                      documentDescription: "Description",
                      makeDocumentMandatory: "Make document mandatory",
                      makeDocumentMandatoryDescription:
                        "Users will need to submit this document in order to pass verification.",
                    },
                    required: "Required",
                    optional: "Optional",
                  },
                  kycDocuments: {
                    title: "Employee documents",
                    messages: { saveSuccess: "Documents saved successfully" },
                    errors: {
                      saveFailed: "Failed to save documents please try again",
                    },
                    header: {
                      title: "Manage employee documents",
                      description:
                        "Configure which documents are required at the employee level",
                    },
                    actions: {
                      add: "Add document",
                      edit: "Edit document",
                      remove: "Remove document",
                      save: "Save changes",
                      cancel: "Cancel",
                      optional: "Optional",
                      documentName: "Document name",
                      documentDescription: "Description",
                    },
                    required: "Required",
                    optional: "Optional",
                  },
                },
              },
            },
          },
          marketOrderSupport: {
            page: {
              updateReceipt: {
                heading: "Update Market Order Receipt",
                description:
                  "Replaces the stored receipt document on a market order without re-executing it. Switch orders carry a separate buy and sell receipt.",
                marketOrderId: "Market Order ID",
                marketOrderIdPlaceholder: "Enter Market Order ID",
                loading: "Loading market order…",
                notFound: "No market order found for this ID.",
                reference: "Reference",
                type: "Type",
                state: "State",
                units: "Units / Amount",
                buyUnits: "Bought (units / amount)",
                sellUnits: "Sold (units / amount)",
                currentReceipt: "Current buy receipt",
                currentReceiptFrom: "Current sell receipt",
                noDocument: "None",
                selectDocument: "Document to update",
                targetBuy: "Buy receipt",
                targetSell: "Sell receipt",
                targetBoth: "Both",
                uploadReceipt: "Receipt",
                uploadBuy: "Buy receipt",
                uploadSell: "Sell receipt",
                submit: "Update Receipt",
                confirmTitle: "Confirm Receipt Update",
                confirmDescription: ({ documents, reference }) =>
                  `Replace ${documents} on market order ${reference}? The existing document will be overwritten.`,
                confirmSubmit: "Update",
                toastSuccess: "Market order receipt updated",
              },
            },
          },
          activity: {
            page: {
              color: "Colour",
              colors: {
                info: "Blue",
                neutral: "Grey",
                primary: "Brand",
                success: "Green",
                warning: "Amber",
              },
              completedDescriptionHint:
                "How the last stage should read after it finishes, for example Invested instead of Being invested. Left blank, it keeps its own name.",
              completedTitle: "Once the last stage is done",
              currentVersion: (version) => `Version ${version} (current)`,
              description:
                "Choose which activities appear on the activity pages, what they are called, and who can see them.",
              inheritedNaming: (version) =>
                `This version has not been named yet, so it is showing the naming of version ${version}. Save to give it its own.`,
              noStages: "This activity has no stages to name.",
              onCompanyPage: "Company page",
              onCompanyPageDescription:
                "Show this activity on a company's activity page.",
              onPlatformPage: "Platform page",
              onPlatformPageDescription:
                "Show this activity on the platform activity page.",
              permission: "Permission needed to see it",
              saved: "Activity settings saved",
              stageDescriptionAr: "Description (Arabic)",
              stageDescriptionEn: "Description (English)",
              stageNameAr: "Name (Arabic)",
              stageNameEn: "Name (English)",
              stages: "Stages",
              stagesHint:
                "Stage names belong to one version of the activity. A version you have not named yet borrows the naming of the version before it.",
              title: "Activity",
              typeLabelAr: "Type label (Arabic)",
              typeLabelEn: "Type label (English)",
              version: (version) => `Version ${version}`,
              versionLabel: "Version",
            },
          },
        },
        disclaimers: {
          page: {
            consent: "Agree and proceed",
            description: {
              contact:
                "Office 402, 14th Floor, Al Sarab Tower, ADGM Square, Al Maryah Island, Abu Dhabi, United Arab Emirates",
              email: "Email: support@aurem.ae",
              phone: "Tel: +971 2 499 6333",
              question: "If you have any questions, please contact us at:",
              text: "These documents involve some of our products such as investing, saving and more. To get a full understanding, read the agreements attached. Please read all of the documents carefully.",
            },
            disclaimers: {
              heading: "Disclaimers",
              noticePrivacy: "Privacy notice",
            },
            heading: "Your documents",
          },
        },
        errorBoundary: {
          reload: "Try again",
          subtext:
            "Unexpected error ocurred. Please try to clear the browser cache and reload the page",
          title: "Please try again",
        },
        forgotPassword: {
          page: {
            title: "Forgot your password?",
            success: {
              title: "Check your email",
              description:
                "If an account exists for this email address, you’ll receive an email from us shortly. Once received, click on the link in the email and set your new password. The link is valid for 24 hours.",
            },
            description:
              "Enter your email to receive a link to reset your password.",
            email: { label: "Enter your email " },
            error:
              "The link could not be sent. Check your internet connection and try again",
            submit: "Send link to email",
            cancel: "Cancel",
          },
        },
        funds: {
          page: {
            list: {
              grid: {
                amount: "Amount",
                companies: "Companies",
                companiesInFund: "Companies in fund",
                companyName: "Company Name",
                employeesInCompany: "Employees in company",
                noRecords: {
                  noRecordsContent:
                    "Your fund insights will show here along with their details.",
                  noRecordsTitle: "No fund insights yet",
                },
                fundClass: "Fund Class",
                fundName: "Fund Name",
                report: "fund insights report",
                title: "Fund insights",
                totalAmount: "Total Amount",
                totalUnits: "Total Units",
                units: "Units",
                viewByCompany: "View by company",
                viewByFundClass: "View by fund Class",
              },
            },
          },
          isin: {
            page: {
              list: {
                grid: {
                  companyName: "Company Name",
                  employeesInCompany: "Employees in company",
                  units: "Units",
                  amount: "Amount",
                  report: "fund insights report",
                  viewByFundClass: "View by fund Class",
                  companiesClass: (className) => `${className} companies`,
                  fundName: "Fund Name",
                  companies: "Companies",
                  totalUnits: "Total Units",
                  totalAmount: "Total Amount",
                },
              },
            },
            fundCompanyId: {
              page: {
                list: {
                  grid: {
                    companyEmployees: (company) => `${company} employees`,
                    amount: "Amount",
                    report: "fund insights report",
                    viewByFundClass: "View by fund Class",
                    totalUnits: "Total Units",
                    employeesInFund: "Employees in Fund",
                  },
                },
              },
            },
          },
          company: {
            fundCompanyId: {
              page: {
                list: {
                  grid: {
                    fundName: "Fund Name",
                    fundClass: "Fund Class",
                    employeesInFund: "Employees in Fund",
                    units: "Units",
                    amount: "Amount",
                    report: "fund insights report",
                    viewByFundClass: "View by fund Class",
                    companyFundDetails: (company) => `${company} fund details`,
                    fundClasses: "Fund Classes",
                    totalUnits: "Total Units",
                    totalAmount: "Total Amount",
                  },
                },
              },
            },
          },
        },
        holdings: {
          page: {
            title: "Holdings",
            views: { employee: "Employee view", employer: "Employer view" },
            totalHoldings: "Total holdings",
            tableColumns: {
              employee: "Employee",
              company: "Company",
              benefit: "Benefit",
              isin: "ISIN",
              totalUnits: "Total units",
              marketValue: "Market value",
              lastUpdated: "Last updated",
              companyName: "Company name",
              fundName: "Fund name",
              shareClass: "Share class",
              navPrice: "NAV price",
            },
            empty: {
              filtersEmpty: {
                title: "No holdings found",
                description: "No holdings found for the selected filters.",
              },
              generalEmpty: {
                title: "No holdings found",
                description:
                  "Your holdings will show here along with their details.",
              },
            },
            filters: {
              company: "Company",
              benefit: "Benefit",
              marketValue: "Market value",
              allValues: "All values",
            },
            dataEditor: {
              title: "Holdings (read-only)",
              unitPrice: "Unit price",
              manage: "Manage",
              viewInDataEditor: "Data Viewer",
            },
            adjustment: {
              adjustmentCta: "Add adjustment",
              adjustmentModal: {
                title: "Adjust holding",
                vestedAt: {
                  label: "Vested at",
                  error: "Vested at is required",
                  validationError: "Vested at must be a valid date",
                },
                adjustmentType: {
                  title: "Adjustment type",
                  positive: "Positive",
                  negative: "Negative",
                },
                newAmount: {
                  label: "Enter new units",
                  description: "The units can not go below 0",
                },
                reason: {
                  label: "Reason",
                  placeholder: "Choose a reason",
                  overpayment: "Overpayment",
                  underpayment: "Underpayment",
                  creditFee: "Credit Fee",
                  debitFee: "Debit Fee",
                  other: "Other",
                },
                otherReason: {
                  label: "Other reason",
                  placeholder: "Enter other reason",
                },
                submitButton: "Add adjustment",
                cancelButton: "Cancel",
                requiredFields: {
                  adjustmentType: "Adjustment type is required",
                  newAmount: "New units is required",
                  reason: "Reason is required",
                  otherReason: "Other reason is required",
                  negativeAmountBelowZero:
                    "Adjustment would reduce the units below 0",
                },
                successMessage: "Adjustment submitted successfully",
              },
            },
          },
        },
        holdingsDetails: {
          page: {
            title: "Holdings details",
            backToHoldings: "Back to holdings",
            header: {
              employeeName: "Employee name",
              companyName: "Company name",
              amount: "Market value",
              productName: "Benefit name",
              isin: "ISIN",
              fundName: "Fund Name",
              shareClass: "Share class",
            },
            tableColumns: {
              units: "Units",
              amount: "Market value",
              vesting: "Vesting",
              executedAt: "Execution date",
              shareClass: "Share class",
              reason: "Reason",
              changedBy: "Changed by",
              changedAt: "Changed at",
            },
            aumFeeTooltip: "Accrued pending fees",
            tableEmptyState: {
              title: "No holdings found",
              description:
                "Your holdings will show here along with their details.",
            },
            dataEditor: {
              title: "Holding details (read-only)",
              viewInDataEditor: "Data Viewer",
            },
          },
        },
        inactive: {
          back: "Close",
          subtext:
            " Your session has timed out and you have been logged out automatically due to inactivity.",
          title: "You have been logged out",
        },
        marketOrders: {
          page: {
            type: {
              buy: "Buy",
              sell: "Sell",
              switch: "Switch",
              withdraw: "Withdraw",
            },
            bulkUpdateMarketOrdersModal: {
              title: "Make edits in bulk",
              cta: "Upload and update",
              fileRequirements: "Excel file (max. 2MB)",
              clickToUpload: "Click to upload",
              orDragAndDrop: "or drag and drop",
              success:
                "Market orders have been started to be updated successfully.",
              error:
                "Failed to start updating market orders. Please check the file format and try again.",
            },
            grid: {
              status: {
                pending: "Pending",
                executed: "Executed",
                overdue: "Overdue",
              },
              today: "Today",
              difference: (diffrence) =>
                `${/**@type{Record<string,unknown>}*/ ({ ["one"]: `1 day` })[P.select(diffrence)] ?? `${diffrence} days`} ago`,
              noRecords: {
                noRecordsContent:
                  "Your market orders will show here along with their status and details.",
                noRecordsTitle: "No new market orders yet",
              },
              fundName: "Fund name",
              fundIsin: "Fund ISIN",
              fundClass: "Fund Class",
              type: "Order type",
              aumFee: { label: "Fee", popover: "Assets Under Management" },
              createdAt: "Created On",
              amount: "Amount",
              executedBy: "Executed By",
              executedOn: "Executed On",
              units: "Units",
              unitPrice: "Unit Price",
              transferBy: "Transfer by",
              report: "market order report",
              movedFrom: (item) => `Moved from ${item}`,
              inProgress: "In progress",
              pastActivity: "Past activity",
              title: "Market orders",
              marketOrderId: "Market Order ID",
              receiptAlt: "Market order receipt",
              filters: {
                last3Months: "Last 3 months",
                last6Months: "Last 6 months",
                lastMonth: "Last month",
                thisYear: "This year",
                fundClass: "Fund class",
                executionStatus: "Execution status",
                employeeTenure: "Employee tenure",
                allValues: "All values",
                placeholders: {
                  type: "All values",
                  company: "Search company",
                  createdAt: "Select date range",
                },
              },
              dynamicReports: {
                pending:
                  "Export list of pending market orders return status, fund name, fund class, fund isin, company, employee, type, amount, created at and transfer by",
                executed:
                  "Export list of all executed market orders return status, fund name, fund class, fund isin, company name, employee name, type, file, total amount invested, total units invested, unit price of the fund, executed by, executed on and created at",
              },
              searchPlaceholder: "Search by company or employee name...",
            },
            dataEditor: {
              title: "Market orders (read-only)",
              manage: "Manage",
              viewInDataEditor: "Data Viewer",
            },
          },
          marketOrderId: {
            page: {
              confirm: {
                amount: "Amount",
                units: "Units Amount",
                description:
                  "Please, confirm the date of market order and the price of purchase/sale.",
                executedAt: { label: "Market order date" },
                heading: "Confirm market order",
                iban: "IBAN",
                name: "Name",
                receipt: {
                  fileRequirements: "PDF, PNG or JPG (max. 2MB)",
                  heading: "Receipt",
                  headingPurchase: "Purchase Receipt",
                  headingSale: "Sale Receipt",
                },
                reference: "Reference",
                transferExecutedAt: { label: "Transfer executed at" },
                unitPrice: {
                  labelBuy: "Unit Price Bought",
                  labelSell: "Unit Price Sold",
                  required: "Unit price is mandatory",
                },
                unitsAmount: {
                  labelBuy: "Units bought",
                  labelSell: "Units sold",
                  required: "Units are mandatory",
                },
                withdrawalDescription:
                  "Please confirm that the transfer to the beneficiary bank account is made",
              },
              withdrawalPayment: {
                description:
                  "Please process and complete the payment to the beneficiary bank account.",
                cta: "Confirm withdrawal payment",
              },
              confirmWithdrawal: "Confirm withdrawal",
              execute: "Execute",
              success: "Market order successfully executed",
              grid: {
                amount: "Amount",
                amountRequested: "Amount requested",
                createdAt: "Created at",
                currency: "Currency",
                detailsTitle: "Market order details",
                executedBy: "Executed by",
                executedOn: "Executed on",
                fundClass: "Fund class",
                fundClassSource: "From fund class",
                fundClassTarget: "To fund class",
                fundId: "Fund ID",
                fundIsin: "Fund ISIN",
                fundIsinSource: "From ISIN",
                fundIsinTarget: "To ISIN",
                fundName: "Fund name",
                fundNameSource: "From fund",
                fundNameTarget: "To fund",
                iban: "IBAN",
                isin: "ISIN",
                report: "market order report",
                status: { overdue: "Overdue" },
                transferBy: "Transfer by",
                type: "Type",
                units: "Units",
                confirmWithdrawalDialog: {
                  uploadReceipt: "Upload receipt",
                  uploadReceiptDescription:
                    "Confirm that you have made this payment by uploading a receipt.",
                },
                noRecords: {
                  noRecordsTitle: "No buy or sell transactions yet",
                  noRecordsContent:
                    "Buy and sell transactions for this order will show here.",
                },
              },
              list: {
                grid: {
                  unitsSold: "Units sold",
                  amountSold: "Amount sold",
                  unitsBought: "Units bought",
                  amountBought: "Amount bought",
                  unitsToSell: "Units to sell",
                  createdOn: "Created on",
                  totalUnitsToSell: "Total units to sell",
                  totalUnitsSold: "Total units sold",
                  totalAmountSold: "Total amount sold",
                  totalUnitsBought: "Total units bought",
                  totalAmountBought: "Total amount bought",
                  units: "Units",
                  amount: "Amount",
                  noRecords: {
                    noRecordsTitle: "No switch transactions yet",
                    noRecordsContent:
                      "Switch transactions for this order will show here.",
                  },
                },
              },
              marketOrders: {
                marketOrderId: {
                  executeSheet: {
                    title: "Confirm market order",
                    subtitle:
                      "Confirm the date of market order and the price of purchase/sale.",
                    executedAt: "Market order date",
                    totalAmount: "Total amount",
                    unitsBought: "Units bought",
                    totalUnits: "Total amount (units)",
                    unitPriceSold: "Unit price sold",
                    receiptSale: "Sale receipt",
                    unitPriceBought: "Unit price bought",
                    receiptPurchase: "Purchase receipt",
                    toastSuccess: "Market order successfully executed.",
                    unitsBoughtRequired: "Units bought is required",
                    receiptRequired: "Receipt is required",
                    unitPriceSoldRequired: "Unit price sold is required",
                    unitPriceBoughtRequired: "Unit price bought is required",
                    unitsPrice: "Units price",
                    assetQuantity: "Asset quantity",
                  },
                },
              },
              adjustments: {
                addAdjustment: "Add adjustment",
                adjustmentModal: {
                  editAmount: "Edit amount",
                  editUnits: "Edit units",
                  currentAmount: "Current amount",
                  currentUnits: "Current units",
                  employeeFieldLabel: "Employee",
                  employeeFieldPlaceholder: "Search employee",
                  reasonFieldLabel: "Add a reason for this change",
                  reasonFieldPlaceholder: "Choose a reason",
                  newAmountFieldLabel: "Enter new amount",
                  newAmountFieldDescription: "The amount can not go below 0",
                  newUnitsFieldLabel: "Enter new units",
                  newUnitsFieldDescription: "The units can not go below 0",
                  submitButton: "Add adjustment",
                  editAdjustmentButton: "Edit adjustment",
                  cancelButton: "Cancel",
                  otherReasonFieldLabel: "Other reason",
                  otherReasonFieldPlaceholder: "Enter other reason",
                  adjustmentType: {
                    title: "Adjustment type",
                    positive: "Positive",
                    negative: "Negative",
                  },
                  requiredFields: {
                    employee: "Employee is required",
                    adjustmentType: "Adjustment type is required",
                    newAmount: "New amount is required",
                    newUnits: "New units is required",
                    reason: "Reason is required",
                    otherReason: "Other reason is required",
                    exactlyOneRequired: "Amount is required",
                    negativeAmountBelowZero:
                      "Adjustment would reduce the amount below 0",
                  },
                  adjustmentReasons: {
                    overpayment: "Overpayment",
                    underpayment: "Underpayment",
                    creditFee: "Credit fee",
                    debitFee: "Debit fee",
                    otherReason: "Other reason",
                  },
                  successMessage: "Market order adjustment successfully added",
                },
              },
            },
            executeSheet: {
              title: "Confirm market order",
              subtitle:
                "Confirm the date of market order and the price of purchase/sale.",
              toastSuccess: "Market order successfully executed.",
              executedAt: "Market order date",
              totalUnits: "Total amount (units)",
              unitPriceSold: "Unit price sold",
              unitPriceSoldRequired: "Unit price sold is required",
              receipt: "Upload receipt",
              receiptRequired: "Receipt is required",
              receiptDescription:
                "Confirm that you have executed the market order by uploading a receipt.",
              totalAmount: "Total amount",
              unitsBought: "Units bought",
              unitsBoughtRequired: "Units bought is required",
              unitPriceBought: "Unit price bought",
              unitPriceBoughtRequired: "Unit price bought is required",
              receiptSale: "Sale receipt",
              receiptPurchase: "Purchase receipt",
            },
          },
        },
        notFound: {
          page: {
            back: "Go back",
            companies: "Go to view companies",
            description:
              "Sorry, the page you're looking for doesn't exist or has been moved",
            error: "404 error",
            heading: "Page not found...",
          },
        },
        payments: {
          page: {
            totalPayments: "Total payments",
            list: { heading: "Payments" },
            grid: {
              amount: "Amount",
              taxAmount: "Tax amount",
              bucket: "Payment category",
              approver: "Approver",
              product: "Product",
              benefitName: "Benefit name",
              companyName: "Company name",
              dueBy: "Due by",
              inProgress: "In progress",
              pastActivity: "Past activity",
              status: "Status",
              confirmPayment: "Confirm payment",
              rejectPayment: "Reject payment",
              tabs: { payments: "Payments", withdrawals: "Withdrawals" },
              statuses: { pending: "Pending", completed: "Paid out" },
              noWithdrawalRecords: {
                noRecordsTitle: "No withdrawals to show for now.",
                noRecordsContent:
                  "Future withdrawal transfers that need to be processed will show here.",
              },
              referenceNumber: "Payment reference",
              employeeName: "Employee name",
              requestedAt: "Request date",
              type: "Type",
              basicSalary: "Basic salary",
              fullSalary: "Full salary",
              confirmWithdrawalDialog: {
                title: "Confirm withdrawal transfer",
                subtitle:
                  "Confirm that the transfer to the beneficiary's bank account is made.",
                totalAmount: "Total amount",
                beneficiary: "Beneficiary",
                iban: "IBAN",
                paymentReference: "Payment reference number",
                paymentReferenceWarning:
                  "You must include this reference number as part of your transfer to avoid risking payment rejections and/or delays.",
                executedAt: "Transfer execution date",
                uploadReceipt: "Upload receipt",
                uploadReceiptDescription:
                  "Confirm that you have made this payment by uploading a receipt.",
                confirm: "Confirm transfer",
                cancel: "Cancel",
                receiptRequired: "Proof of payment is required",
                toastSuccess:
                  "The withdrawal transfer has been successfully confirmed.",
              },
              confirmPaymentModal: {
                downloadReceipt: "Download receipt",
                note: "Add a note",
              },
              rejectPaymentModal: {
                title: "Confirm rejection",
                subtitle: "Please provide a reason for rejecting the payment",
                paymentNotFound: "The payment was not found",
                paymentNotFullAmount:
                  "The payment was less than the required amount",
                note: {
                  label: "Add a note to the customer to describe the issue",
                  placeholder: "Add a note here",
                  required: "Note is required",
                },
              },
              noRecords: {
                noRecordsTitle: "No payments to show for now.",
                noRecordsContent: "Your future payments will show here.",
              },
              sender: "Sender",
              recipient: "Recipient",
              iban: "IBAN",
              accountName: "Account name",
              swiftCode: "SWIFT code",
              branchName: "Branch name",
              branchAddress: "Branch address",
              issueDate: "Issue date",
              dueDate: "Due date",
              paymentForMonth: "Payment for month",
              pendingNote:
                "Please ensure your monthly payment is completed by the 5th day of the following month.",
              report: "payment report",
              dynamicReports: {
                payments: {
                  pending:
                    "Export in csv a list of benefit payments in progress, in overdue or in payment made return Status, company name, ID, payment reference benefit name, amount and due by",
                  completed:
                    "Export in csv a  list of completed or rejected benefit payments return Status, company name, ID, payment reference benefit name, Status, company name, ID, payment reference benefit name, approver and amount",
                },
                withdrawals: {
                  pending:
                    "Export in csv a list of employees withdrawal payments in progress, return status, payment reference, company name, employee name, type, request date and amount",
                  completed:
                    "Export in csv a list of completed employees withdrawal payments, return status, payment reference, company name, employee name, approver, type, request date and amount",
                },
              },
              noResults: {
                title: "No line items found",
                description: "No line items match your search.",
              },
              noLineItems: {
                title: "No line items yet",
                description: "Line items for this payment will show here.",
              },
            },
            filters: {
              issueDate: "Issue date",
              currency: "Currency",
              amount: "Amount",
              from: "From",
              to: "To",
              min: "Min",
              max: "Max",
              allValues: "All values",
              product: "Product",
              allProducts: "All products",
            },
            reviewPaymentsDrawer: {
              confirmPaymentDetails: "Confirm payment details",
              overview: "Overview",
              totalAmount: "Total amount",
              payment: "Payment",
              fund: "Fund",
              amount: "Amount",
              iban: "IBAN",
              referenceNumber: "Payment reference number",
              confirmPayments: "Confirm payments",
              failureConfirmation: "The transaction has been rejected",
              successConfirmation: "The transaction has been confirmed",
            },
            status: {
              overdue: "Overdue",
              paid: "Paid",
              paymentMade: "Payment processing",
              processing: "Processing",
              rejected: "Rejected",
              pending: "Pending",
              approved: "Approved",
            },
            confirm: {
              receipt: { fileRequirements: "PDF, PNG or JPG (max. 2MB)" },
            },
            companyPayments: {
              noRecords: {
                noRecordsTitle: "No payments to show for now.",
                noRecordsContent: "Your future payments will show here.",
              },
            },
            dataEditor: {
              title: "Payments (read-only)",
              manage: "Manage",
              viewInDataEditor: "Data Viewer",
            },
          },
          id: {
            page: {
              grid: { dueBy: "Due by" },
              reviewPaymentsDrawer: {
                amount: "Amount",
                confirmPayments: "Confirm payments",
                fund: "Fund",
                iban: "IBAN",
                accountName: "Account name",
                swiftCode: "SWIFT code",
                branchName: "Branch name",
                branchAddress: "Branch address",
                overview: "Overview",
                payment: "Payment",
                referenceNumber: "Payment reference number",
                referenceNumberTooltip:
                  'Your bank might call this the "Transfer Description" or "Note for recipient".',
                success: "Transaction successfully paid",
                title: "Review and confirm payments",
                totalAmount: "Total amount",
                uploadReceipt: "Upload receipt",
                uploadReceiptDescription:
                  "Confirm that you have made this payment by uploading a receipt.",
                warning:
                  "You must include this reference number as part of your transfer to avoid risking payment rejections and/or delays.",
              },
            },
          },
        },
        profile: {
          page: {
            contact: {
              email: { label: "Email" },
              error: "Failed to update contact info",
              heading: "Contact information",
              success: "Please verify your email to reflect changes here",
            },
            mfa: {
              codeRequest: {
                description:
                  "Scan the QR code and enter the six digit code shown in your authenticator app.",
                heading: "Set up multi-factor authentication",
                verificationCode: "Verification code",
              },
              codeRequestForDisable: {
                description:
                  "Enter the code from your authenticator app to turn off multi-factor authentication.",
                heading: "Turn off multi-factor authentication",
              },
              heading: "Multi-factor authentication",
              headingDescription:
                "Keep your account secure by using a security code in addition to your password while logging in. You will need to setup an authenticator app",
              passwordRequest: {
                description:
                  "Enter your password to set up multi-factor authentication.",
                enterPassword: "Enter password",
                error: "Password is incorrect",
                heading: "Set up multi-factor authentication",
                password: "Password",
              },
              successDisable:
                "Multi-factor authentication turned off successfully",
              successEnable:
                "Multi-factor authentication setup completed successfully",
              invalidCode: "Invalid authentication code. Please try again.",
            },
            personal: {
              error: "Failed to save profile changes",
              heading: "Personal information",
              name: {
                label: "Full name",
                placeholder: "Enter full name",
                required: "Full name is required",
              },
              success: "Profile saved successfully",
            },
            security: {
              heading: "Security",
              password: {
                button: "Change password",
                dialog: {
                  description: "Enter your existing password to verify you",
                  title: "Change password",
                },
                form: {
                  confirmPassword: { label: "Confirm new password" },
                  existingPassword: {
                    label: "Existing password",
                    placeholder: "Enter existing password",
                  },
                  newPassword: {
                    hint: "Must be at least 8 characters",
                    label: "Your new password",
                    placeholder: "Enter new password",
                  },
                  submitButton: "Change password",
                },
                label: "Password",
                lastChanged: "Last changed",
                match: "Passwords do not match",
                success: "Password changed successfully",
              },
            },
            shared: { title: "Profile settings" },
            tabs: { accountDetails: "Account details", security: "Security" },
          },
        },
        requests: {
          company: {
            companyId: {
              page: {
                tabTitle: { documents: "Documents", company: "Company" },
                documentsTab: {
                  approveDialog: {
                    successMessage: "Company verification request approved",
                    heading: "Approve Verification Request",
                    subHeading:
                      "Are you sure you want to approve this request? You can’t undo this action afterwards.",
                    cancelButton: "Cancel",
                    confirmButton: "Confirm Approval",
                  },
                  resubmittedDocuments: "Resubmitted",
                  footer: {
                    heading: "Ready to approve?",
                    subHeading:
                      "Now that you have reviewed the business activities, you can request more documents to complete the KYB process",
                    rejectButton: "Reject verification request",
                    requestMoreButton: "Request more documents",
                    resubmitButton: "Request to resubmit documents",
                    approveButton: "Approve verification",
                  },
                  companyDocuments: { heading: "Company & Ownership" },
                  signatoryDocuments: { heading: "Signatory documents" },
                },
                rejectRequestAlertDialog: {
                  alert: { successMessage: "Rejected successfully" },
                  heading: "Reject verification request",
                  subHeading:
                    "Are you sure you want to reject this request? You can’t undo this action afterwards.",
                  button: { cancel: "Not now", submit: "Confirm Rejection" },
                },
                company: { form: { info: { heading: "Company information" } } },
                new: {
                  name: { label: "Company Name" },
                  registeredNumber: { label: "Trade license number" },
                  website: { label: "Website" },
                  fabCif: { label: "CIF number" },
                  taxInformation: {
                    label: "Tax Information",
                    completed: "Completed via FATCA form",
                    pending: "Pending FATCA completion",
                  },
                },
                signatureRequest: {
                  heading: "Signed documents",
                  companyDocument: "Company document",
                  deedDocument: "Deed of Admission document",
                  download: "Download",
                  waitingForSignature:
                    "Waiting for the user to sign the document",
                },
                detailsApprovalModal: {
                  documentNamePlaceholder: "Enter document name",
                  companyAndOwnership: {
                    defaultOptions: [
                      "Valid Trade License",
                      "Articles of Association",
                      "Memorandum of Association",
                      "Structure chart (Signed and dated)",
                      "Register of Directors",
                      "Register of Members",
                      "Last Audited Financial",
                      "Business Registration",
                      "Proof of operating address in UAE",
                    ],
                    title: "Company & Ownership",
                  },
                  signatoryDocuments: { title: "Signatory documents" },
                  signatory: "Signatory",
                  button: { addOther: "Add Other", submit: "Send Request" },
                },
                requestMoreDocumentsModal: {
                  alert: {
                    successMessage: "Documents request sent successfully",
                  },
                  heading: "Request more documents",
                },
                documentsResubmissionModal: {
                  successMessage: "Documents resubmission request sent",
                  heading: "Request documents resubmission",
                  companyDocuments: "Company documents",
                  signatoryDocuments: "Signatory documents",
                  remarkLabel: "Remarks (optional)",
                  cancelButton: "Cancel",
                  submitButton: "Send Request",
                },
              },
            },
          },
          page: {
            list: {
              grid: {
                columns: {
                  dateReceived: "Date received",
                  dateReviewed: "Date reviewed",
                  reviewer: "Approver",
                },
                noRecords: {
                  noRecordsTitle: "Nothing to review for now.",
                  noRecordsContent:
                    "Verification documents that have been submitted or re-submitted will show here.",
                },
                emptyPrompt: {
                  content:
                    "As you have more requests come through from your companies or employees, you’ll see them listed here for review",
                  title: "No new requests yet",
                },
                report: "requests report",
                status: {
                  approved: "Approved",
                  documentsInReview: "Documents in review",
                  documentsRequired: "Waiting for documents submission",
                  documentsRetry: "Waiting for documents resubmission",
                  rejected: "Rejected",
                  signatoryRequired: "Waiting for signatory emails",
                  waitingForSignature: "Waiting for digital signatures",
                  awaitingSubmission: "Awaiting submission",
                  awaitingResubmission: "Awaiting resubmission",
                  awaitingAdditionalDocuments: "Awaiting additional documents",
                  pendingReview: "Pending review",
                  reset: "Reset",
                },
                statuses: { completed: "Completed", pending: "In progress" },
                tabs: {
                  companies: "Company documents",
                  employees: "Employee documents",
                  subscriptions: "Subscriptions",
                },
              },
              heading: "Requests",
              dynamicReports: {
                pending: {
                  employeeSubscription:
                    "Export in csv a list of employees subscriptions requests that are in progress, return employee name, company, type, amount and date added",
                  companyRequests:
                    "Export in csv a list of all company documents in progress return company verification status, company name, reviewer name, date received and date reviewed",
                  employeeRequests:
                    "Export in csv a list of employee documents in progress return status, employee name and date received",
                },
                completed: {
                  employeeSubscription:
                    "Export in csv a list of employees subscriptions requests that are approved, return employee name, company, type, amount and date added",
                  companyRequests:
                    "Export in csv a list of completed company documents  return company verification status, company name, reviewer name, date received and date reviewed",
                  employeeRequests:
                    "Export in csv a list of completed employee documents return status, employee name, approver, date received and date reviewed",
                },
              },
              dataEditor: {
                manage: "Manage",
                viewInDataEditor: "Data Viewer",
                subscriptionsTitle: "Subscriptions (read-only)",
                companiesTitle: "Company documents (read-only)",
                employeesTitle: "Employee documents (read-only)",
              },
              bulkReset: {
                button: "Reset submissions",
                selected: (count) => `${count} selected`,
                title: "Reset submissions",
                description: (count) =>
                  `You are about to reset ${count} submissions. The employees will be notified and will need to submit again when they are ready.`,
                submitButton: "Reset submissions",
                successMessage: ({ resetCount, skippedCount }) =>
                  `${resetCount} reset, ${skippedCount} skipped`,
                failedMessage: (failedCount) =>
                  `${failedCount} could not be reset`,
              },
              filters: { status: "Status", allStatuses: "All statuses" },
            },
            employeeSubscriptionRequests: {
              grid: { amount: "Amount", dateAdded: "Date added", type: "Type" },
            },
            type: {
              voluntary: "Voluntary",
              oneTimePayment: "One time payment",
            },
          },
          employee: {
            requestId: {
              page: {
                tabTitle: {
                  documents: "Documents and screening",
                  employee: "Employee details",
                },
                documentsTab: {
                  approveDialog: {
                    heading: "Approve Verification Request",
                    subHeading:
                      "Are you sure you want to approve this request? You can’t undo this action afterwards.",
                    riskRating: {
                      header: "Assign risk rating",
                      high: "High",
                      description: {
                        high: "Regular review required",
                        medium: "May require review",
                        low: "No material concerns",
                      },
                      medium: "Medium",
                      low: "Low",
                    },
                    confirmButton: "Confirm Approval",
                  },
                  employeeDocuments: {
                    personalId: "Personal ID",
                    proofOfAddress: "Proof of residency",
                  },
                  documentPreview: {
                    documentTypes: {
                      identityDocument: "Identity document",
                      proofOfAddress: "Proof of address",
                      document: "Document",
                    },
                    sides: { front: "Front", back: "Back" },
                    labels: { fileName: "File name", fileSize: "File size" },
                    messages: {
                      noPreviewAvailable: "No preview available",
                      unknownFilename: "Unknown filename",
                      previewNotAvailable: "Preview not available",
                    },
                    actions: { downloadDocument: "Download document" },
                  },
                  footer: {
                    heading: "Ready to approve?",
                    subHeading:
                      "Now that you have reviewed the employee's details, you can either reject or approve the employee identification process.",
                    rejectButton: "Reject verification request",
                    approveButton: "Approve verification",
                  },
                  emptyState: {
                    status: "Status",
                    message: (employeeName) =>
                      `${employeeName} hasn't submitted their KYC documents yet. Their submission will appear here once they've uploaded the required files.`,
                  },
                  actionRequired: "Action required",
                  status: "Status",
                  statusBanner: {
                    approved: "Verification successful",
                    rejected: "Verification failed",
                    inProgress: "Verification in progress",
                    reset: "Submission reset",
                    approvedMessage: ({ name, date }) =>
                      `Documents approved by ${name} on ${date}.`,
                    rejectedMessage: ({ name, date, note }) =>
                      `Documents rejected by ${name} on ${date} with the rejection note: ${note}`,
                    resetMessage: ({ name, date, note }) =>
                      `Submission reset by ${name} on ${date} with the reason: ${note}`,
                    verificationSuccessful: "Verification successful.",
                    noMatchesFound:
                      "All documents checked and no sanctions or watchlist matches found.",
                    verificationFailed: "Verification failed",
                  },
                  actions: {
                    approve: "Approve and complete",
                    request: "Reject - request resubmission",
                    reject: "Permanently reject - no retry allowed",
                    reset: "Reset submission",
                    approveDescription:
                      "The submitted documents are verified and accepted.",
                    requestDescription:
                      "The submitted documents are insufficient or incorrect. The employee will be asked to resubmit additional or corrected documents.",
                    rejectDescription:
                      "The submitted documents are invalid and cannot be accepted. The employee will be notified of final rejection and cannot resubmit.",
                    resetDescription:
                      "Return the submission to the employee. No action is needed from them until they choose to continue.",
                    requestMoreDocuments: "Request more documents",
                    requestMoreDocumentsDescription:
                      "The submitted documents are insufficient. The employee will be asked to submit additional documents.",
                  },
                  confirmButton: "Confirm",
                },
                rejectRequestAlertDialog: {
                  button: { cancel: "Not now" },
                  heading: "Reject verification request",
                },
                resubmitKycDocuments: {
                  note: {
                    required: "Reason is required",
                    hint: "Your message below will be shared with the employee to explain what's needed and why.",
                    label: "Reason for document request",
                  },
                },
                rejectKycDocuments: {
                  note: {
                    required: "Reason is required",
                    hint: "Your message below will be shared with the employee to explain why the documents were rejected.",
                    label: "Reason for document rejection",
                  },
                  description:
                    "Are you sure you want to reject this request? You cannot undo this action afterwards.",
                  notNow: "Not now",
                  confirmRejection: "Confirm rejection",
                },
                documentsResubmitDialog: {
                  title: "Request documents resubmission",
                  description:
                    "Your message below will be shared with the employee to explain what's needed and why.",
                  selectDocuments: "Select documents that require resubmission",
                  submitButton: "Request documents",
                  successMessage:
                    "Documents resubmission requested successfully",
                },
                documentsRejectDialog: {
                  title: "Reject documents",
                  description:
                    "Are you sure you want to reject these documents? You can't undo this action afterwards.",
                  submitButton: "Reject documents",
                  successMessage: "Documents rejected successfully",
                },
                documentsResetDialog: {
                  title: "Reset submission",
                  description:
                    "Are you sure you want to reset this submission? The employee will be notified and will need to submit again when they are ready.",
                  submitButton: "Reset submission",
                  successMessage: "Submission reset successfully",
                  note: {
                    required: "Reason is required",
                    label: "Reason for resetting",
                  },
                },
                documentsApproveDialog: {
                  title: "Approve documents",
                  description:
                    "Are you sure you want to approve these documents? You can't undo this action afterwards.",
                  overrideMessage:
                    "You are about to manually approve a customer that SumSub has rejected for KYC verification. This action will bypass the automated risk assessment and allow the customer to proceed.",
                  extractedDataReview:
                    "Review and verify the applicant's information extracted by our KYC system. Please ensure all data corresponds accurately with the submitted documents.",
                  assignRiskRating: "Assign risk rating",
                  reasonForRiskRating: "Reason for risk rating",
                  reasonDescription:
                    "Your message below will only be visible to you and will not be shared with the employee.",
                  submitButton: "Approve documents",
                  successMessage: "Documents approved successfully",
                },
                form: {
                  personal: { heading: "Personal info" },
                  nationalId: { label: "Emirates ID" },
                  labourId: { label: "Ministry of Labour ID" },
                  contact: { heading: "Contact" },
                  email: { label: "Work email" },
                  details: { heading: "Employment details" },
                  startDate: { label: "Start of employment" },
                  endDate: { label: "End of employment" },
                  fullSalary: { label: "Monthly salary" },
                  basicSalary: { label: "Monthly basic salary" },
                  iban: { label: "IBAN" },
                  level: { label: "Level (optional)" },
                  department: { label: "Department (optional)" },
                  jobTitle: { label: "Job title" },
                },
                verification: {
                  formHeading: { documentsInReview: "Uploaded documents" },
                },
                extractedData: {
                  title: "Extracted data",
                  fields: {
                    country: "Country",
                    firstName: "First name",
                    middleName: "Middle name",
                    lastName: "Last name",
                    dob: "Date of birth",
                    gender: "Gender",
                    placeOfBirth: "Place of birth",
                    address: "Address",
                  },
                },
                screeningData: { title: "Screening data" },
                applicantData: {
                  noData: {
                    title: "No data to show yet",
                    text: "This data is currently being processed",
                  },
                  details: "Details",
                  id: "ID",
                  submitted: "Submitted",
                  screened: "Screened",
                  vendor: "Vendor",
                  monitoring: "Monitoring",
                  enabled: "Enabled",
                  disabled: "Disabled",
                  result: "Result",
                  metadata: "Metadata",
                  screeningId: "Screening ID",
                  apiTimestamp: "API timestamp",
                  auremId: "Aurem ID",
                  potentialMatches: "Potential matches",
                  birthYears: "Birth year(s)",
                  matchStatus: "Match status",
                  whitelisted: "Whitelisted",
                  categories: "Categories",
                  sources: "Sources",
                  since: "Since",
                },
                list: {
                  grid: {
                    status: { awaitingSubmission: "Awaiting submission" },
                  },
                  heading: "Requests",
                },
              },
            },
            requestMoreDocumentsModal: {
              heading: "Request more documents",
              alert: { successMessage: "Documents requested successfully" },
            },
          },
        },
        signIn: {
          page: {
            signIn: {
              mfa: {
                heading: "Verify your identity",
                description:
                  "Enter the 6 digit code from your authenticator app.",
                error: "Login failed. Please try again.",
              },
              invalidInvitation:
                "This invitation has already been used. Try logging in instead.",
              signIn: "Sign in",
              title: "Log in to",
              email: { label: "Email", placeholder: "Enter your email" },
              password: {
                label: "Password",
                placeholder: "Enter your password",
              },
              error: "Email or password is incorrect",
              signInWithGoogle: "Sign in with Google",
              youCanAlso: "You can also",
              continueWithSaml: "continue with SAML SSO",
              donthaveAccount: "Don't have an account yet?",
              signUpLink: "Sign up",
              forgotPassword: "Forgotten password",
            },
          },
        },
        signInWithSaml: {
          page: {
            signIn: {
              title: (name) => `Log in to ${name}`,
              email: { label: "Email", placeholder: "Enter your email" },
              youCanAlso: "You can also",
              donthaveAccount: "Don't have an account yet?",
              signUpLink: "Sign up",
              forgotPassword: "Forgotten password",
            },
            signInWithSaml: {
              signIn: "Sign in with SAML",
              continueWithEmail: "Continue with email",
            },
          },
        },
        signUp: {
          page: {
            signUp: {
              title: "Register with",
              alreadyHaveAccount: "Already have an account?",
              signInLink: "Sign in",
              email: { label: "Email", placeholder: "Enter your email" },
              password: {
                label: "Password",
                placeholder: "Enter your password",
                hint: "Must be at least 8 characters",
              },
              disclaimer: {
                textFirst:
                  "By continuing to use this platform, you agree to the ",
                link: "terms and conditions",
                textSecond:
                  " and privacy policy, and consent to your information being shared for the purpose of your end of service benefits.",
              },
              agreeTerms:
                "By continuing to use this platform, you agree that your information will be shared for the purpose of your end of service benefits.",
              signUp: "Create an account",
              signUpWithGoogle: "Sign up with Google",
            },
          },
        },
        signUpNewCompanyAdmin: {
          page: {
            emailVerified: "Email verified.",
            welcome:
              "Welcome to the intelligent operating system for retirement and wealth providers. Let’s get started.",
            fullName: { label: "Your full name" },
            preferredName: {
              label: "Preferred name",
              hint: "This could be your first name or a nickname — the name you’d like people to see and refer to in the platform.",
            },
            nextStep: "Next step",
            setYourPassword: "Set your password.",
            setPassword: "Set password",
            passwordConfirmation: { label: "Repeat new password" },
            password: {
              label: "Your new password",
              hint: "Must be at least 8 characters",
            },
          },
        },
        usersManagement: {
          users: {
            page: {
              list: {
                emailVerified: "Email verified",
                grid: {
                  roles: "Roles",
                  employeeStatus: { active: "Active", invited: "Invited" },
                  blockStatus: "Block status",
                  blocked: "Blocked",
                  block: "Block",
                  unblock: "Unblock",
                  active: "Active",
                  invited: "Invited",
                },
              },
              invite: {
                assignUsersToRole: "Assign users to role",
                addUsers: "Add your users",
                choosePermissions: "Choose permissions and assign roles",
                assignAnotherRole: "Assign another role",
                chooseRole: "Choose role",
                company: { label: "Company", placeholder: "Select a company" },
                companyPermissions: {
                  hint: "Users with company permissions will be limited to a select number of features based off specific company settings.",
                  label: "Company permissions",
                },
                description: "Add your users",
                errors: {
                  atLeastOneEmail: "Please add at least one email",
                  selectCompany: "Please select a company",
                  selectRole: "Please select a role",
                  invalidEmail: "One of the emails is invalid",
                  duplicatedRoles:
                    "You cannot select the same role more than once.",
                  userAlreadyExists:
                    "This user is already registered in the system.",
                  duplicateEmail:
                    "This email has already been invited or added.",
                },
                peopleSelected: (count) =>
                  `${/**@type{Record<string,unknown>}*/ ({ ["one"]: `${count} recipient added` })[P.select(count)] ?? `${count} recipients added`}`,
                platformPermissions: {
                  hint: "Users will have access to all permissions and platform features available. You should only invite people you fully trust.",
                  label: "Platform permissions",
                },
                role: { label: "Role", placeholder: "Select a role" },
                selectPermissionsGroup: "Select Permissions group",
                title: "Invite users",
                useComma:
                  "Separate emails using a comma, space, or by pressing enter.",
              },
              invitationAcceptance: { invited: "The users are invited." },
              admins: { invitedBy: "Invited by", lastActive: "Last active" },
              emptyTitle: "No users to show",
              assignNewRole: "Assign new role",
              rolesUpdatedSuccessfully: "Roles updated successfully",
              blockUser: {
                blockTitle: "Block user",
                blockDescription: (email) =>
                  `Are you sure you want to block ${email}? They will no longer be able to log in.`,
                blockConfirm: "Block",
                unblockTitle: "Unblock user",
                unblockDescription: (email) =>
                  `Are you sure you want to unblock ${email}? They will be able to log in again.`,
                unblockConfirm: "Unblock",
                aggregateTitle: "Confirm block status changes",
                aggregateSubmit: "Confirm",
                aggregateBlockHeading: (count) =>
                  `${{ [1]: `Block this user:` }[count] ?? `Block these ${count} users:`}`,
                aggregateUnblockHeading: (count) =>
                  `${{ [1]: `Unblock this user:` }[count] ?? `Unblock these ${count} users:`}`,
                error: {
                  cannotBlockSelf: "Cannot block your own account",
                  userAlreadyBlocked: "User is already blocked",
                  userNotBlocked: "User is not blocked",
                  cannotBlockLastPlatformAdmin:
                    "Cannot block the last active Platform Admin",
                },
              },
              blockedFilter: {
                all: "All",
                blocked: "Blocked",
                nonBlocked: "Not blocked",
              },
              cancelInvite: {
                title: "Cancel invitation",
                description: (email) =>
                  `Are you sure you want to cancel the invitation for ${email}? They will no longer be able to use this invitation to log in.`,
                confirm: "Cancel invitation",
                action: "Cancel invitation",
              },
              resendInvite: {
                title: "Resend invitation",
                description: (email) =>
                  `Are you sure you want to resend the invitation to ${email}?`,
                confirm: "Resend invitation",
                action: "Resend invitation",
                success: "Invitation resent",
              },
              dataEditor: {
                action: "Data Editor",
                title: "Users",
                inviteInProgress:
                  "We're sending the invitations you've added. This might take a moment.",
                inviteResult: ({ invited, total }) =>
                  `${invited} of ${total} invitations sent successfully`,
              },
            },
            userId: {
              page: {
                joined: "Joined",
                chooseRole: "Choose role",
                selectRole: "Select role",
                assignedAt: "Date assigned",
                assignedBy: "Assigned by",
                otherRole: "Add another role",
                duplicatedRoles:
                  "You cannot select the same role more than once.",
                uploadFailed: "Failed to update roles",
                loading: "Loading roles...",
                platformRoles: "Platform roles",
                rolesUpdatedSuccessfully: "Roles updated successfully",
                noRoles: {
                  title: "This user doesn't have any roles yet",
                  text: "Assign roles to define what this user can access and manage",
                },
                pendingInvitation: {
                  title: "This user hasn't accepted the invitation yet",
                  text: "Access and permissions will be available once the user joins the platform",
                  action: "Back to all users",
                },
                assignNewRole: "Assign new role",
                updateEmail: {
                  editAriaLabel: "Edit email",
                  title: "Update email",
                  description:
                    "Enter the new email address for this user. The change takes effect immediately.",
                  emailLabel: "Email",
                  emailPlaceholder: "name@example.com",
                  successTitle: "Email updated",
                  errors: {
                    required: "Email is required",
                    invalid: "Enter a valid email address",
                  },
                },
              },
            },
          },
        },
        passwordReset: {
          requestId: {
            page: {
              resetPassword: {
                title: "Set a new password",
                password: {
                  label: "Your new password",
                  placeholder: "Enter new password",
                },
                confirmPassword: { label: "Repeat new password" },
                passwordHint: "Must be at least 8 characters",
                submit: "Change password",
                cancel: "Back to log in",
              },
            },
          },
        },
        invitation: {
          admin: {
            invitationId: {
              page: {
                invitationAcceptance: {
                  success: (roleName) => `You are now ${roleName}!`,
                  failure:
                    "The user invitation verification failed, contact your inviter to request a new invitation",
                },
              },
            },
          },
        },
        emailVerification: {
          verificationId: {
            page: {
              verification: {
                success: (email) => `Your email ${email} is now verified!`,
                failure: "The email verification failed",
              },
            },
          },
        },
        chats: {
          page: {
            title: "Chats",
            search: "Search your insights...",
            history: "History",
            allChats: "All Chats",
            reports: "Reports",
            newChat: "New chat",
            threads: {
              count: (count) =>
                `You have ${{ [1]: `1 previous chat.` }[count] ?? `${count} previous chats.`}`,
              empty: {
                noThreadsSearch: "No threads found.",
                noReportsSearch: "No reports found.",
                starter: {
                  noThreadsMessage:
                    "Start a chat to explore insights, summaries, or answers.",
                },
              },
              loading: "Loading more...",
              menu: {
                documents: "Files",
                rename: "Rename",
                star: "Star",
                unstar: "Unstar",
                delete: "Delete",
              },
              modal: {
                rename: {
                  title: "Rename chat",
                  placeholder: "Enter new chat title",
                  emptyError: "Title cannot be empty",
                },
                delete: {
                  title: "Delete chat",
                  description: "Are you sure you want to delete this chat?",
                },
              },
              toast: {
                starred: "Thread starred",
                unstarred: "Thread unstarred",
                renamed: "Conversation renamed successfully",
                deleted: "Conversation deleted",
                updateFailed: "Failed to update thread",
                deleteFailed: "Failed to delete chat",
              },
              documents: {
                title: "Files from chat",
                description: "Download your exported files and reports",
                error: "Failed to load documents",
                empty: {
                  title: "No documents yet",
                  description:
                    "Documents exported from this chat will appear here",
                },
              },
            },
          },
        },
        tasks: {
          title: "Tasks",
          list: {
            yourTasksLabel: "You",
            allTasksLabel: "All",
            searchPlaceholder: "Search keyword, category, assignee...",
            filters: "Filters",
          },
          noItems: { text: "No tasks available" },
          noSelection: {
            title: "No task selected",
            text: "Select a task to view task details",
          },
          escalated: "Escalated",
          untitled: "Untitled task",
          types: {
            PaymentEntity: "Payments",
            MarketOrderEntity: "Market orders",
            CompanyVerificationEntity: "KYB requests",
            KycRequestEntity: "KYC requests",
            ManualTaskEntity: "Manual tasks",
            ProductAssignmentSubscriptionRequestEntity: "Subscription requests",
            AttributesCorrectionsRequestEntity: "Correction requests",
          },
          taskTitle: {
            MarketOrderEntity: ({ type, amount, employeeName, companyName }) =>
              `${type} market order of ${amount} for ${employeeName} at ${companyName}`,
            MarketOrderEntityUnits: ({
              type,
              amount,
              employeeName,
              companyName,
            }) =>
              `${type} market order of ${amount} units for ${employeeName} at ${companyName}`,
            CompanyVerificationEntity: (companyName) =>
              `KYB documents from ${companyName}`,
            KycRequestEntity: (employeeName) =>
              `KYC identity verification for ${employeeName}`,
            ManualTaskEntity: "Manual tasks",
            ProductAssignmentSubscriptionRequestEntity: (employeeName) =>
              `Subscription request from ${employeeName}`,
            AttributesCorrectionsRequestEntity: (employeeName) =>
              `Request to update employee details from ${employeeName}`,
            ContributionPaymentEntity: ({ amount, companyName }) =>
              `Contribution payment of ${amount} for ${companyName}`,
            AdjustmentPaymentEntity: ({ amount, companyName }) =>
              `Adjustment payment of ${amount} for ${companyName}`,
            WithdrawalPaymentEntity: ({ amount, employeeName }) =>
              `Withdrawal payment of ${amount} for ${employeeName}`,
            FeeDistributionEntity: (amount) => `Fee distribution of ${amount}`,
            FeePayoutEntity: ({ amount, companyName }) =>
              `Fee payout of ${amount} for ${companyName}`,
            marketOrderType: { buy: "Buy", sell: "Sell", switch: "Switch" },
          },
          statuses: {
            inReview: "In review",
            inProgress: "In progress",
            completed: "Completed",
          },
          urgency: {
            overdue: (count) =>
              `${{ [1]: `1 day overdue` }[count] ?? `${count} days overdue`}`,
            due: (d) => `Due ${d}`,
            noDueDate: "No due date",
          },
          priorities: { low: "Low", medium: "Medium", high: "High" },
          createTask: {
            title: "Create new task",
            submit: "Create task",
            taskTitle: "Task title",
            taskTitlePlaceholder: "e.g. Confirm payment for ABC",
            taskDescription: "Task description",
            taskDescriptionPlaceholder:
              "e.g. Make payment of AED 1,500.00, then upload the proof of payment.",
            assignee: "Assignee",
            assigneePlaceholder: "Select assignee",
            successMessage: "Task created successfully",
            addTask: "Add task",
          },
          filters: {
            filterTasks: "Filter tasks",
            sortBy: "Sort by",
            issueDate: "Issue date",
            priority: "Priority",
            taskTypes: "Task types",
            taskStatus: "Task status",
            assignees: "Assignees",
            assigneesPlaceholder: "Search name or role",
            assignedBy: "Assigned by",
            assignedByPlaceholder: "Search name or role",
            companies: "Companies",
            companiesPlaceholder: "Search company",
          },
        },
        taskDetails: {
          title: "Task details",
          escalate: "Escalate task",
          escalateTitle: "Escalate this task?",
          escalateDescription:
            "Are you sure you want to escalate this task? Escalating this task will notify the assignee and flag this task permanently until it is closed.",
          filesAndLinks: {
            label: "Files and links",
            files: "Files",
            links: "Links",
            noFiles: "No files yet",
            noLinks: "No links yet",
          },
          submitTaskForReview: "Submit task for review?",
          submittedForReview: "Submitted for review",
          markTaskAsCompleted: "Mark task as completed?",
          submitTaskForReviewDescription:
            "The creator of this task will be notified and you will no longer be able to make changes.",
          markTaskAsCompletedDescription:
            "This task will be marked as done and you will no longer be able to make changes.",
          backToAllTasks: "Back to all tasks",
          assigneeTooltip: "Choose an assignee for this task",
          priorityTooltip: "Choose a priority for this task",
          tabs: {
            taskDetails: "Task details",
            paymentDetails: "Payment details",
            confirmPayment: "Confirm payment",
            actionRequired: "Action required",
            marketOrderDetails: "Market order details",
            reviewDocuments: "Review documents",
            activityAndComments: "Activity and comments",
            activity: "Activity",
            uploadDocuments: "Upload documents",
            reviewDetails: "Request details",
            companyDetails: "Company details",
            employeeDetails: "Employee details",
            reviewChanges: "Review changes",
          },
          subscriptionRequest: {
            title: "Request details",
            employee: "Employee",
            companyName: "Company name",
            type: "Type",
            amount: "Amount",
            dateAdded: "Created on",
            typeRecurrent: "Monthly payment",
            typeOneTimePayment: "Lump-sum payment",
          },
          category: "Category",
          taskStatus: "Task status",
          priority: {
            label: "Priority",
            low: "Low",
            medium: "Medium",
            high: "High",
          },
          activityAndComments: {
            writeAComment: "Write a comment...",
            send: "Send",
            attachFile: "Attach a file",
            addedAComment: "added a comment",
            you: "You",
            user: "User",
            removeFile: "Remove file",
            downloadFile: "Download file",
            failedToPreviewFile: "Failed to preview file",
            activity: {
              taskCreated: "Task created ",
              taskCreatedVia: "via",
              requestedVia: {
                requestedVia: "Requested via",
                Contribution: "Contribution",
                Withdrawal: "Withdrawal",
                FundSwitch: "Fund Switch",
              },
              statusChanged: "Task status changed to ",
              assigneeChanged: "Task assigned to ",
              submittedForReview: " submitted documents for review",
              escalated: " escalated the task",
              escalatedAutomatically: "Task was escalated automatically",
              markedAsCompleted: " marked the task as completed",
              reviewerChanged: "Task reviewer is assigned to ",
              taskClosed: "Task closed",
              documentsUploaded: "New documents uploaded",
              resubmissionRequested: " requested a resubmission of documents",
              correctionAccepted: " accepted an update request",
              correctionRejected: " rejected an update request",
              correctionResolved: " resolved an update request",
            },
          },
          reviewDocuments: {
            reviewDocuments: "Review documents",
            reviewCompanyDocuments: "Review company documents",
            reviewSignatoryDocuments: "Review signatory documents",
            downloadAllDocuments: "Download all",
            signatory: "Signatory",
            documents: "Documents",
            openInNewTab: "Open in new tab",
            downloadDocument: "Download document",
          },
          assignee: "Assignee",
          unAssigned: "Unassigned",
          reviewer: "Reviewer",
          taskStatusUpdated: "Task status updated successfully",
          kyb: {
            noDocumentsYet: "No documents yet",
            noDocumentsYetDescription:
              "Documents will appear here once the assignee has submitted documents for review.",
            uploadCompanyDocuments: "Upload company documents",
            uploadSignatoryDocuments: "Upload signatory documents",
            submitForReview: "Submit for review",
            submittedForReview: "Submitted for review",
            documentsInReview:
              "Your documents have been submitted and are being reviewed",
            documentsRetry:
              "The reviewer requested a resubmission of documents",
            additionalDocumentsRequired:
              "The reviewer requested additional documents",
            rejected:
              "Your company could not be verified. Your documents were reviewed and rejected.",
            approved:
              "Congratulations! Your documents were approved and your business has been verified.",
            goToDashboard: "Go to dashboard",
            documentRequiresResubmission: "Resubmission required",
            resubmittedForReview: "Resubmitted for review",
            additionalDocumentRequired: "Additional document required",
            addSignatory: "Add signatory",
            requestMoreDocuments: "Request more documents",
            requestMoreDocumentsDescription:
              "The submitted documents are insufficient. The company admin will be asked to submit additional documents.",
            resubmit: "Request resubmission",
            resubmitDescription:
              "The submitted documents are incorrect. The company admin will be asked to resubmit corrected documents.",
            reject: "Reject verification request",
            rejectDescription:
              "The submitted documents are invalid and cannot be accepted.",
            approve: "Approve and complete",
            approveDescription:
              "The submitted documents are valid and can be accepted.",
            confirmButton: "Confirm decision",
            actionRequired: "Action required",
            requestedResubmission:
              "You have requested a resubmission of documents.",
            requestedResubmissionDescription:
              "You will be notified when the assignee has submitted documents for review.",
            rejectedCompanyVerification:
              "You have rejected the verification request and the company admin has been notified.",
            requestedMoreDocuments: "You have requested for more documents.",
            requestedMoreDocumentsDescription:
              " You will be notified when the assignee has submitted documents for review.",
            approvedCompanyVerification:
              "You have approved the verification request and the company admin has been notified.",
            updateSignatories: "Update signatories",
            signatoryDocumentsUpdated:
              "Signatory documents updated successfully",
            failedToUpdateSignatories: "Failed to update signatories",
            companyDocuments: "Company documents",
            signatoryDocuments: "Signatory documents",
            downloadDocument: "Download document",
            noDocumentsSubmitted: "No documents submitted",
            noDocumentsSubmittedDescription:
              "No documents submitted for this task.",
            companyDetails: {
              title: "Company details",
              name: "Company name",
              tradeLicenseNumber: "Trade license number",
            },
          },
          marketOrder: {
            title: "Market order details",
            fundDetails: "Fund details",
            orderDetails: "Order details",
            executionDetails: "Execution details",
            fundName: "Fund name",
            fundClass: "Fund class",
            amount: "Amount",
            fundIsin: "Fund ISIN",
            companyName: "Company name",
            type: "Type",
            createdOn: "Created on",
            transferedBy: "Transfered by",
            dueOn: "Due on",
            status: "Market order status",
            confirm: {
              title: "Confirm market order",
              description:
                "Process the market order and upload the receipt with the execution details to confirm the transaction.",
              button: "Confirm market order",
              success: "Market order confirmed successfully",
            },
            receipt: "Receipt",
            saleReceipt: "Sale receipt",
            purchaseReceipt: "Purchase receipt",
            marketOrderDate: "Market order date",
            unitPrice: "Unit price",
            assetQuantity: "Asset quantity",
            unitPricePlaceholder: "Enter unit price",
            uploadReceipt: "Upload receipt",
            uploadReceiptDescription:
              "The file must be a PDF, JPG or DOCS (max. 5MB)",
            dateIsRequired: "Date is required",
            invalidNumber: "Invalid number",
            numberIsRequired: "Number is required",
            fileIsRequired: "File is required",
            executedOn: "Executed on",
            unitsSold: "Units sold",
            totalUnitsToSell: "Total units to sell",
            unitsBought: "Units bought",
            switch: {
              sellMarketOrderDate: "Sell market order date",
              buyMarketOrderDate: "Buy market order date",
              unitPriceSold: "Unit price sold",
              unitPriceBought: "Unit price bought",
              totalAmountSold: "Total amount sold",
              uploadSaleReceipt: "Upload sale receipt",
              uploadPurchaseReceipt: "Upload purchase receipt",
            },
          },
          kyc: {
            uploadDocuments: "Upload documents",
            reviewEmployeeDocuments: "Review employee documents",
            documentsInReview:
              "Your documents have been submitted and are being reviewed",
            submitForReview: "Submit for review",
            rejected: "Your documents were reviewed and rejected.",
            approved:
              "Your documents were approved and verification is complete.",
            goToRequest: "Go to request",
            requestedResubmission:
              "The reviewer requested a resubmission of documents.",
            rejectedVerification:
              "You have rejected the verification request and the employee has been notified.",
            approvedVerification:
              "You have approved the verification request and the employee has been notified.",
            requestedMoreDocuments: "You have requested for more documents.",
            requestedMoreDocumentsDescription:
              "You will be notified when the employee has submitted documents for review.",
            requestedResubmissionTitle:
              "You have requested a resubmission of documents.",
            requestedResubmissionDescription:
              "You will be notified when the employee has submitted documents for review.",
            approve: "Approve and complete",
            approveDescription:
              "The submitted documents are valid and can be accepted.",
            resubmit: "Request resubmission",
            resubmitDescription:
              "The submitted documents are incorrect. The employee will be asked to resubmit corrected documents.",
            reject: "Permanently reject - no retry allowed",
            rejectDescription:
              "The submitted documents are invalid and cannot be accepted. The employee will be notified of final rejection and cannot resubmit",
            cancelAndClose: "Cancel and close task",
            cancelAndCloseDescription:
              "Close the document verification process without completion.",
            confirmButton: "Confirm decision",
            actionRequired: "Action required",
            documentRequiresResubmission: "Resubmission required",
            resubmittedForReview: "Resubmitted for review",
            documentType: {
              identity: "Identity document",
              proofOfAddress: "Proof of address",
              identityDescription:
                "Official government-issued ID (Emirates ID, passport, or UAE driving license).",
              proofOfAddressDescription:
                "Recent documents showing the individual's physical residential address (Ejari, utility bill, or bank statement). The document must be dated within the last three months.",
            },
            requestMoreDocuments: "Request more documents",
            requestMoreDocumentsDescription:
              "The submitted documents are insufficient. The employee will be asked to submit additional documents.",
            reset: "Reset submission",
            resetDescription:
              "Return the submission to the employee without completing the verification.",
          },
          payment: {
            title: "Payment details",
            paymentType: "Payment type",
            paymentTypes: {
              ContributionPaymentEntity: "Contributions",
              AdjustmentPaymentEntity: "Adjustments",
              WithdrawalPaymentEntity: "Withdrawals",
              FeeDistributionEntity: "Fee distribution",
              FeePayoutEntity: "Fee payout",
            },
            sender: "Sender",
            recipient: "Recipient",
            paymentId: "Payment ID",
            taxAmount: "Tax amount",
            invoice: "Invoice",
            downloadInvoice: "Download invoice",
            downloadReceipt: "Download receipt",
            referenceNumber: "Reference number",
            iban: "IBAN",
            accountName: "Account name",
            swiftCode: "SWIFT code",
            branchName: "Branch name",
            branchAddress: "Branch address",
            amount: "Amount",
            createdOn: "Created on",
            paymentForMonth: "Payment for month",
            status: "Payment status",
            confirm: {
              note: "The submitted payment receipt is verified and accepted.",
              button: "Confirm payment",
              description:
                "Process the payment and upload the payment receipt. Make sure to include the Reference Number in your transfer to avoid payment rejections or delays.",
              decision: "Confirm decision",
              success: "Payment confirmed successfully",
            },
            uploadReceipt: "Upload receipt",
            receipt: "Receipt",
            uploadReceiptDescription:
              "The file must be a PDF, JPG or DOCS (max. 5MB)",
            actionRequired: {
              title: "Action required",
              description:
                "Verify the uploaded receipt and confirm or reject the payment.",
            },
            rejectButton: "Reject payment",
            rejectSuccess: "Payment rejected successfully",
            notePlaceholder:
              "Please provide a reason for rejecting the payment",
            rejectNotePlaceholder:
              "The submitted payment receipt is invalid and cannot be accepted.",
            rejectReasonDialogTitle: "Why are you rejecting this payment?",
            noActionForStatus: "No action available for this payment status.",
            transactionSection: "Transaction",
            senderSection: "Sender",
            recipientSection: "Recipient",
          },
          correction: {
            employeeDetails: {
              title: "Employee details",
              employeeName: "Employee name",
              name: "Full name",
              nationalId: "Emirates ID",
              iban: "IBAN",
              firstName: "First name",
              lastName: "Last name",
              gender: "Gender",
              dateOfBirth: "Date of birth",
              nationality: "Nationality",
              emiratesId: "Emirates ID",
              passportNumber: "Passport number",
              startDate: "Start date",
              endDate: "End date",
              employmentStatus: "Employment status",
              jobTitle: "Job title",
              department: "Department",
              branch: "Branch",
              level: "Level",
              workEmail: "Work email",
              phoneNumber: "Phone number",
              address: "Address",
              basicSalary: "Basic salary",
              fullSalary: "Full salary",
              empty: "Empty",
              mohreManaged:
                "Please contact Ministry of Human Resources & Emiratisation (MOHRE) to update this field.",
              mohreUpdateRequestPrefix: "The employee requested an update to",
            },
          },
        },
        roles: {
          administrative: {
            adminsAndUsers: {
              name: "Admins and users",
              permissions: {
                update: {
                  description:
                    "Allow role to update details of users / admins.",
                  name: "Update users",
                },
                updateEmail: {
                  description:
                    "Allow role to update the email address of users / admins.",
                  name: "Update user email",
                },
                view: {
                  description: "Allow role to view users / admins.",
                  name: "View users",
                },
              },
            },
            companies: {
              name: "Companies",
              permissions: {
                create: {
                  description: "Allow role to add and create new companies.",
                  name: "Create companies",
                },
                dashboard: {
                  description: "Allow role to view company dashboard.",
                  name: "View dashboard",
                },
                viewActivityLog: {
                  description: "Allow role to view activity log.",
                  name: "View activity log",
                },
                list: {
                  description: "Allow role to list companies.",
                  name: "List companies",
                },
                manageBankingDetails: {
                  description: "Allow role to manage company banking details.",
                  name: "Manage banking details",
                },
                update: {
                  description:
                    "Allow role to update details of existing companies.",
                  name: "Update companies",
                },
                view: {
                  description:
                    "Allow role to view companies that have been created.",
                  name: "View companies",
                },
              },
            },
            internalData: {
              name: "Internal Data",
              permissions: {
                manage: {
                  description:
                    "Allow role to access and manage internal platform data.",
                  name: "Manage internal data",
                },
                manageSupportTools: {
                  description:
                    "Allow role to access and use the internal support tools.",
                  name: "Manage support tools",
                },
              },
            },
            name: "Administrative",
            rolesAndPermissions: {
              name: "Roles and permissions",
              permissions: {
                create: {
                  description:
                    "Allow role to create new roles and permissions.",
                  name: "Create roles",
                },
                delete: {
                  description: "Allow role to delete roles and permissions.",
                  name: "Delete roles",
                },
                list: {
                  description: "Allow role to list all roles and permissions.",
                  name: "List roles",
                },
                update: {
                  description:
                    "Allow role to update details of roles and permissions.",
                  name: "Update roles",
                },
                view: {
                  description: "Allow role to view all roles and permissions.",
                  name: "View roles",
                },
              },
            },
          },
          features: {
            benefits: {
              name: "Benefits",
              permissions: {
                approveAndDeposit: {
                  description:
                    "Allow role to approve requests and manage payments.",
                  name: "Approve and deposit benefits",
                },
                create: {
                  description: "Allow role to create and set up new benefits.",
                  name: "Create benefits",
                },
                delete: {
                  description: "Allow role to delete benefits permanently.",
                  name: "Delete benefits",
                },
                update: {
                  description:
                    "Allow role to update details of benefits including benefit criteria and assigned employees.",
                  name: "Update benefits",
                },
                view: {
                  description: "Allow role to view all benefits.",
                  name: "View benefits",
                },
              },
            },
            controlsAndCustomization: {
              name: "Controls and customization",
              permissions: {
                updateBranding: {
                  description:
                    "Allow role to customise colours and theming of platform.",
                  name: "Update branding",
                },
                updateContent: {
                  description:
                    "Allow role to customize all platform content, email content, and translations.",
                  name: "Update platform content",
                },
                updateDocument: {
                  description:
                    "Allow role to add, update and delete platform documents.",
                  name: "Update platform documents",
                },
                updateProduct: {
                  description:
                    "Allow role to enable and disable all platform products.",
                  name: "Update platform products",
                },
                manageForms: {
                  description: "Allow role to add, update, and delete forms.",
                  name: "Update forms",
                },
                managePasswordPolicy: {
                  description: "Allow role to update password policy.",
                  name: "Update password policy",
                },
                manageProductWorkflow: {
                  description:
                    "Allow role to add, update and delete workflows.",
                  name: "Update product workfow",
                },
                manageAuthenticationPolicy: {
                  description: "Allow role to update authentication policy.",
                  name: "Update authentication policy",
                },
                manageTasks: {
                  description:
                    "Allow role to view and manage tasks in Controls.",
                  name: "Manage tasks",
                },
                manageActivityPage: {
                  name: "Manage activity page",
                  description:
                    "Set up which activities appear on the activity pages, what they are called, and who can see them.",
                },
                manageFees: {
                  description:
                    "Allow role to create, update and delete fee types and their workflows.",
                  name: "Manage fees",
                },
                managePaymentCategories: {
                  description:
                    "Allow role to create, update and delete payment categories.",
                  name: "Manage payment categories",
                },
                viewPaymentCategories: {
                  description: "Allow role to view payment categories.",
                  name: "View payment categories",
                },
              },
            },
            complianceAndVerification: {
              name: "Compliance and verification",
              permissions: {
                manageKYB: {
                  description:
                    "Allow role to approve or reject company documents as well as request for additional documents if needed.",
                  name: "Manage KYB documents",
                },
                manageCompanyDocumentType: {
                  description:
                    "Allow role to add, update and delete company document types.",
                  name: "Manage company document type",
                },
                manageKYC: {
                  description:
                    "Allow role to approve or reject employee documents.",
                  name: "Manage KYC documents",
                },
                submitKYB: {
                  description:
                    "Allow role to submit company documents for verification.",
                  name: "Submit KYB documents",
                },
                viewKYB: {
                  description:
                    "Allow role to view company documents and verification requests without taking any action.",
                  name: "View KYB documents",
                },
                viewKYC: {
                  description:
                    "Allow role to view employee documents and verification requests without taking any action.",
                  name: "View KYC documents",
                },
              },
            },
            employees: {
              name: "Employees",
              permissions: {
                create: {
                  description: "Allow role to create new employees.",
                  name: "Create employees",
                },
                invite: {
                  description: "Allow role to invite new employees.",
                  name: "Invite employees",
                },
                list: {
                  description:
                    "Allow role to list all invited, active and inactive employees.",
                  name: "List employees",
                },
                update: {
                  description:
                    "Allow role to update employee details and assign employees to benefits.",
                  name: "Update employees",
                },
                view: {
                  description:
                    "Allow role to view all invited, active and inactive employees.",
                  name: "View employees",
                },
                viewNominees: {
                  description:
                    "Allow role to view an employee's nominated beneficiaries.",
                  name: "View employee beneficiaries",
                },
              },
            },
            holdings: {
              name: "Holdings",
              permissions: {
                view: {
                  description: "Allow role to view all holdings and details.",
                  name: "View",
                },
                adjust: {
                  description:
                    "Allow role to add adjusted entries to holdings.",
                  name: "Adjust holdings",
                },
              },
            },
            marketOrders: {
              name: "Market orders",
              permissions: {
                update: {
                  description: "Allow role to update market order details.",
                  name: "Update market orders",
                },
                view: {
                  description: "Allow role to view all market orders.",
                  name: "View market orders",
                },
                adjust: {
                  description:
                    "Allow role to add adjusted entries to market orders.",
                  name: "Adjust market orders",
                },
              },
            },
            name: "Features",
            payments: {
              name: "Payments",
              permissions: {
                approveAndReject: {
                  description:
                    "Allow role to approve and reject payments made by companies.",
                  name: "Approve and reject payments",
                },
                create: {
                  description: "Allow role to create new company payments.",
                  name: "Create payments",
                },
                makeFundProviderPayment: {
                  description: "Allow role to make fund provider payments.",
                  name: "Make fund provider payments",
                },
                view: {
                  description:
                    "Allow role to view all payments received and made by companies.",
                  name: "View payments",
                },
                viewWithdrawal: {
                  description: "Allow role to view all withdrawals.",
                  name: "View withdrawals",
                },
                manageWithdrawal: {
                  description: "Allow role to execute withdrawals.",
                  name: "Manage withdrawals",
                },
                adjust: {
                  description:
                    "Allow role to add adjusted entries to payments.",
                  name: "Adjust payments",
                },
              },
            },
            reports: {
              name: "Reports",
              permissions: {
                exportAndDownload: {
                  description: "Allow role to export and download all reports.",
                  name: "Export and download reports",
                },
                view: {
                  description: "Allow role to view all reports available.",
                  name: "View reports",
                },
              },
            },
            aiAssistant: {
              name: "AI Assistant",
              permissions: {
                manage: {
                  description: "Allow role to interact with AI Assistant.",
                  name: "Manage AI Assistant",
                },
              },
            },
          },
          platformPermissions: "Platform permissions",
          companyPermissions: "Company permissions",
          defaultRoles: "Default roles",
          customRoles: "Custom roles",
          createRole: "Create role",
          empty: { title: "No roles found" },
          manage: {
            toast: (count) =>
              `You’ve hidden ${count} companies from this role.`,
            hideCompanies: "Hide companies from role",
            companiesSelected: (count) => `${count} companies selected`,
            chooseCompanies:
              "Choose the companies, if any, that you wish to hide from this role. Users assigned to this role will not be able to view the selected companies or have access to any of its data.",
            backToRoles: "Back to roles",
            editRole: "Edit role",
            createRole: "Create role",
            roleDetails: "Role details",
            roleName: "Role name",
            description: "Description",
            setPermissions: "Set permissions",
            setRestrictions: "Set restrictions",
            seeAllCompanies: "See all companies",
            save: "Save",
            nextStep: "Next Step",
            enableAll: "Enable all",
          },
          delete: {
            userRequired: "Please select at least one user",
            reassignUsers: "Reassign users",
            reassignUsersDescription: ({ usersCount, roleName }) =>
              `${{ [1]: `1 user` }[usersCount] ?? `${usersCount} users`} assigned to ${roleName}`,
            noUsersAssigned:
              "You no longer have any users assigned to this role.",
            continueAndDelete: (roleName) =>
              `You may proceed to continue and delete ${roleName}.`,
            reassignUsersButton: (usersCount) =>
              `Reassign users (${usersCount})`,
            deleteRoleButton: "Delete role",
            removeUserFromRole: "Remove user from role",
            title: "Danger zone",
            confirm: "Permanently delete this role",
          },
          invite: {
            errors: {
              selectRole: "Please select a role",
              selectCompany: "Please select a company",
            },
            selectPermissionsGroup: "Select Permissions group",
            platformPermissions: {
              hint: "Users will have access to all permissions and platform features available. You should only invite people you fully trust.",
              label: "Platform permissions",
            },
            companyPermissions: {
              hint: "Users with company permissions will be limited to a select number of features based off specific company settings.",
              label: "Company permissions",
            },
            assignUsersToRole: "Assign users to role",
            company: { label: "Company", placeholder: "Select a company" },
            role: { label: "Role", placeholder: "Select a role" },
          },
        },
        activity: {
          page: {
            allTypes: "All types",
            columns: {
              status: "Status",
              type: "Type",
              companyEmployee: "Company / Employee",
              employee: "Employee",
              date: "Date",
            },
            companyIntro:
              "Track every stage of this company's activity, from the money arriving to it reaching employee accounts.",
            empty: "Nothing to show yet.",
            inProgress: "In progress",
            pastActivity: "Past activity",
            platformIntro:
              "Track every stage of an activity across all companies, from the money arriving to it reaching employee accounts.",
            searchPlaceholder: "Search company or employee...",
            stageCompleted: "Completed",
            stageInProgress: "In progress",
            stageUpcoming: "Upcoming",
            stepOf: ({ step, total }) => `Step ${step} of ${total}`,
            viewActivity: "View activity",
          },
        },
      },
      translationsPanel: {
        platformText: "platform text.",
        toEdit:
          "To edit more content such as navigation, onboarding, or pages of the employee platform, go to ",
      },
      translationMode: {
        editTextOnPage: "Edit text on page",
        finishEditing: "Finish editing",
        modal: {
          title: "Edit text",
          currentValue: "Current value",
          affectedKey: "Affected key",
          affectedKeys: "Affected keys",
          newValue: "New value",
          newValuePlaceholder: "Enter new translation...",
          cancel: "Cancel",
          saveChanges: "Save changes",
          errorSaving: "Failed to save translation",
          keyRequired: "At least one translation key is required",
          valueRequired: "Translation value is required",
        },
      },
      validation: {
        list: {
          intro: "Password must include:",
          capitalLetter: "uppercase letter",
          lowercaseLetter: "lowercase letter",
          number: "number",
          specialCharacter: "special character",
          minimumLength: (min) => `minimum ${min} characters`,
        },
        date: {
          invalid: "Date is invalid",
          invalidFormat: "Must be DD/MM/YYYY",
          required: "Date is required",
        },
        email: { format: "Email is invalid", required: "Email is required" },
        employmentStatus: {
          invalid:
            "Invalid Employment status. Must be Permanent, Contract or Temporary",
        },
        nationalId: {
          required: "Emirates ID is required",
          format: "Must be a valid Emirates ID",
        },
        endDate: { invalid: "End date must be after start date" },
        gender: { invalid: "Invalid Gender. Must be Male or Female" },
        iban: { invalid: "Invalid IBAN", notUAE: "Only UAE IBANs are allowed" },
        nationality: {
          invalid: "Nationality must be capitalized and existing",
          invalidWithHint: (hint) => `Did you mean ${hint}?`,
        },
        number: {
          negativeOrInvalid:
            "Numbers must be in the format 10000.00 with numbers only and can be to 2 decimal places",
        },
        password: {
          minLength: "Must be at least 8 characters",
          required: "Password is required",
          match: "Your passwords do not match",
          weak: "This password is too weak. Add more complexity to make it a stronger password",
        },
        fullName: { minLength: "Full name must be at least 1 character" },
        preferredName: {
          minLength: "Preferred name must be at least 1 character",
        },
      },
      chatAI: {
        suggestedQuestions: [
          "How many employees are currently active in the first company created?",
          "What benefits are available to employees for all companies?",
          "Show me recent payments summaries for my companies.",
          "What are the latest market trends?",
        ],
        reports: {
          platform: {
            onboardingStatus:
              "Create a report showing the onboarding status of all companies",
            contributions12m:
              "Create a report showing total contributions over the last 12 months",
            withdrawals12m:
              "Create a report showing total withdrawals over the last 12 months",
          },
          company: {
            employeeContributions3m:
              "Create a report of all employee contributions over the last 3 months",
            benefitsAssignments:
              "Create a report listing all benefits with their assigned employees",
            pendingPayments: "Create a report listing all pending payments",
          },
        },
        reportTemplates: {
          contributions: {
            name: "Contributions and cash",
            description:
              "Generate comprehensive contribution and cash flow analysis",
            prompt:
              "Generate a comprehensive contributions and cash flow analysis report including all contribution types and cash transactions",
          },
          marketOrders: {
            name: "Market orders",
            description: "Generate market orders and trading activity report",
            prompt:
              "Generate a detailed market orders report including trading activities, positions, and market performance",
          },
          withdrawals: {
            name: "Withdrawals",
            description:
              "Generate withdrawal transactions and processing report",
            prompt:
              "Create a withdrawal report showing all withdrawal transactions, processing status, and compliance details",
          },
          benefitEmployees: {
            name: "Benefit employees",
            description:
              "Generate employee benefits enrollment and eligibility report",
            prompt:
              "Generate a benefit employees report showing enrollment status, eligibility, and benefits coverage details",
          },
        },
        ui: {
          assistantTitle: "AI Assistant",
          askQuestionsTitle: "Ask a question",
          reportTemplatesTitle: "Generate reports",
          inputPlaceholder: "Ask me anything...",
          stopResponse: "Stop response",
          modeAuremAgent: "Aurem agent",
          modeGeneralInquiries: "General inquiries",
          viewRawJSON: "View raw JSON",
          showingRows: ({ maxRows, total }) =>
            `Showing first ${maxRows} of ${total} rows.`,
          close: "Close",
          requestExportToViewAll: "Request export to view all records",
          viewAllChat: "View all chats",
          emptyThreadTitle: "What can I help you with today?",
          emptyThreadSubtitle: "Ask a question or generate a report",
        },
        messages: {
          noReport: {
            summary: "No report generated",
            reasoning:
              "The assistant could not create a report for your query.",
          },
          errors: {
            executionLimit:
              "The AI assistant ran out of execution steps while processing your request.",
            llmValidation: "The AI assistant encountered a formatting issue.",
            workflowState: "This request has already been processed.",
            dataProcessing: "An error occurred while processing your data.",
            timeout: "Your request took too long to process.",
            rateLimit:
              "The AI service is currently at capacity. Please wait a moment before retrying.",
            unexpected: "An unexpected error occurred.",
            cancel: {
              summary: "Request Cancelled",
              reasoning: "You stopped the request before it completed.",
            },
            retryPrompt: "Want me to retry?",
            retryCta: "Yes, retry",
            toast: {
              fetchFailed: "Failed to fetch conversation updates",
              sendFailed: "Failed to send message",
              cancelFailed: "Failed to cancel message",
              loadingFailed: "Failed to load chat",
            },
          },
          processStates: {
            analyzing: "Analyzing your request...",
            generating: "Generating response...",
            processing: "Processing...",
            thinking: "Thinking...",
            exportingResults: "Exporting results...",
          },
        },
      },
      marketOrderPriceConfirmation: {
        title: "Confirm the price",
        description:
          "Check the price you entered against the last price we have on record before this is executed.",
        fundIsin: "Fund ISIN",
        entered: "Price entered",
        lastKnown: "Last known price",
        difference: "Difference",
        noPreviousPrice: "No previous price",
        unitPrice: "Unit price",
        soldPrice: "Price sold at",
        boughtPrice: "Price bought at",
        confirm: "Confirm and execute",
      },
    },
    employee: {
      common: {
        add: "Add",
        back: "Back",
        continue: "Continue",
        currency: "AED",
        confirm: "Confirm",
        date: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
        monthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateFull: (d) =>
          `${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}`,
        dateShort: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short" })}`,
        dateMonthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateMonthShort: (d) => `${d.toLocaleString(L, { month: "short" })}`,
        next: "Next",
        loading: "Loading",
        fullName: ({ first, last }) => `${first} ${last}`,
        money: (amount) =>
          `${amount.toLocaleString(L, { style: "currency", currency: "AED", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        moneyUpDown: ({ amount, sign }) =>
          `${{ [1]: `Up by ${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "never", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, [-1]: `Down by ${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "never", minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }[sign] ?? ``}`,
        percentSign: (percent) =>
          `${percent.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
        unexpectedError: {
          title: "Unexpected error occured",
          description:
            "Something has gone wrong. Send us an email so we can make sure it doesn't happen again",
        },
        saveSuccessful: "Changes saved successfully",
        moneySign: (amount) =>
          `${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "exceptZero", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        percent: (percent) =>
          `${percent.toLocaleString(L, { style: "percent" })}`,
        fromName: (name) => `From ${name}`,
        remove: "Remove",
        noDocuments: "No documents available",
        voluntarySubscription: "Voluntary subscription",
        requested: "Requested",
        dueBy: "Due by",
        completed: "Completed",
        rejected: "Rejected",
        pending: "Pending",
        save: "Save changes",
        cancel: "Cancel",
        withdraw: "Withdraw",
        accept: "Accept",
        reject: "Reject",
        supportEmail: "support@aurem.ae",
        needHelp: "Need help?",
        contactSupport: "Contact support",
        passwordHint: "Must be at least 8 characters",
        logIn: "Log in",
        optional: "Optional",
        fieldIsRequired: "Field is required",
      },
      navigation: {
        back: "Back",
        dashboard: "Dashboard",
        subscriptions: "Subscriptions",
        transactions: "Transactions",
        withdraw: "Withdraw",
        LogOut: "Logout",
        termsAndConditions: "Terms and conditions",
        confirmYourDetails: "Confirm your details",
        inactiveCurrency:
          "Currency switch is not available at the moment due to technical issues.",
        contributions: "Contributions",
        settings: {
          title: "Settings",
          accountDetails: "Account details",
          security: "Security",
          verification: "Verification",
          beneficiaries: "beneficiaries",
          biometrics: "Biometrics",
          documents: "Documents",
          dataAndPrivacy: "Data and privacy",
        },
        subFunds: "Sub-funds",
        avs: "End of service benefits",
        retirement: "Retirement",
        benefit: "Benefits",
        funds: "Funds",
        menu: "Menu",
        overview: "Overview",
        statements: "Statements",
        support: "Support",
      },
      components: {
        errorBoundary: {
          heading: "Please try again",
          description:
            "Unexpected error ocurred. Please try to clear the browser cache and reload the page",
          reload: "Try again",
        },
        postTerminationWithdrawal: {
          youNowLeft: "You've now left",
          theCompany: "the company",
          moveSubscription: (date) =>
            `Please note that we will automatically move basic subscriptions from your employer on ${date} to your voluntary subscriptions. Alternatively, you may also withdraw all basic subscriptions now.`,
          withdrawBasicSubscriptions: "Withdraw basic subscriptions",
          confirmWithdrawal: "Confirm withdrawal",
          totalBasicSubscriptions: "Total basic subscriptions",
          pleaseConfirm:
            "Please confirm that you would like to withdraw all basic subscriptions from your employer now.",
          amountWillBe:
            "This amount will be transferred to a bank account of your choice after verification checks are completed.",
        },
        benefitNotAssigned: {
          title: "No benefits assigned",
          description:
            "You’re not currently assigned to any benefits and cannot access the platform at this stage. Contact your employer if you have any questions or need support.",
        },
        noProductModal: {
          title: "You have no active products in this company",
          description:
            "You’re not currently assigned to any products and cannot take any action within this company. Contact your employer if you have any questions or need support.",
          cta: "Back to Overview",
        },
        verificationBanner: {
          success: {
            title: "Your documents have been successfully verified.",
            description: "You can now access all features on the platform.",
          },
          pending: {
            title: "Your documents are being reviewed.",
            description:
              "You’ll be notified via email once your documents are verified.",
          },
          rejected: {
            title: "Verification unsuccessful.",
            description:
              "We're unable to verify your identity at this time. Please contact our support team for assistance.",
            pageDescription:
              "Your identity verification was not approved. For more information on the reason for this decision and next steps, please contact your administrator.",
          },
          required: {
            title: "Verification is required.",
            description:
              "We need to confirm a few details about you before you can use all features.",
          },
          retry: {
            title: "Verification unsuccessful.",
            description:
              "Ensure that your documents are clear, valid, and match your account information.",
          },
          note: "Your verification documents must be approved before you can confirm or edit your voluntary subscription.",
          cta: {
            procced: "Proceed to verification",
            pending: "Verification in progress",
            dissmiss: "Dismiss",
            submit: "Submit documents",
            resubmit: "Resubmit documents",
          },
          confirm: {
            title: "Start verification now?",
            cta: "Yes, start verification",
            cancel: "Not now",
            contribution:
              "You only need to verify your documents if you want to make a voluntary subscription now. If you are not ready yet, you can come back and start this at any time.",
            withdrawal:
              "You only need to verify your documents if you want to make a withdrawal now. If you are not ready yet, you can come back and start this at any time.",
            fundSwitch:
              "You only need to verify your documents if you want to change your sub-fund now. If you are not ready yet, you can come back and start this at any time.",
            default:
              "You only need to verify your documents if you want to continue with this request now. If you are not ready yet, you can come back and start this at any time.",
          },
        },
        blockedBenefitsBanner: {
          description:
            "Your participation in this benefit has ended. You can still withdraw your voluntary contributions at any time.",
        },
        oneTime: "One-time payment",
        cookie: {
          description:
            "We use cookies to enhance your browsing experience. By continuing to use our site, you agree to our use of cookies.",
        },
      },
      form: {
        email: { label: "Email" },
        password: { label: "Password" },
        passwordConfirm: { label: "Confirm password" },
      },
      pages: {
        landing: {
          page: {
            welcome: (name) => `Welcome to ${name}`,
            description:
              "Bringing retirement and wealth to a new era and helping you achieve a better financial future",
            getStarted: " Get started",
            alreadyHaveAccount: "I already have an account",
          },
        },
        overView: {
          title: "Hello",
          heading: "Overview",
          avs: "End of Service Benefits",
          allotted: "Allotted",
          consumed: "Consumed",
          remaining: "Remaining",
          category: "Category",
          depositCompany: "Basic subscriptions",
          depositSalary: "Voluntary subscriptions",
          depositSalaryLumpsum: "Lumpsum",
          depositUser: "Deposit",
          withdrawal: "Withdrawals",
          fees: "Fees",
          moneyIn: "Money in",
          moneyOut: "Money out",
          completedOn: "Completed on",
          requestedOn: "Requested on",
          placeholder: "Enter total amount",
          noEmployment: "No employments with active benefits found.",
          errorEmployment: "Error loading employments. Please try again",
          success: "Your contribution  has updated successfully.",
          ipp: "International Pension Plan",
          addMoney: {
            title: "Add money",
            subtitle: "Which benefit do you want to edit or add to?",
            addOrEdit: "Edit or add to your subscriptions",
            voluntary: "Voluntary",
            onetime: "One-time",
            percent: "of your salary",
            addingMoneyTo: "Adding money to",
            max: "Max",
            maxExceeded: ({ maxPercent, salaryAttributeLabel }) =>
              `The amount entered exceeds the allowed limit. The maximum voluntary contribution is ${maxPercent.toLocaleString(L, { style: "percent" })} of your monthly ${salaryAttributeLabel}.`,
            yourSalary: "Your salary calculations",
            payrollImpact: "This month's salary impact",
            salaryBeforeSubscriptions: "Salary before subscriptions",
            salaryBeforeContribution: "Salary before contribution",
            yourMonthlyContributions: "Your monthly contributions",
            yourLumpSum: "Your lump-sum",
            yourOneTimePayment: "Your one-time payment",
            existingMonthlyContribution: "Existing monthly contribution",
            existingLumpSum: "Existing lump-sum",
            netSalary: "Net salary",
            netSalaryTooltip: (ibanSuffix) =>
              `After your contributions, this is what you will receive in your account ending with ${ibanSuffix} this month.`,
            netSalaryTooltipNoIban:
              "After your contributions, this is what you will receive in your account this month.",
            toBePainIntoYourAccountEndingWith:
              "to be paid into your account ending with",
            confirm: "Confirm",
            confirmPayment: "Confirm payment",
            info: "By confirming, you acknowledge that you understand the nature and risks of the investment and confirm that you have reviewed the relevant fund documentation made available to you.",
            monthly: "Monthly",
            contributing: "Contributing",
            lumpsum: "Lump-sum",
            lumpSumPayment: "Lump-sum payment",
            lumpSumMaxExceeded: (maxAmount) =>
              `The amount entered exceeds the allowed limit. The maximum lump-sum contribution is ${maxAmount}.`,
            limitProgressSummary: ({ percentage, remainingAmount }) =>
              `This brings you to ${percentage}% of your annual limit, with ${remainingAmount} remaining.`,
            limitProgressSummaryMonthly: ({ percentage, remainingAmount }) =>
              `This brings you to ${percentage}% of your monthly limit, with ${remainingAmount} remaining.`,
            remainingOf: (totalAmount) => `of ${totalAmount}`,
            annualLimitBanner: {
              title: "You've reached your annual contribution limit",
              description: (annualCap) =>
                `Your total contributions have reached ${annualCap}, which is the maximum allowed for this year. No further monthly or lump-sum contributions can be made until the next annual cycle.`,
              descriptionMonthlyOnly: (annualCap) =>
                `Your total contributions have reached ${annualCap}, which is the maximum allowed for this year. No further monthly contributions can be made until the next annual cycle.`,
              descriptionLumpSumOnly: (annualCap) =>
                `Your total contributions have reached ${annualCap}, which is the maximum allowed for this year. No further lump-sum contributions can be made until the next annual cycle.`,
            },
            limitModal: {
              title: "Your annual contribution limit",
              open: "Open annual contribution limit details",
              description:
                "Your breakdown right now — this reflects the same contribution values shown on this page, including changes in progress.",
              sharedPoolInfo:
                "Monthly contributions and lump sums draw from the same annual pool. They compete for the same 25% cap. A large lump sum will reduce room for future monthly contributions.",
              annualCap: "Annual contribution limit",
              annualVoluntaryCap: "Maximum you can contribute this year",
              totalYtdSharedPool: "Contributed so far this year",
              whatYouCanContributeNow: "What you can contribute right now",
              maxMonthlyContribution: "Max monthly contribution",
              maxMonthlyContributionHint:
                "25% of monthly salary, capped at annual pool",
              maxLumpSumContribution: "Max lump sum (this transaction)",
              maxLumpSumContributionHint:
                "Limited by salary ceiling or annual pool",
              salaryCeiling: "Salary ceiling",
            },
          },
          withdraw: {
            title: "Withdraw",
            subtitle: "Which benefit do you withdraw from?",
          },
          total: {
            overallBalance: "Overall balance",
            totalEarnings: "Total earnings",
            withdrawals: "Withdrawals",
            lastUpdated: "Last updated on ",
          },
          products: {
            title: "My products",
            availableAmount: "Available amount",
            segments: { all: "All", active: "Active", inactive: "Inactive" },
            activeSince: (date) => `Active since ${date}`,
            inactiveSince: (date) => `Inactive since ${date}`,
            noProducts: "No products",
            noActiveProducts: "No active products",
            noInactiveProducts: "No inactive products",
          },
          recentActivity: {
            title: "Recent activity",
            emptyState: "No recent activity",
            viewAll: "View all transactions",
            completed: "Completed on",
          },
          recentTransactions: {
            title: "Recent transactions",
            emptyState: "No recent transactions",
            viewAll: "View all transactions",
            completed: "Completed on",
            withdrawal: "Withdrawal",
          },
          selectedFund: {
            title: "Your selected fund",
            info: ({ days, d }) =>
              `You can switch funds anytime in the next ${days} days (until ${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}).`,
            viewFunds: "View funds",
          },
          withdrawHistory: {
            title: "Withdraw history",
            inProgress: "In progress",
            pastTransactions: "Past transactions",
            empty: "No transaction history",
          },
          funds: {
            disclaimer:
              "If eligible, change sub-fund at any time. Your eligible units will be exchanged for units of your chosen sub-fund within 5 business days.",
            choose: "Choose",
            inProgress:
              "Your fund switch is being executed. You'll be able to request a new switch once this one's finished.",
            cta: "Switch fund",
            switchSuccess: "Your fund switch request has been submitted",
            switchError: "Failed to switch fund. Please try again.",
          },
        },
        nativeDownload: {
          page: {
            welcome: (name) => `Welcome to ${name}`,
            headingMobile: "Download the app",
            headingDesktop: "Scan to download the app",
            description: (name) =>
              `Download the ${name} app today and start taking control of your financial future!`,
            instructions: [
              "Open the camera or QR scanner app on your phone",
              "Point the camera on the QR code",
              "Click on the link that shows up to download the app",
            ],
            altAppStore: "Download on the App Store",
            altPlayStore: "Get it on Google Play",
          },
        },
        notFound: {
          page: {
            heading: "Page not found",
            description: "These are not the pages you're looking for...",
            back: "Go back",
            home: "Return to the home page",
          },
        },
        signIn: {
          page: {
            heading: (name) => `Log in to ${name}`,
            passwordReset: "Forgot your password?",
            mfa: {
              heading: "Verify your identity",
              description:
                "Enter the 6 digit code from your authenticator app.",
              error: "Login failed. Please try again.",
            },
          },
        },
        signUp: {
          page: {
            aboutYou: "About you",
            title: (name) => `Register with ${name}`,
            newPassword: "Your new password",
            personalEmail: "Personal email",
            description:
              "Please provide a personal email that you'll always have access to, even if you change employers.",
            workEmail: "Work email",
            alreadyHaveAnAccount: "Already have an account?",
            repeat: "Repeat new password",
            cta: "Create account",
            terms: {
              left: "By continuing to use this platform, you agree to the",
              center: "terms and conditions",
              right: "and privacy policy",
            },
          },
        },
        disclaimers: {
          page: {
            heading: "Your documents",
            description: {
              text: "These documents involve some of our products such as investing, saving and more. To get a full understanding, read the agreements attached. Please read all of the documents carefully.",
              question: "If you have any questions, please contact us at:",
              contact:
                "Office 402, 14th Floor, Al Sarab Tower, ADGM Square, Al Maryah Island, Abu Dhabi, United Arab Emirates",
              email: "Email: support@aurem.ae",
              phone: "Tel: +971 2 499 6333",
            },
            disclaimers: {
              heading: "Disclaimers",
              noticeDisclaimer: "Disclaimer notice",
              noticePrivacy: "Privacy notice",
            },
            cookiePolicy: "Cookie policy",
            consent: "Agree and proceed",
          },
        },
        onboarding: {
          page: {
            flagDetails: {
              heading: "Flag any incorrect details",
              subheading: "About you",
              description:
                "If anything looks wrong, let us know. We'll confirm your details with your employer",
              ctaDefault: "Everything is correct",
              ctaSubmit: "Submit request to update details",
              labels: {
                flag: "Flag",
                fullName: "Full name",
                salaryFull: "Full salary",
                salaryBasic: "Basic salary",
                iban: "IBAN",
                eid: "Emirates ID",
                phone: "Phone number",
                dob: "Date of birth",
                address: "Address",
                passport: "Passport number",
                update: "Update",
                cancel: "Cancel",
                startDate: "Start date",
              },
              successToast:
                "We have received your request. After your company reviews and approves it, the changes will be reflected in your records.",
            },
            personalDetails: {
              heading: "Personal details",
              subheading: "About you",
              description: "Complete your personal details",
              form: {
                name: {
                  label: "Preferred name",
                  placeholder: "Enter your name",
                  hint: "This could be your first name or a nickname — the name you’d like people to see and refer to in the platform.",
                },
                personalEmail: {
                  label: "Personal email",
                  placeholder: "Enter personal email",
                },
                placeOfBirth: {
                  label: "Place of birth",
                  placeholder: "Enter town or city",
                },
                anotherJuridisdiction: {
                  label: "Are you a tax resident in another jurisdiction?",
                  options: { yes: "Yes", no: "No" },
                  countryOfResidence: "Country of tax residence",
                  taxNumber: "Tax reference number",
                  add: "Add country",
                  remove: "Remove",
                  select: "Select country",
                  empty: "No results found",
                  error: {
                    title: "Error",
                    duplicateCountry: "Duplicate country",
                    missingCountry:
                      "Select a country for each filled tax number.",
                    missingTaxNumber:
                      "Enter a tax number for each selected country.",
                  },
                },
                submit: "Continue",
                back: "Back",
              },
            },
          },
        },
        changePassword: {
          page: {
            heading: "Set a new password",
            email: "Email",
            form: {
              password: { label: "Your new password" },
              confirmPassword: { label: "Repeat new password" },
              submit: "Change password",
            },
          },
        },
        forgottenPassword: {
          page: {
            heading: "Forgot your password?",
            description:
              "Enter your email to receive a link to reset your password.",
            form: {
              email: { label: "Enter your email" },
              submit: "Send link",
              cancel: "Go back",
            },
            success: {
              title: "Check your email",
              description:
                "If an account exists for this email address, you’ll receive an email from us shortly. Once received, click on the link in the email and set your new password. The link is valid for 24 hours.",
            },
          },
        },
        dashboard: {
          page: {
            bannerSwitchFund: {
              title: (fundName) =>
                `Your basic fund is set to ${fundName}. You may change the fund where your contributions will be invested at any time.`,
              description:
                "You can switch your fund before the first contribution is made.",
              cta: "Switch fund",
              dismiss: "Dismiss",
            },
            banner: (companyName) => `You’ve left ${companyName}.`,
            subscriptionStop:
              "Your subscriptions into this fund will stop and you can withdraw your money at any time.",
            withdraw: "Withdraw employer subscriptions",
            contributions: {
              title: "Contributions",
              baseContibution: "Monthly basic subscription",
              tooltipInfo: "These payments are mandatory for your employer.",
              voluntaryContribution: "Monthly voluntary subscription",
              total: "Total subscriptions:",
              fromName: (name) => `From ${name}`,
              fromYou: "From you",
              totalBenefitValue: "Total subscription value",
              thisMonth: "This month",
              cta: {
                add: "Add your voluntary subscription",
                edit: "Update voluntary subscription",
                view: "View transactions",
              },
              pending: {
                title: "Your subscription is pending",
                description: ({ amount, date }) =>
                  `Your documents are currently being reviewed. You last edited this subscription to ${amount} on ${date}`,
              },
            },
            selectedFunds: {
              title: "Selected sub-fund",
              factSheet: "Feature sheet",
              note: "If eligible, change sub-fund at any time. Your eligible units will be exchanged for units of your chosen sub-fund within 5 business days.",
              cta: "Change sub-fund",
            },
            pwaInstall: {
              card: {
                description:
                  "You can download this app and add it to your home screen. It'll only take a few seconds",
                later: "Remind me later",
                showMe: "Show me how",
              },
              ios: [
                {
                  heading: "Click on the Share icon",
                  description:
                    "At the bottom of your screen in your browser's navigation bar, you'll see a Share icon which will bring up a list of options ",
                },
                {
                  heading: "Find 'Add to Home Screen'",
                  description:
                    "Scroll down the list and find 'Add to Home Screen'. You will then be prompted to customise the name of the app.",
                },
              ],
              android: [
                {
                  heading: "Click on the More icon",
                  description:
                    "At the top of your screen in your browser's address bar, you'll see a More icon which will bring up a list of options.",
                },
                {
                  heading: "Find 'Add to Home screen'",
                  description:
                    "Scroll down the list and find 'Add to Home Screen'. You will then be prompted to customise the name of the app.",
                },
              ],
              addToHomescreen: "Add to Home Screen",
            },
            statementHistory: {
              title: "Statement history",
              emptyState: "No statements available",
              downloadButton: "Download",
              statementLabel: (month) => `${month} statement`,
              statementSuffix: "statement",
              issuedOn: (date) => `Issued on ${date}`,
            },
            toast: { employmentNotFound: "Employment not found" },
            feelingLostBanner: { title: "Feeling lost?", cta: "Get help" },
            balance: {
              title: "Total value of your contributions today",
              growth: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })} growth`,
              updatedAt: "Updated",
              vested: "Vested",
              unvested: "Unvested",
              availableNow: "Available now",
              whenYouLeave: "When you leave",
              vestedInfo:
                "The amount available for you to withdraw at any time.",
              unvestedInfo:
                "Unavailable to withdraw: Amount available after your employment ends and once invested",
              pendingInvestment: "Pending investment",
            },
            contribution: {
              title: "Money in this month",
              basic: "Basic subscription",
              voluntary: "Voluntary subscription",
              from: "From ",
              fromYou: "From you",
              monthlyDeposit: "Monthly deposit",
              completedOn: "Completed on",
              onetime: "One-time payment",
            },
            actions: {
              kycWarning:
                "Your verification documents must be approved before you can confirm or edit your voluntary subscription.",
              depositMoney: "Deposit",
              withdrawMoney: "Withdraw",
              switchFunds: "Switch funds",
            },
            manageContributions: "Manage contributions",
            contributionOverview: {
              title: {
                threeMonths: "Money paid in over the last 3 months",
                sixMonths: "Money paid in over the last 6 months",
                oneYear: "Money paid in over the last 12 months",
                yearToDate: "Money paid in since the start of the year",
              },
              ranges: {
                threeMonths: "3M",
                sixMonths: "6M",
                oneYear: "1Y",
                yearToDate: "YTD",
              },
              series: {
                basic: "Basic",
                additional: "Basic Additional",
                voluntary: "Voluntary",
                lumpSum: "Lump sum",
                other: "Other",
              },
              seriesInfo: {
                basic: "The amount your employer contributed on your behalf.",
                additional:
                  "Extra contributions your employer made beyond the required amount.",
                voluntary: "The additional amount you chose to contribute.",
                lumpSum: "One-off amounts you chose to contribute.",
              },
              empty: {
                title: "No contributions yet.",
                description:
                  "Your contributions appear here once the first payment settles.",
              },
            },
            voluntaryCap: {
              title: "Voluntary contribution cap",
              subtitle: (rate) =>
                `YTD usage of your ${rate.toLocaleString(L, { style: "percent", minimumFractionDigits: 0, maximumFractionDigits: 2 })} annual salary limit`,
              cap: (amount) => `${amount} cap`,
              used: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} used`,
              remaining: (amount) => `${amount} remaining`,
              remainingLabel: "Remaining",
              recurring: "Monthly recurring",
              lumpSum: "Lump-sum",
            },
            fundPerformance: {
              title: "Fund performance",
              subtitle: "Net asset value over time",
              ranges: {
                allTime: "All",
                oneMonth: "1M",
                threeMonths: "3M",
                sixMonths: "6M",
                oneYear: "1Y",
                yearToDate: "YTD",
              },
              stats: {
                fundReturn: "Fund return",
                yourReturn: "Your return",
                highLow: "High / Low",
              },
              series: { blended: "All funds" },
              empty: {
                title: "No performance data yet.",
                description:
                  "Fund performance appears once your first contribution is invested.",
              },
              historyNotice: (date) =>
                `Performance history starts in ${date} — earlier data isn't available.`,
            },
            upcomingContribution: {
              title: "Your next contribution",
              hint: "Estimated from your current salary and elections, and confirmed when your employer runs payroll.",
              dueOn: (d) =>
                `on ${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}`,
              rows: {
                basic: "Basic (employer)",
                additional: "Basic Additional (employer)",
                voluntary: "Voluntary (employee)",
                lumpSum: "Lump-sum",
              },
            },
            withdrawalProgress: {
              title: "Withdrawal progress",
              description: "Processing usually takes up to 3 business days.",
              descriptionDisbursed:
                "The funds have been transferred to your account.",
              requestedOn: (d) =>
                `Requested ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
              disbursedOn: (d) =>
                `Disbursed ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
              steps: {
                submitted: "Request submitted",
                processing: "Processing",
                approved: "Approved",
                disbursed: "Funds disbursed",
              },
            },
            kycStatus: {
              title: "KYC status",
              badge: {
                pending: "Pending",
                inReview: "In review",
                actionRequired: "Action required",
                rejected: "Rejected",
                verified: "Verified",
              },
              description: {
                verifying:
                  "We need to verify your identity before this request can complete.",
                verified: "Your identity has been verified.",
                rejected:
                  "We're unable to verify your identity at this time. Contact our support team for assistance.",
                additionalDocuments:
                  "We need additional documents to verify your identity.",
                resubmission:
                  "Ensure your documents are clear, valid, and match your account information.",
              },
              steps: {
                submitted: "Documents submitted for review",
                reviewed: "Documents reviewed",
                verified: "Identity verified",
              },
            },
            switchProgress: {
              title: "Switch progress",
              description:
                "Reallocation usually takes up to 2 business days. Your holdings update once the switch executes.",
              from: "From",
              to: "To",
              buckets: { voluntary: "Voluntary", employer: "Employer-led" },
              steps: {
                submitted: "Request submitted",
                processing: "Processing",
                executed: "Switch executed",
              },
            },
            holdingsBreakdown: {
              title: "Holdings by share class",
              subtitle:
                "Where each part of your balance is invested, with returns by period",
              ranges: {
                allTime: "All",
                oneMonth: "1M",
                threeMonths: "3M",
                sixMonths: "6M",
                oneYear: "1Y",
                yearToDate: "YTD",
              },
              columns: {
                fund: "Share class / fund",
                units: "Units held @ price",
                balance: "Balance",
                return: "Return",
              },
              sections: {
                employer: "Employer-led investment",
                employee: "Employee-led investment",
              },
              buckets: { employer: "Employer-led", employee: "Employee-led" },
              types: {
                accrued: "Accrued EOSB",
                basic: "Basic",
                additional: "Basic Additional",
                voluntary: "Voluntary",
              },
              units: (units) => `${units} units`,
              price: (price) => `@ ${price}`,
              share: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
              shareOfBalance: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} of balance`,
              returnLabel: "return",
              subtotal: "Subtotal",
              empty: {
                title: "No holdings yet.",
                description:
                  "Your holdings appear once your first contribution is invested.",
              },
            },
          },
        },
        contributionsManage: {
          page: {
            pageHeader: "Subscriptions",
            yourPensions: {
              heading: "Your End of Service Benefits Funds",
              totalContributions: "Total subscriptions:",
              cta: {
                add: "Add a voluntary subscription",
                edit: "Manage subscriptions",
              },
            },
            withdrawContribution: {
              title: "Withdraw balance",
              total: "Total balance available:",
              note: "Please note:",
              warning:
                "The amount you receive may differ slightly from your request due to unit pricing fluctuations at the time of processing.",
              cta: { title: "Withdraw subscriptions" },
            },
            pendingWithdrawal: {
              title: "Your withdrawal is currently being processed",
              description:
                "Please note that it can take up to 14 days until your withdrawal is fully processed. You can make another withdrawal when this is complete",
              cta: "View past withdrawals",
            },
            recentTransactions: {
              title: "Recent transactions",
              empty: {
                title: "There are no transactions to show here",
                description:
                  "Your recent subscriptions and withdrawals will display here",
              },
              cta: "See all past transactions",
            },
          },
        },
        contributionsSetupOnboarding: {
          page: {
            heading: "Choose your subscription type",
            voluntary: {
              title: "Voluntary subscription",
              description:
                "Set up a recurring monthly payment. You can edit this amount up to 7 days before your monthly payroll date.",
            },
            oneTime: {
              title: "One-time payment",
              description:
                "Set up a single payment just for this month. You may also add on to your voluntary subscription",
            },
          },
        },
        contributionsSetUp: {
          page: {
            heading: "Confirm voluntary subscription",
            description:
              "You are setting up a monthly voluntary subscription which will be deducted from your salary and invested into a sub-fund of End of Service Benefits Funds available to you and of your choosing.",
            details:
              "By confirming your subscription, you are representing that you have carefully read the Prospectus and the relevant Supplement before deciding to subscribe for units in the relevant sub-fund and are aware of the risks this entails.",
            yourContributions: "Your subscription",
            yourOneTime: "Your one-time-payment",
            salaryPercent: ({ amount, description }) =>
              `${amount} of ${description}`,
            totalContribution: "Total monthly subscription",
            salary: "salary",
            showDetails: "Details",
            segmentedControl: {
              voluntary: "Voluntary subscription",
              oneTime: "One-time payment",
            },
            setYourAmount: "Set your amount",
            toast: { success: "Contribution updated successfully" },
            pending: {
              description:
                "Your contribution change is awaiting your company's approval. Nothing is deducted from your salary until it is approved.",
            },
            oneTime: {
              heading: "Confirm one-time payment",
              description:
                "Set up a single payment just for this month. You may also add on to your voluntary subscription.",
              submit: "Confirm payment",
            },
            yourSalary: {
              heading: "Your salary",
              salaryBeforeContribution: "Salary before voluntary subscription",
              salaryBeforeOnetime: "Salary before one-time payment",
              onetime: "Your one-time payment",
              voluntaryContribution: "Your voluntary subscription",
              netSalary: "Net salary",
              cardPayment: (card) =>
                `to be paid into your account ending ${card}`,
              investmentInfo: ({ invested, max }) =>
                `You have invested ${invested}% out of ${max}% of your annual salary.`,
              investmentInfoCont:
                "Your voluntary subscriptions and one-time payments cannot exceed 25% of your annual salary.",
              toolTip:
                "Your voluntary subscription or one-time payment may be adjusted if you have existing salary deductions. Total deductions cannot exceed 50% of your salary as per legal limits.",
            },
            selectFund: {
              title: "Select sub-fund",
              factSheet: "Feature sheet",
              supplementSheet: "Fund prospectus",
              supplement: "Supplement - ",
              keyInvestorInfo: "Key Investor Information",
              keyInvestor: "Key Investor Information - ",
              note: "If eligible, change sub-fund at any time. Your eligible units will be exchanged for units of your chosen sub-fund within 5 business days.",
            },
            submit: "Confirm voluntary subscription",
            error: { employeeNotAssigned: "Employee not assigned to pension" },
          },
        },
        contributionsVerification: {
          page: {
            heading: "Confirm via email",
            description: (email) => `Enter the code sent to ${email}`,
            resendCode: (count) => `Resend code in ${count}`,
            cta: { submit: "Authenticate", resend: "Resend" },
            toast: {
              error: "Error",
              success: "Success",
              otpFailed: "Failed to send OTP",
              otpSuccess: "OTP sent successfully",
              contributionsFailed: "Failed to update voluntary subscription",
            },
          },
        },
        contributionsPreview: {
          page: {
            heading: "Subscription scheduled",
            description: {
              youCan: "You can",
              edit: "edit your subscription",
              yourContribution: "before the 21st each month",
            },
            yourPensions: {
              heading: "Your End of Service Benefits Funds",
              baseContibution: "Basic subscription",
              voluntaryContribution: "Voluntary subscription",
              total: "Total subscriptions:",
            },
          },
        },
        contributionsWithdraw: {
          page: {
            heading: "Withdraw subscription",
            totalAvailableBalance: "Total balance available",
            totalBalance: "your available balance",
          },
        },
        contributionsConfirmBankDetails: {
          page: {
            heading: "Confirm your bank details",
            description: "We’ll transfer your balance to this bank account",
            edit: "Edit",
            toast: { success: "IBAN updated successfully" },
          },
        },
        kycRequest: {
          page: {
            title: "Let's get you verified",
            description: "We need to do a few checks to make sure it's you",
            documents: {
              identity: {
                title: "Upload an identity document",
                description:
                  "You can upload your passport, ID card, driver’s license or residency card.",
              },
              proofOfAddress: {
                title: "Proof of address",
                description:
                  "The document provided must be dated within the last three months.",
              },
              resubmission: "There was an issue with your previous submission.",
              resubmissionRequired: "Resubmission required",
              resubmittedForReview: "Resubmitted for review",
            },
            banner: {
              resubmissionRequired:
                "The reviewer requested a resubmission of documents",
            },
            tabs: {
              uploadDocuments: "Upload documents",
              activityAndComments: "Activity and comments",
            },
            upload: {
              noFileChosen: "No file chosen",
              chooseFile: "Choose file",
              clickToUpload: "Click to upload",
              orDragAndDrop: "or drag and drop",
              fileRequirements:
                "The file must be a PDF, JPG or DOCS (max. 5MB)",
            },
            submitForReview: "Submit for review",
            cta: "Continue",
            success: {
              title: "Documents uploaded successfully",
              description:
                "Your verification documents have been submitted for review.",
            },
            confirmSubmit: {
              title: "Submit documents for review?",
              description:
                "The reviewer will be notified and you will no longer be able to make changes to your uploads unless prompted by the reviewer.",
              cta: "Submit documents for review",
            },
            uploadRequiredDocuments:
              "Please upload all required documents before submitting for review.",
            noCommentsYet: "No comments yet",
          },
        },
        transactions: {
          table: {
            title: "Transactions",
            columns: {
              status: "Status",
              type: "Type",
              totalAmount: "Total amount",
              dateCompleted: "Date completed",
            },
            filters: {
              all: "All",
              moneyIn: "Money in",
              moneyOut: "Money out",
              export: (count) => `Export (${count}) invoices`,
            },
            status: {
              pending: "Pending",
              processing: "Processing",
              completed: "Completed",
            },
            empty: {
              title: "No transactions found",
              text: "Transaction records will appear here when payments are processed.",
            },
          },
          list: {
            title: "Past transactions",
            contributions: "Subscriptions",
            withdrawals: "Withdrawals",
            states: {
              monthlyBasicSubscription: "Monthly basic subscription",
              monthlyVoluntarySubscription: "Monthly voluntary subscription",
              onetimeVoluntarySubscription: "One-time payment",
              withdrawal: "Withdrawal",
            },
            emptyContributions: {
              title: "There are no contributions to show here",
              description:
                "Your contributions will display here along with their status and details",
            },
            emptyTransactions: {
              title: "There are no transactions to show here",
              description:
                "Your transactions will display here along with their status and details",
            },
            emptyWithdrawals: {
              title: "There are no withdrawals to show here",
              description:
                "Your withdrawals will display here along with their status and details",
            },
            timeline: {
              documentsInReview: {
                title: "Documents in review",
                description:
                  "Once your documents have been approved, it can take up to 14 days until your withdrawal is fully processed",
              },
              paymentProcessing: {
                title: "Payment processing",
                description:
                  "It can take up to 14 days until your withdrawal is fully processed",
              },
            },
          },
        },
        settings: {
          navigation: {
            title: {
              account: "My account",
              language: "Language preferences",
              currency: "Currency preferences",
            },
            accountDetails: "Account details",
            documents: "Documents",
            beneficiaries: "Beneficiaries",
            security: "Security",
            employmentDetails: "Employment details",
            bankDetails: "Bank details",
            taxInformation: "Tax information",
            verification: "Verification",
            overview: "Overview",
          },
          page: {
            accountDetails: {
              lastActive: "Last active",
              from: "From",
              joined: "Joined",
              cta: "Save changes",
              missingEmployee: "Missing employee data",
              validationError: "Please fix validation errors.",
              reported:
                "We have received your request. After your company reviews and approves it, the changes will be reflected in your records.",
              profileSuccess: "Profile updated successfully",
              employeeSuccess: "Employee record updated",
              unknownDevice: "Unknown device",
              unknownCity: "Unknown city",
              unknownCountry: "Unknown country",
              personalDetails: {
                title: "Personal details",
                name: "Name",
                firstName: "First name",
                lastName: "Last name",
                preferredName: "Preferred name",
                gender: "Gender",
                nationalId: "Emirates ID",
                nationality: "Nationality",
                passportNumber: "Passport number",
                iban: "IBAN",
              },
              contact: {
                title: "Contact details",
                personalEmail: "Personal email",
                phoneNumber: "Phone number",
                address: "Address",
              },
              employeeDetails: {
                title: "Employment details",
                save: "Send changes to employer",
                cancel: "Cancel",
                edit: "Edit",
                fullName: "Full name",
                firstName: "First name",
                lastName: "Last name",
                dateOfBirth: "Date of birth",
                phoneNumber: "Phone number",
                address: "Address",
                passportNumber: "Passport number",
                nationalId: "Emirates ID",
                iban: "IBAN",
                startDate: "Start date",
                search: "Search for employer...",
                segment: { active: "Active", inactive: "Inactive" },
                noActiveEmployment: "No active employments.",
                noInactiveEmployment: "No inactive employments.",
                employerDetail: "Employer details",
                myEmployers: "My employers",
                inAccurateFieldReported:
                  "You can't edit this while your changes are under review.",
                attributeInReview: "In review",
                errors: {
                  workEmail: { invalid: "Email is invalid" },
                  fullSalary: {
                    required: "Full salary is required",
                    invalid: "Full salary must be a positive number",
                  },
                  basicSalary: {
                    required: "Basic salary is required",
                    invalid: "Basic salary must be a positive number",
                  },
                  startDate: {
                    required: "Start date is required",
                    invalid: "Start date is invalid",
                  },
                },
              },
            },
            bankDetails: {
              title: "Bank details",
              accountName: "Account name",
              iban: "IBAN",
              swiftCode: "SWIFT code",
              branchName: "Branch name",
              branchAddress: "Branch address",
              cta: "Save changes",
              success: "Bank details updated successfully",
            },
            beneficiaries: {
              heading: "Add a beneficiary",
              headingBeneficiariesAdded: "Some reminders",
              headingShariah: "Verification of beneficiaries",
              description:
                "Designate a family member who can access your funds in case of passing away.",
              descriptionShariah:
                "Under Shariah law, the EoSB amount is distributed to the employee’s legal heirs based on the principles of Islamic inheritance. The legal heirs (such as the spouse, children, and parents) are entitled to the employee’s benefits in specific proportions, determined by Islamic inheritance rules.",
              accordions: {
                first: {
                  title: "Let your beneficiary know",
                  description:
                    "It is the account holder's responsibility to inform their beneficiary(ies) of their designation. The employer will not reach out to beneficiaries at any point.",
                },
                second: {
                  title: "Accessing your funds",
                  description:
                    "A beneficiary can access funds in the unfortunate event of the account holder's demise. They can claim funds that have already vested or are available for withdrawal, but they will not be able to continue investing.",
                },
                third: {
                  title: "Let them know to contact us",
                  description:
                    "In the event of the account holder's demise, the beneficiary must contact the employer to initiate next steps. The necessary documents must be submitted during the claim initiation process.",
                },
              },
              warningOverAllotted:
                "You have allocated more than 100% of your funds to your beneficiaries. Please adjust the percentages.",
              warningUnderAllotted:
                "You have allocated less than 100% of your funds to your beneficiaries.",
              form: {
                firstName: "First name",
                lastName: "Last name",
                relation: "Relationship to you",
                dateOfBirth: "Date of birth",
                mobileNumber: "Phone number",
                email: "Personal email",
                passportNumber: "Passport no.",
                percentAllotted: "Percentage of funds allocated",
                new: "Add beneficiary details",
                remove: "Remove beneficiary",
                removeDescription: (name) =>
                  `Are you sure you want to remove ${name} as a beneficiary? You can't undo this action.`,
                relationship: {
                  Spouse: "Spouse",
                  Child: "Child",
                  Parent: "Parent",
                  Sibling: "Sibling",
                  Other: "Other",
                },
                errors: {
                  firstName: { required: "First name is required" },
                  lastName: { required: "Last name is required" },
                  relation: { required: "Relationship is required" },
                  dateOfBirth: {
                    required: "Date of birth is required",
                    future: "Date of birth must be in the past",
                  },
                  mobileNumber: { required: "Phone number is required" },
                  email: { format: "Email is invalid" },
                  percentAllotted: {
                    required: "Percentage of funds allocated is required",
                    invalidRange: "Allocation must be between 1% and 100%",
                    totalExceeded: (value) =>
                      `Total percentage of funds allocated cannot exceed 100% (${value}% available)`,
                  },
                },
              },
              add: "Add a beneficiary",
              localWarning:
                "Be aware that the country you live in might have rules that supersede this decision based by fund admin.",
              shariah: {
                compliance: "I am complying with Shariah Law",
                nonCompliance: "I am nominating a beneficiary",
              },
              removedBeneficiarySuccess: "Beneficiary removed successfully",
            },
            security: {
              password: {
                minLength: "Must be at least 8 characters",
                required: "Password is required",
                match: "Your passwords do not match",
                weak: "This password is too weak. Add more complexity to make it a stronger password",
                currentPassword: "Your current password",
                newPassword: "Your new password",
                confirmPassword: "Repeat new password",
                changePassword: "Change password",
                success: "Password changed successfully",
                lastUpdated: "Last updated",
              },
              mfa: {
                heading: "Enable multi-factor authentication",
                headingDescription:
                  "Keep your account secure by using a security code in addition to your password while logging in. You will need to set up an authenticator app.",
                codeRequest: {
                  description:
                    "Scan the QR code and enter the six digit code shown in your authenticator app.",
                  heading: "Set up multi-factor authentication",
                },
                codeRequestForDisable: {
                  description:
                    "Enter the code from your authenticator app to turn off multi-factor authentication.",
                  heading: "Turn off multi-factor authentication",
                },
                passwordRequest: {
                  description:
                    "Enter your password to set up multi-factor authentication.",
                  enterPassword: "Enter password",
                  error: "Password is incorrect",
                  heading: "Set up multi-factor authentication",
                  password: "Password",
                },
                successDisable:
                  "Multi-factor authentication turned off successfully",
                successEnable:
                  "Multi-factor authentication setup completed successfully",
                invalidCode: "Invalid authentication code. Please try again.",
              },
            },
          },
        },
        withdrawals: {
          page: {
            title: "Withdrawals",
            balanceAvailable: "Balance available to withdraw",
            withdrawalHistory: "Withdrawal history",
            withdrawalInProgress: "1 withdrawal in progress",
            inProgress: "In progress",
            pastWithdrawals: "Past withdrawals",
            withdrawFrom: "Withdraw from",
            withdrawTo: "Withdraw to",
            yourSubscriptions: "Your subscriptions",
            updateBankDetails: "Update bank details",
            withdrawFunds: "Withdraw funds",
            fullWithdrawal: "Full withdrawal",
            viewHistory: "View history",
            withdrawalInProgressBtn: "Withdrawal in progress",
            timeline: {
              initiatedWithdrawal: "Initiated withdrawal of",
              payoutInProgress: "Payout in progress",
              payoutInProgressDesc:
                "You will be notified of the payment transfer being made.",
              paymentProcessed: "Payment processed",
              paymentProcessedDesc:
                "Your money should be seen in your account.",
            },
            alert: {
              marketFluctuations:
                "Please note that the amount you receive may differ slightly from your request due to market fluctuations at the time of processing.",
              fundSwitchInProgress:
                "A fund switch is currently in progress. You cannot submit a withdrawal request until the fund switch has been completed.",
            },
            tooltip: {
              title:
                "Your available balance consists of only voluntary subscriptions.",
              description:
                "Active employees cannot withdraw employer subscriptions.",
            },
            toast: {
              withdrawalSuccess: "Successfully requested your withdrawal",
              withdrawalError: "Failed to process your withdrawal",
              ibanSuccess: "Successfully updated your IBAN",
              ibanError: "Failed to update your IBAN",
            },
            emptyState: {
              title: "No withdrawals found",
              description:
                "Your withdrawals will display here along with their status and details",
            },
            validation: {
              exceedsBalance: (balance) =>
                `Amount exceeds the available balance of ${balance}`,
              ibanRequired: "IBAN is required to make a withdrawal",
            },
            iban: "IBAN",
            kycNote:
              "Your verification documents must be approved before you can make a withdrawal.",
            ibanHint: "A UAE IBAN is 23 digits long and should start with AE.",
            editIban: "Edit IBAN",
            postTermination: {
              youHaveLeft: "You've left",
              theCompany: "the company",
              stopSubscriptions: "Your subscriptions into this fund will stop.",
              withdrawSubscriptions:
                "You can now withdraw your employer subscriptions.",
              withdrawSubscriptionsCta: "Withdraw employer subscriptions",
              withdrawVoluntarySubscriptions: (date) =>
                `You can not withdraw your voluntary subscriptions now. They will be available to withdraw after ${date}.`,
              employerSubscriptions: "Employer subscriptions",
              description: (date) =>
                `On ${date}, basic subscriptions from your employer will be transferred to your voluntary subscriptions. Alternatively, you may withdraw all basic subscriptions now.`,
            },
          },
        },
        citizenshipConfirmation: {
          button: "Confirm citizenship",
          modal: {
            title: "Confirm your citizenship",
            placeholder: "Choose your citizenship...",
            checkbox: (citizenships) =>
              `The employee understands, acknowledges and agrees that (i) the End-of-Service Savings Fund is not available to employees with certain citizenships (${citizenships}), and (ii) they must immediately notify the plan administrator if they discover that they are, or have become, a blocked citizen.`,
            acknowledge:
              "Acknowledging this disclaimer is required to access the benefit. Otherwise, your basic funds will be returned to your company and you'll be excluded from the scheme.",
          },
          toast: {
            success: {
              title: "Citizenship confirmed",
              text: "Your citizenship has been successfully confirmed.",
            },
            error: { title: "Error", text: "Invalid citizenship selected" },
          },
        },
        subFunds: {
          page: {
            title: "Choose your sub-fund",
            description:
              "If eligible, change sub-fund at any time. Your eligible units will be exchanged for units of your chosen sub-fund within 5 business days.",
            cta: "Confirm sub-fund",
          },
        },
        statements: {
          page: {
            title: "Statements",
            emptyTitle: "No statements",
            emptyDescription: "Your statements will appear here",
            loadError: "Couldn't load your statements. Please try again.",
            loadErrorDescription:
              "Something went wrong while loading your statements.",
          },
        },
      },
      reauthentication: {
        mfa: {
          heading: "Verify your identity",
          description: "Enter the 6 digit code from your authenticator app.",
        },
        password: {
          heading: "Confirm your password",
          description: "Please enter your password to perform this action.",
          passwordLabel: "Password",
          passwordPlaceholder: "Enter password",
          error: "Password is invalid",
        },
      },
      emailOtp: {
        title: "Enter verification code",
        description:
          "Enter the 6-digit verification code sent to your verified email address. This step confirms your identity and allows us to complete the request.",
        codeValidity:
          "This code is valid for 5 minutes. If you requested a new code, please enter the most recent one.",
        resendCode: "Resend code",
        resendCodePeriod: (period) => `Resend code in ${period}`,
        error:
          "The verification code you entered is invalid. Please try again.",
      },
      validation: {
        passwordPolicy: {
          list: {
            intro: "Password must include:",
            capitalLetter: "an uppercase letter",
            lowercaseLetter: "a lowercase letter",
            number: "a number",
            specialCharacter: "a special character",
            minimumLength: (min) => `at least ${min} characters`,
          },
        },
        email: {
          required: "Email is required",
          format: "Must be a valid email address",
        },
        password: {
          required: "Password is required",
          weakPassword: "Password is too weak",
          passwordNotMatch: "Passwords do not match",
          minLength: "Must be at least 8 characters",
        },
        iban: {
          required: "IBAN is required",
          format: "Must be a valid IBAN",
          countryUAE: "Must be a number for a UAE account",
        },
        tinUS: {
          required: "Tax number is required",
          length: "TIN must have 9 digits",
          format: "TIN must start with the digit '9'",
        },
        phone: {
          required: "Phone number is required",
          format:
            "Phone number must start with a country code and be at least 8 digits long",
        },
        required: "Required",
      },
      taxInformation: {
        submissionError: "Unable to submit: No employment data found",
        formSubmitted: "Tax information form submitted successfully",
        formResubmitInfo:
          "Your tax information form has been submitted. Fill the form again to update your information.",
        authRequired: "Authentication required",
        authRequiredDescription:
          "Please log in to access your tax information.",
        refreshPage: "Refresh Page",
        errorLoadingForm: "Error Loading Form",
        formLoadingError: "The tax form template could not be loaded.",
        formTemplateNotFound: "Form Template Not Found",
        formTemplateNotFoundDescription:
          "The tax form template does not exist.",
      },
    },
  },
  components: {
    fundSelector: { highRiskLabel: "High Risk" },
    formBuilder: {
      sidebar: { questions: "Questions", layout: "Layout" },
      fieldTypes: {
        shortAnswer: "Short answer",
        longAnswer: "Long answer",
        yesNo: "Yes/No",
        number: "Number",
        currency: "Currency",
        dropdown: "Dropdown",
        checkboxes: "Checkboxes",
        radios: "Radios",
        date: "Date",
        schedule: "Schedule",
        fund: "Fund",
        salaryContribution: "Salary contribution",
        country: "Country",
        title: "Title",
        paragraph: "Paragraph",
        divider: "Divider",
      },
      wizard: {
        cancel: "Cancel",
        addToForm: "Add to form",
        preview: "Preview",
      },
      properties: {
        title: "Properties",
        required: "Required",
        requiredHint: "Is this question mandatory or not?",
        label: "Label",
        labelHint: "The question users will see above the input field.",
        placeholderText: "Placeholder text",
        placeholderTextHint: "Example text inside the input field.",
        descriptionText: "Description text",
        descriptionTextHint: "Add helpful details for your question.",
        contentText: "Content text",
        contentTextHint: "The text that will be shown to your users.",
        defaultLabel: "Default label",
      },
      options: {
        title: "Options",
        option: "Option",
        addOption: "Add an option",
      },
      validation: {
        title: "Validation",
        requiredMessageText: "Required message",
        requiredMessageTextHint:
          "Message to show when the field is required but empty.",
        validator: "Validator",
        validatorHint: "Select a validation rule for this field",
        selectValidator: "Select validator",
        validators: {
          email: "Email address",
          emiratesId: "Emirates ID (784-YYYY-XXXXXXX-X)",
          phoneNumber: "Phone number (international or local)",
          url: "Website URL",
          dateOfBirth: "Date of birth (cannot be future)",
          futureDate: "Future date only",
          number: "Number validation",
          positiveInteger: "Positive whole number",
        },
        minMaxValidation: "Range validation",
        numberValidationMin: "Minimum value",
        numberValidationMinPlaceholder: "Enter minimum value (optional)",
        numberValidationMax: "Maximum value",
        numberValidationMaxPlaceholder: "Enter maximum value (optional)",
      },
      condition: {
        title: "Show this field conditionally",
        hint: "Only show this field when another field meets certain criteria",
        when: "When",
        equals: "equals",
        notEquals: "not equals",
        includes: "includes",
        notIncludes: "not includes",
        selectField: "Select field",
        selectOption: "Select option",
      },
      schedule: {
        title: "Frequency options",
        allowedFrequencies: "Allowed frequencies",
        allowedFrequenciesHint:
          "Choose which frequencies users can pick from. Select at least one.",
        defaultFrequency: "Default frequency",
      },
      salaryContribution: {
        title: "Salary contribution",
        type: "Contribution type",
        typeRecurring: "Recurring",
        typeLumpSum: "Lump sum",
        attributeName: "Salary attribute binding",
        attributeNamePlaceholder: "Select salary attribute",
        contributionRange: "Contribution range (% of salary)",
        contributionRangeHintRecurring:
          "Define the minimum and maximum monthly contribution as a percentage of salary. Values will be rounded to the nearest whole number.",
        contributionRangeHintOneTime:
          "Define the minimum and maximum annual contribution as a percentage of annualized salary. Values will be rounded to the nearest whole number.",
        minPercent: "Minimum percentage",
        maxPercent: "Maximum percentage",
      },
      actions: { delete: "Delete", moveUp: "Move up", moveDown: "Move down" },
    },
    queryToolbar: {
      search: "Search...",
      filters: "Filters",
      reset: "Reset",
      cancel: "Cancel",
      apply: "Apply",
      ariaQueryToolbar: "Query toolbar",
      ariaSearchAndFilters: "Search and filters",
      ariaActions: "Actions",
      ariaFilters: "Filters",
      loadingControls: "Loading controls",
    },
    languageCurrencyPicker: {
      chooseDefaultLanguage: "Choose default language",
      chooseDefaultCurrency: "Choose default currency",
      language: {
        label: "Language",
        en: "English",
        enDescription: "United States",
        ar: "Arabic",
        arDescription: "العربية",
      },
      currency: {
        label: "Currency",
        aed: "Emirati dirham",
        usd: "United States Dollar",
        gbp: "Pound sterling",
        eur: "Euro",
      },
    },
    controls: {
      custom: {
        emiratesId: {
          label: "Emirates ID",
          invalidLength: "Emirates ID must be 15 digits",
          invalidPrefix: "Emirates ID must begin with 784",
          invalidYear: "Year segment is out of range",
        },
        genders: { label: "Gender", male: "Male", female: "Female" },
        dateOfBirth: { label: "Date of birth" },
        nationality: { label: "Nationality" },
        country: { label: "Country" },
      },
    },
    readOnlyField: { noProvided: "Not provided" },
    nestedCard: {
      expand: "Expand card content",
      collapse: "Collapse card content",
      cancel: "Cancel",
      edit: "Edit",
    },
    scheduleControl: {
      title: "Schedule configuration",
      description: "Set up a recurring schedule for your task",
      frequency: "Frequency",
      frequencyOptions: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
      },
      placeholder: {
        day: "Select time (e.g., 09:00 AM)",
        week: "Select day (e.g., Monday)",
        month: "Select date (e.g., 1st of month)",
        year: "Select date (e.g., Jan 15)",
      },
      weekday: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
      dayOfWeek: "Day of week",
      dayOfMonth: "Day of month",
      yearlyDate: "Annual date",
      time: "Time",
      hour: "Hour",
      minute: "Minute",
      schedulePreview: "Schedule preview",
      technicalDetails: "Technical details",
      cronExpression: "Cron expression",
      cronPattern: "Cron pattern",
      descriptions: {
        daily: (time) => `Every day at ${time}`,
        weekly: ({ dayName, time }) => `Every ${dayName} at ${time}`,
        monthly: ({ dayNumber, time }) =>
          `Every ${dayNumber} of the month at ${time}`,
        yearly: ({ date, time }) => `Every year on ${date} at ${time}`,
        yearlyNoDate: "Please select an annual date",
      },
      defaultScheduleConfig: {
        cronPattern: "0 9 * * *",
        description: "Every day at 09:00",
        frequency: "daily",
        settings: { frequency: "daily", hour: "09", minute: "00" },
      },
    },
    fundControl: {
      preview: "Preview",
      configure: "Configure",
      choosesFund: "Choose fund",
      searchPlaceholder: "Search funds...",
      noFundsFound: "No funds found",
      availableFunds: (count) =>
        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `No funds available`, ["one"]: `1 available fund` })[P.select(count)] ?? `${count} available funds`}`,
      documentsCount: (count) =>
        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `No documents`, ["one"]: `${count} document` })[P.select(count)] ?? `${count} documents`}`,
      defaultFunds: {
        conservativeGrowth: {
          label: { en: "Conservative Growth Fund", ar: "صندوق النمو المحافظ" },
          description: {
            en: "Low-risk investment option with steady returns",
            ar: "خيار استثمار منخفض المخاطر مع عوائد مستقرة",
          },
          riskLabel: { en: "Low", ar: "منخفض" },
        },
      },
      fundListView: {
        sectionTitle: "Section title",
        sectionDescription: "Name this section e.g. “Choose funds”",
        english: "English",
        arabic: "Arabic",
        filesUploaded: (count) =>
          `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `No files uploaded`, ["one"]: `${count} file uploaded` })[P.select(count)] ?? `${count} files uploaded`}`,
        addFund: "Add fund",
      },
      fundEditForm: {
        color: {
          default: "Default",
          success: "Green",
          warning: "Yellow",
          danger: "Red",
          primary: "Blue",
          neutral: "Gray",
        },
        fundName: "Fund name",
        fundNameDescription:
          "The question users will see above the input field.",
        english: "English",
        arabic: "Arabic",
        description: "Description text",
        descriptionDescription:
          "The question users will see above the input field.",
        riskCategory: "Risk category",
        riskCategoryDescription: "Assign a risk level to this fund.",
        riskLevel: "Risk level",
        riskLevelDescription: "e.g. “Low”, “Medium”, “High”",
        riskColor: "Risk color",
        riskColorDescription:
          "Assign a colour to the badge. e.g. “High” can be red.",
        documents: "Upload documents",
        documentsDescription: "Upload multiple documents for this fund.",
        uploadFile: "Upload a file",
        uploadFileDescription: "The file must be a PDF, JPG or DOCS (max. 5mb)",
        uploading: "Uploading documents...",
        uploadSuccess: "Documents uploaded successfully",
        uploadError: "Failed to upload documents",
        uploadNotAvailable: "Upload functionality is not available",
      },
    },
    contributionControl: {
      currencySymbol: "AED",
      max: "Max",
      percentOfSalary: "of your salary",
      percentOfBalance: "of your balance",
      maxExceeded: (maxPercent) =>
        `The amount entered exceeds the allowed limit. The maximum contribution is ${maxPercent.toLocaleString(L, { style: "percent" })}.`,
    },
    transferList: {
      availableItems: "Available",
      selectedItems: "Selected",
      searchPlaceholder: "Search...",
      noItemsAvailable: "No items available",
      noItemsSelected: "No items selected",
      loading: "Loading...",
      moveAll: (count) => `Move all (${count})`,
      clearAll: "Clear all",
    },
    datePicker: { placeholder: "Pick a date" },
    multipleFileUpload: {
      noFilesChosen: "No files chosen",
      chooseFiles: "Choose files",
      orDragAndDrop: "or drag and drop",
      fileTooLarge: ({ count, size }) =>
        `${{ [1]: `File exceeds` }[count] ?? `${count} files exceed`} the ${size}MB size limit`,
      invalidFileType: (count) =>
        `${{ [1]: `File has` }[count] ?? `${count} files have`} an unsupported type`,
      tooManyFiles: (max) =>
        `You can upload up to ${{ [1]: `1 file` }[max] ?? `${max} files`} at a time`,
    },
    collapsibleSection: {
      expand: "Expand section",
      collapse: "Collapse section",
    },
    collapsibleCard: { expand: "Expand", collapse: "Collapse" },
    innerSidebar: { expand: "Expand sidebar", collapse: "Collapse sidebar" },
    dataEditor: {
      modal: { importTitle: "Import data", editTitle: "Edit data" },
      dataSources: {
        title: "Data sources",
        addDataSource: "Add data source",
        importData: "Import data",
        existingData: "Existing data",
        show: "Show",
        hide: "Hide",
        remove: "Remove",
        addRow: "New row",
        manuallyAdded: "Manually added",
        confirmRemove: {
          title: "Remove data source",
          text: "Are you sure you want to remove this data source? This action cannot be undone.",
          action: "Remove",
        },
      },
      filters: {
        title: "Filter table",
        rowsWithErrors: "Rows with errors",
        newRows: "New rows",
        rowsWithEmptyCells: "Rows with empty cells",
        editedRows: "Edited rows",
        changedRows: "Changed rows",
        searchMode: "Search mode",
        search: "Search",
        findAndReplace: "Find and replace",
        replace: "Replace",
        replaceAll: "Replace all",
        previousOccurrence: "Previous occurrence",
        nextOccurrence: "Next occurrence",
        matchCase: "Match case",
        matchEntireCell: "Match exact cell value",
        zeroResults: "0 results",
        rows: "Rows",
        columns: "Columns",
        allColumns: "All columns",
        searchInColumns: "Search in columns",
        allValues: "All values",
        min: "Min",
        max: "Max",
        from: "From",
        to: "To",
      },
      grid: {
        loading: "Loading...",
        emptyTitle: "No data to show",
        emptyText: "Import data or change filters to see the data",
        emptyCell: "Empty",
        contextMenu: {
          cut: "Cut",
          cutCells: (count) => `Cut (${count} cells)`,
          copy: "Copy",
          copyCells: (count) => `Copy (${count} cells)`,
          paste: "Paste",
          deleteRow: "Delete row",
          deleteRows: (count) => `Delete ${count} rows`,
          sortAsc: "Sort ascending",
          sortDesc: "Sort descending",
          sortRemove: "Remove sorting",
        },
      },
      footer: {
        cancel: "Cancel",
        back: "Back",
        next: "Next",
        import: "Import",
        submit: "Submit",
        export: "Export",
        exportAll: "Export all",
        exportFiltered: "Export filtered",
        csvFormat: "Comma-separated values (.csv)",
        excelFormat: "Microsoft Excel (.xlsx)",
      },
      uploader: {
        steps: {
          selectFiles: "Select files",
          mapColumns: "Map columns",
          primaryKey: "Primary key",
        },
        uploadFile: {
          title: "Upload file",
          text: "Select a CSV or XLSX file you would like to import employees from.",
          clickToUpload: "Click to upload",
          orDragAndDrop: "or drag and drop",
          formats: "CSV or XLSX",
          parseError: "Failed to parse the uploaded file",
        },
        primaryKey: {
          title: "Set primary key",
          text: "Select the column that uniquely identifies each record in your data. This helps us identify which records from your uploaded file already exist.",
          footer: (field) =>
            `Rows with an ${field} that already exists will be updated with the values in the imported file. Rows without a matching ${field} from existing records will be detected as new data.`,
        },
        matchColumns: {
          title: "Match columns",
          text: "Match the columns from your uploaded file to existing columns. This helps ensure we import your data to the right places.",
          banner: "Data from any unmatched columns will not be imported.",
          importedColumns: "Imported columns",
          existingColumns: "Existing columns",
          selectColumnPlaceholder: "Select column",
          unmatchedCount: (count) => `${count} unmatched`,
        },
      },
      undoRedo: { undo: "Undo", redo: "Redo" },
      validation: {
        required: "This field is required",
        invalidNumber: "Must be a valid number",
        invalidPositiveInteger: "Must be a positive whole number",
        invalidEmail: "Invalid email format",
        invalidDate: "Invalid date format",
        endDateBeforeStart: "End date must be after start date",
        invalidEmiratesId: "Invalid Emirates ID",
        invalidPhoneNumber: "Invalid phone number",
        invalidUrl: "Invalid URL",
        dateOfBirthInvalid: "Date of birth must be in the past",
        dateMustBeFuture: "Date must be in the future",
        invalidOption: "Invalid value",
      },
      confirmClose: {
        title: "Are you sure you want to close the editor?",
        text: "Once you close the editor, all changes you've made will be discarded and you will not be able to undo this action.",
        action: "Confirm and close",
      },
      confirmSubmit: {
        title: "Are you sure you want to update the data?",
        text: "The following changes will be made to your existing data:",
        createRows: (count) =>
          `${{ [1]: `Create 1 row` }[count] ?? `Create ${count} rows`}`,
        updateRows: (count) =>
          `${{ [1]: `Update 1 row` }[count] ?? `Update ${count} rows`}`,
        deleteRows: (count) =>
          `${{ [1]: `1 row will be deleted` }[count] ?? `${count} rows will be deleted`}`,
        action: "Confirm and update",
        bannerTitle: (count) =>
          `${{ [1]: `There is 1 row with errors` }[count] ?? `There are ${count} rows with errors`}`,
      },
      errorState: {
        title: "Something went wrong",
        text: "An unexpected error occurred in the data editor. Please try again.",
      },
    },
    productCard: { moreActions: "More actions" },
  },
  validation: {
    fieldIsRequired: "Field is required",
    invalidPhoneNumber:
      "Invalid phone number format. Please enter a local or international number.",
    invalidEmailAddress: "Invalid email address",
    invalidIban: "Invalid IBAN",
    invalidEmail: "Invalid email format",
    invalidEmiratesId:
      "Invalid Emirates ID format (expected: 784XXXXXXXXXXXX - 15 digits)",
    invalidUrl:
      "Invalid URL format. Please enter a valid URL (e.g., https://example.com)",
    dateCannotBeFuture: "Date cannot be in the future",
    dateMustBeFuture: "Date must be in the future",
    invalidNumber: "Must be a valid number",
    invalidPositiveInteger: "Must be a positive whole number",
    numberTooSmall: "Number is too small",
    numberTooLarge: "Number is too large",
    invalidDate: "Invalid date format",
    maxLength: (max) => `Must be ${max} characters or less`,
    dateOfBirthMinAge: "Date of birth must be at least 15 years ago",
  },
};
